//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



/** Absences for a single Worker. */
export interface WorkerAbsences {
    /** Account ID for the worker whose absences are recorded. */
    workerId?: string | null;
    /** The employment relation id for the worker whose absences are recorded. */
    employmentId: string;
    /** Collection of absence periods. */
    periods?: AbsencePeriod[] | null;
    /** Basic information for the Worker. 
Automatically updated upon save based on WorkerId.
Mainly for the listings etc. */
    workerSnapshot?: Avatar | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Period of absence */
export interface AbsencePeriod {
    /** Identifies a single leave. */
    id?: string | null;
    /** Period for the absance. */
    period?: DateRange | null;
    /** Cause / type of the absence */
    causeCode?: AbsenceCauseCode | null;
    /** If true, the absence is paid by the employer. */
    isPaid?: boolean | null;
    /** If true, annual leaves are accrued from the absence. If false, these days are deducted from the accrual.
By default, you may leave this null and it always follows the IsPaid. */
    isHolidayAccrual?: boolean | null;
    /** Amount of salary that is paid for the absense.
Currently not in use: Would be used in Incomes Register integration. */
    amount?: number | null;
    /** Additional information as recorded by the Employer. */
    notes?: string | null;
    /** Identifier in the source system is a key defined by a source system / partner system.
This is a pass-through string that is passed to the result calculations. */
    sourceId?: string | null;
    /** Number of Bonus days to be paid. */
    bonusDaysCount?: number | null;
}

/** Defines an avatar for an account, profile etc. - mainly the image that should be shown, names and short description */
export interface Avatar {
    /** Entity type: person/company */
    entityType?: LegalEntityType | null;
    /** First name or company name */
    firstName?: string | null;
    /** Last name, for companies, this should be null */
    lastName?: string | null;
    /** Display name. For a person this is 'FirstName LastName' (auto-created). */
    displayName?: string | null;
    /** Sortable name for ordered lists etc. For a person this is 'LastName, FirstName' (auto-created).
Depending on the data storage, this may be all-lowercase for easier sorting and search. */
    sortableName?: string | null;
    /** Type of the Avatar picture. */
    pictureType?: AvatarPictureType | null;
    /** Color - currently only used by type Icon */
    color?: string | null;
    /** Initials - currently only used by type Icon */
    initials?: string | null;
    /** URL of the picture if specified as picture (null in a case of type Icon) */
    url?: string | null;
    /** Short description of the user. 
This may be overriden by a context specific value by the business logic. */
    description?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Describes the range of dates from start to end and the number of days in between. */
export interface DateRange {
    /** Start date of the period */
    start?: string | null;
    /** End date of the period. */
    end?: string | null;
    /** Number of days in the range.
Depending of the context, this may be mathematical (end - start) or 
explicitly specified (typically working days).
Typically an integer, and calculations and UI's may choose to round it. */
    daysCount?: number | null;
    /** The collection of days contained in the DateRange if specified by the user.
Alternative to DaysCount. If set, should also set DaysCount for backward compatibility. */
    days?: string[] | null;
}

export interface PageResultOfApiListItem {
    items?: ApiListItem[] | null;
    nextPageLink?: string | null;
    count?: number | null;
}

/** The line item class for search and listing results. Use this class for building user interfaces. */
export interface ApiListItem {
    /** The payload type of the item. */
    type?: ApiListItemType | null;
    /** List item type of the item if the item supports a custom OData interface. */
    listType?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Person GUID for the owner of the object. */
    ownerId?: string | null;
    /** Metadata for the owner */
    ownerInfo?: AccountInIndex | null;
    /** The main status depending on the type of the object. */
    status?: string | null;
    /** The back office status depending on the type of the object. */
    backOfficeStatus?: string | null;
    /** When the event started. Typically, this is the CreatedAt date, but it may be something else. */
    startAt?: string | null;
    /** This is the end date of the event.
Typically, it is the UserUpdatedAt date, but it may be something else - e.g PaidAt for the calculation. */
    endAt?: string | null;
    /** Gross salary if that is relevant to the transaction. */
    grossSalary?: number | null;
    /** This is the payment from the Owner point-of-view:
Total payment for the Employer and Net salary for the Worker in the case of a calculation.
Only add here the payment, if the payment is really made. */
    payment?: number | null;
    /** Estimated fee of the transaction to Palkkaus.fi. */
    fee?: number | null;
    /** The GUID for the other party. Currently, this is always the PersonID. */
    otherId?: string | null;
    /** The other party (usually a Person) that is involved in the event (e.g Worker if this is a Salary payment by Employer). */
    otherPartyInfo?: AccountInIndex | null;
    /** A very short description describing the object as an event. E.g. "Paid salary" */
    shortText?: string | null;
    /** Business object ids related to this object. E.g. calculations and payrolls in the payment. */
    businessObjects?: string[] | null;
    /** This is valid for calculations only. The estimated date of salary in worker. */
    salaryDate?: string | null;
    /** Business data to include further information of the object. */
    data?: { [key: string]: any; } | null;
    /** Version number. May be used in conflicts */
    versionNumber?: number | null;
    /** Salaxy uri of the resource. */
    uri?: string | null;
    /** Workflow flags for the object.
Only workflow events with API supported message types are listed. */
    flags?: string[] | null;
    /** Workflow messages for the object.
Only workflow events with API supported message types are listed.
Shown in format "[MessageType]:[Message] ([User] at [UTC-time])" */
    messages?: string[] | null;
    /** Sub category for the payload. E.g. Payment Category, MoneyTransfer Source. */
    entityType?: string | null;
    /** The date for the actual period for which this object is done. */
    logicalDate?: string | null;
    /** Reference information. E.g. Payment or MoneyTransfer reference number. */
    reference?: string | null;
    /** External id for the object in 3rd party system. */
    externalId?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Object that represents a Salaxy account. */
export interface AccountInIndex {
    /** Avatar for the account */
    avatar?: Avatar | null;
    /** Official id of the person or company. */
    officialId?: string | null;
    /** Email address. */
    email?: string | null;
    /** Telephone number. */
    telephone?: string | null;
    /** Bank account number (IBAN) */
    ibanNumber?: string | null;
}

/** An account for a Person - can be both Employer and Worker */
export interface PersonAccount {
    /** Information about the verification of the account. 
NOTE that this object may not be present in many method calls - this is because it contains confidential information. */
    identity?: Identity | null;
    /** Type of the last login - the user role */
    lastLoginAs?: WebSiteUserRole | null;
    /** Contact verification pin for securing contact address changes. */
    contactVerificationPin?: string | null;
    /** Entity type of the account.
Type PersonCreatedByEmployer means that the Worker has not yet signed into the system and there may be multiple instances of the same logical person (Official ID) - one for each employer. */
    entityType?: LegalEntityType | null;
    /** If true the object Account is and Employer account - it has the EmployerInfo object */
    isEmployer?: boolean | null;
    /** If true the object Account is and Worker account - it has the WorkerInfo object */
    isWorker?: boolean | null;
    /** If true, the account has been verified. Typically this means a digitally signed contract.
This means that the account also has an Identity object.
However, as the Identity object contains confidential information, it is not necessarily present in all method calls. */
    isVerified?: boolean | null;
    /** Avatar is the visual representation of the Account. */
    avatar?: Avatar | null;
    /** Contact information for the Account. */
    contact?: Contact | null;
    /** Language of the person/company. */
    language?: Language | null;
    /** Service model for the account. */
    serviceModelId?: string | null;
    /** Workflow data, which is exposed to API. */
    workflowData?: WorkflowData | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Identity is the official identity of an actor. This part is not freely editable as changing it requires signature or some other means. Identity is also often fetched from external sources such as govenment registries. */
export interface Identity {
    /** This is an official identifier of the actor:
Finnish HETU (Soc. sec. number) for a Person or Y-tunnus (Company ID for a company or association) */
    officialId?: string | null;
    /** This is an official name of the actor.
It originates from the YTJ or Bank authentication. */
    officialName?: string | null;
    /** First name OR company name */
    firstName?: string | null;
    /** Last name
Available only to real persons (as opposed to companies). */
    lastName?: string | null;
    /** The latest authorization contract that is the bases for this Identity */
    contract?: AuthorizationContract | null;
    /** Tha bank account number of the Worker - in Iban format. */
    ibanNumber?: string | null;
    /** Indicates whether the principal user of the customer is a politically exposed person or not. */
    isPep?: boolean | null;
    /** Mainly for company accounts, but in special cases for Persons,
this is the main Contact party and usually the signer for the account. */
    primaryContact?: ContractParty | null;
    /** List of roles which this account is member of. */
    roles?: Role[] | null;
    /** Latest contact, bank account or name update. */
    identityUpdatedAt?: string | null;
    /** Latest KYC update, if done. */
    kycUpdatedAt?: string | null;
}

/** Common contact information object for Person, Company, Location etc. */
export interface Contact {
    /** Contact e-mail address. Always lower invariant, trimmed and empty string set to null. */
    email?: string | null;
    /** Telephone number */
    telephone?: string | null;
    /** Street address */
    street?: string | null;
    /** Postal code */
    postalCode?: string | null;
    /** City or community (postitoimipaikka) */
    city?: string | null;
    /** This is the ISO code for country.
Currently, it should always be "fi". */
    countryCode?: string | null;
}

/** Defines the data that IWorkflowItem must provide. */
export interface WorkflowData {
    /** Workflow events for the item. */
    events?: WorkflowEvent[] | null;
}

/** Contract / authorization document that is the bases for Salaxy acting in behalf of this account */
export interface AuthorizationContract {
    /** Time when the contract was signed */
    signedAt?: string | null;
    /** If true, there is a valid authorization - the account has been validated. */
    isSigned?: boolean | null;
    /** Type of the authorization */
    authorizationType?: AuthorizationType | null;
    /** A person or other party that authorized the current person. */
    authorizedBy?: Authority | null;
}

/** A signing party in a contract. */
export interface ContractParty {
    /** Identifier for the party: Currently always an account, but may be an external ID later. */
    id?: string | null;
    /** Avatar for the Party. 
Note that this is not automatically fetched by all methods: Especially when IsSelf is true. */
    avatar?: Avatar | null;
    /** Contact information - note that for most signatures, only E-mail and phone number are required. */
    contact?: Contact | null;
    /** True if Profile is the current Authorization.
If set to true, will set current Authorization as this contract party.
If set to false AND was previously true, will set the Profile properties null (unless explicitly set to something else) */
    isSelf?: boolean | null;
    /** Official ID if needed in signature */
    officialId?: string | null;
    /** Role of the person - justification for authorization */
    role?: string | null;
    /** True if the person has signed the contract. */
    isSigned?: boolean | null;
    /** Reserved for cases where there are several signees and each has a separate signature document. */
    signatureUrl?: string | null;
    /** Bank account IBAN number */
    iban?: string | null;
    /** Party type (Person or Prospect) */
    contractPartyType?: ContractPartyType | null;
    /** If true, contact is an employer */
    isEmployer?: boolean | null;
}

/** Event in the workflow */
export interface WorkflowEvent {
    /** Event-provider specific identifier for the event.
For deletable events, this should identify , but do NOT trust this to be 100% unique. */
    id?: string | null;
    /** Type of the event. This typically maps to parent-object specific enumeration. */
    type?: string | null;
    /** Message for backoffice purposes from the User or system that created the event. */
    message?: string | null;
    /** User Interface styling of the event: Indicates the severity for the end-user. */
    ui?: BootstrapStyle | null;
    /** Features for this event. */
    features?: WorkflowEventFeatures[] | null;
    /** UTC time for when the event occured. */
    time?: string | null;
    /** User or system that created the event. */
    user?: string | null;
    /** Credential of the user which is responsible of the event. */
    assignedTo?: string | null;
    /** Record attached to this event. */
    record?: string | null;
}

/** A person or other party that authorized the current person. */
export interface Authority {
    /** Name of the authority. */
    name?: string | null;
    /** Telephone number of the person. This is currently optional.
Idea is to send SMS invitations in some scenarios. */
    telephone?: string | null;
    /** E-mail of the person. This is currently not used, but is expected to be used in the future. 
So fill it in as it was required unless you have very compelling reasons. */
    email?: string | null;
    /** Finnish Person ID is the key to signature. This is currently always required. */
    personalId?: string | null;
    /** The Palkkaus.fi Account ID. This is optional and should not be set if the ID is the same as the target account / Person. */
    accountId?: string | null;
    /** Date for the authorization. */
    authorizedAt?: string | null;
}

/** A company account - note that this can also be an association etc. - something that has a Company ID. */
export interface CompanyAccount {
    /** Information about the verification of the account. 
NOTE that this object may not be present in many method calls - this is because it contains confidential information. */
    identity?: Identity | null;
    /** High level company type */
    companyType?: CompanyType | null;
    /** Entity type of the account.
Type PersonCreatedByEmployer means that the Worker has not yet signed into the system and there may be multiple instances of the same logical person (Official ID) - one for each employer. */
    entityType?: LegalEntityType | null;
    /** If true the object Account is and Employer account - it has the EmployerInfo object */
    isEmployer?: boolean | null;
    /** If true the object Account is and Worker account - it has the WorkerInfo object */
    isWorker?: boolean | null;
    /** If true, the account has been verified. Typically this means a digitally signed contract.
This means that the account also has an Identity object.
However, as the Identity object contains confidential information, it is not necessarily present in all method calls. */
    isVerified?: boolean | null;
    /** Avatar is the visual representation of the Account. */
    avatar?: Avatar | null;
    /** Contact information for the Account. */
    contact?: Contact | null;
    /** Language of the person/company. */
    language?: Language | null;
    /** Service model for the account. */
    serviceModelId?: string | null;
    /** Workflow data, which is exposed to API. */
    workflowData?: WorkflowData | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Represents a user credential in session: This credential is typically based on Claims and is availble without going to database. */
export interface SessionUserCredential {
    /** The date when the object was created. */
    createdAt?: string | null;
    /** Unique identitier for the user ID coming from the Auth0 database: 
'[MethodText]|[ProviderId]', e.g. 'facebook|12345678901234567'
(Number may contain more characters - not sure for the exact cahracters count) */
    id?: string | null;
    /** Avatar object that contains the visual reresentation of the User account. */
    avatar?: Avatar | null;
    /** E-mail address if provided by the authentication provider. */
    email?: string | null;
    /** The ultimate authentication provider that authenticated the user, e.g. Facebook, Google. */
    authenticationMethod?: AuthenticationMethod | null;
}

/** User certificate. */
export interface Certificate {
    /** Certificate thumbprint. */
    thumbprint?: string | null;
    /** Certificate bytes Used in returning the certificate to the user as PFX or ZIP.
Not persisted. */
    bytes?: string | null;
    /** End user description for the certificate. */
    title?: string | null;
    /** Password for issuing a new certificate. Not persisted.
Also used for passing the CSR in request if it is passed as Base64 encoded text. Not persisted. */
    password?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Avatar for authorized account. */
export interface AuthorizedAvatar {
    /** Optional ID for partner authorization.
Used to restrict the authorization based on Partner data (typically user account, role etc.).
Current implementation compares this to partnerAccountId and allows acces only if the two match. */
    partnerKey?: string | null;
    /** The time when the authorization was done */
    authorizedAt?: string | null;
    /** Scope for the account authorization.
The value of the scope  is expressed as a list of space-delimited, case-sensitive strings. */
    scope?: string | null;
    /** Entity type: person/company */
    entityType?: LegalEntityType | null;
    /** First name or company name */
    firstName?: string | null;
    /** Last name, for companies, this should be null */
    lastName?: string | null;
    /** Display name. For a person this is 'FirstName LastName' (auto-created). */
    displayName?: string | null;
    /** Sortable name for ordered lists etc. For a person this is 'LastName, FirstName' (auto-created).
Depending on the data storage, this may be all-lowercase for easier sorting and search. */
    sortableName?: string | null;
    /** Type of the Avatar picture. */
    pictureType?: AvatarPictureType | null;
    /** Color - currently only used by type Icon */
    color?: string | null;
    /** Initials - currently only used by type Icon */
    initials?: string | null;
    /** URL of the picture if specified as picture (null in a case of type Icon) */
    url?: string | null;
    /** Short description of the user. 
This may be overriden by a context specific value by the business logic. */
    description?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Account - either Person or Company - is a juridical entity Paying or receiving salaries, making contracts etc. It may be related to zero, one or multiple UserAccounts/Credentials. */
export interface AccountBase {
    /** Entity type of the account.
Type PersonCreatedByEmployer means that the Worker has not yet signed into the system and there may be multiple instances of the same logical person (Official ID) - one for each employer. */
    entityType?: LegalEntityType | null;
    /** If true the object Account is and Employer account - it has the EmployerInfo object */
    isEmployer?: boolean | null;
    /** If true the object Account is and Worker account - it has the WorkerInfo object */
    isWorker?: boolean | null;
    /** If true, the account has been verified. Typically this means a digitally signed contract.
This means that the account also has an Identity object.
However, as the Identity object contains confidential information, it is not necessarily present in all method calls. */
    isVerified?: boolean | null;
    /** Avatar is the visual representation of the Account. */
    avatar?: Avatar | null;
    /** Contact information for the Account. */
    contact?: Contact | null;
    /** Language of the person/company. */
    language?: Language | null;
    /** Service model for the account. */
    serviceModelId?: string | null;
    /** Workflow data, which is exposed to API. */
    workflowData?: WorkflowData | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Provides information about a new issued certificate. */
export interface IssuedCertificate {
    /** Certificate thumbprint: A unique identifier for the created certificate. */
    thumbprint?: string | null;
    /** Certificate bytes when the certifcate is a file. Currently PFX or ZIP. */
    bytes?: string | null;
    /** Certificate / public key as text (PEM) if provided by the generation process. */
    cert?: string | null;
    /** Private key as text (PEM) if provided by the generation process. */
    key?: string | null;
}

/** Defines an accounting target (system), CoA and ruleset that maps the calculation to the CoA (Chart of Accounts). */
export interface AccountingTarget {
    /** Information and configuration related to the system where the accounting data is to be sent. */
    info?: AccountingTargetInfo | null;
    /** The rule set that defines the Chart of Accounts and the mapping of salary payment to it. */
    ruleSet?: AccountingRuleSet | null;
    /** Readonly workflow data, which is exposed to API. */
    workflowData?: WorkflowData | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Specifies the general information of the behavior of Accounting target: Especially the channel and the related properties. */
export interface AccountingTargetInfo {
    /** Basic information and visualization for the accounting target.
Avatar provides the visualization and the name for the target.
E-mail may be used in sending of the material and telephone in contacting the accounting target.
IBAN number has no use. */
    target?: AccountInIndex | null;
    /** Channel is the technical transport mechanism to accounting software */
    channel?: AccountingChannel | null;
    /** The default export method for exports: whether automatic or manual. */
    method?: ExportMethod | null;
    /** If specified, defines the available methods in manual exports. */
    availableMethods?: ExportMethod[] | null;
    /** The default export format for tabular (csv, excel) data. */
    format?: string | null;
    /** Accounting channel specific data (default settings) for the accounting target setup. */
    data?: { [key: string]: any; } | null;
}

/** Ruleset containing required tabular logic (rules) and accounts for creating accounting entries. */
export interface AccountingRuleSet {
    /** Template to which this ruleset is based on. */
    templateId?: string | null;
    /** Accounts which are used in the tabular logic for creating accounting entries. */
    accounts?: AccountingRuleSetAccount[] | null;
    /** Optional target Chart of Accounts: All the accounts in the target system, not just the ones in use. */
    targetCoA?: AccountingRuleSetAccount[] | null;
    /** Tabular logic for creating accounting entries. */
    rows?: AccountingRuleSetRow[] | null;
}

/** Single account with number, grouping and default text. */
export interface AccountingRuleSetAccount {
    /** Id for the account. */
    id?: string | null;
    /** Boolean indicating if the account is non-removable template. */
    isReadOnly?: boolean | null;
    /** Account number. */
    account?: string | null;
    /** Text for the account. */
    text?: string | null;
}

/** Contains a single row of the tabular logic for creating accounting entries. */
export interface AccountingRuleSetRow {
    /** Id for the row. */
    id?: string | null;
    /** Entry group: income type or total type. */
    entryCodeGroup?: string | null;
    /** A single code in the code group: single income type code or total row type. */
    entryCode?: string | null;
    /** Boolean indicating if the row is non-removable template. */
    isReadOnly?: boolean | null;
    /** Boolean indicating if the row is in use. */
    enabled?: boolean | null;
    /** Boolean indicating whether the system should make an accounting entry based on this row. */
    isIncluded?: boolean | null;
    /** Id of the debit account. */
    debitId?: string | null;
    /** Grouping text for the account.
If the account has a grouping defined, it will be listed as a separate row group. */
    debitGrouping?: string | null;
    /** Id of the credit account. */
    creditId?: string | null;
    /** Grouping text for the account.
If the account has a grouping defined, it will be listed as a separate row group. */
    creditGrouping?: string | null;
    /** Additional flags for directing the logic for creating accounting entry based on given entries. */
    flags?: string[] | null;
}

export interface PageResultOfAccountingTargetListItem {
    items?: AccountingTargetListItem[] | null;
    nextPageLink?: string | null;
    count?: number | null;
}

/** Represents a single item in a list of Accounting targets. */
export interface AccountingTargetListItem {
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Person GUID for the owner of the object. */
    ownerId?: string | null;
    /** Metadata for the owner */
    ownerInfo?: AccountInIndex | null;
    /** The main status depending on the type of the object. */
    status?: AccountingTargetStatus | null;
    /** The back office status depending on the type of the object. */
    backOfficeStatus?: string | null;
    /** When the event started. Typically, this is the CreatedAt date, but it may be something else. */
    startAt?: string | null;
    /** This is the end date of the event.
Typically, it is the UserUpdatedAt date, but it may be something else - e.g PaidAt for the calculation. */
    endAt?: string | null;
    /** Gross salary if that is relevant to the transaction. */
    grossSalary?: number | null;
    /** This is the payment from the Owner point-of-view:
Total payment for the Employer and Net salary for the Worker in the case of a calculation.
Only add here the payment, if the payment is really made. */
    payment?: number | null;
    /** Estimated fee of the transaction to Palkkaus.fi. */
    fee?: number | null;
    /** The GUID for the other party. Currently, this is always the PersonID. */
    otherId?: string | null;
    /** The other party (usually a Person) that is involved in the event (e.g Worker if this is a Salary payment by Employer). */
    otherPartyInfo?: AccountInIndex | null;
    /** A very short description describing the object as an event. E.g. "Paid salary" */
    shortText?: string | null;
    /** Business object ids related to this object. E.g. calculations and payrolls in the payment. */
    businessObjects?: string[] | null;
    /** This is valid for calculations only. The estimated date of salary in worker. */
    salaryDate?: string | null;
    /** Business data to include further information of the object. */
    data?: AccountingTargetData | null;
    /** Version number. May be used in conflicts */
    versionNumber?: number | null;
    /** Salaxy uri of the resource. */
    uri?: string | null;
    /** Workflow flags for the object.
Only workflow events with API supported message types are listed. */
    flags?: string[] | null;
    /** Workflow messages for the object.
Only workflow events with API supported message types are listed.
Shown in format "[MessageType]:[Message] ([User] at [UTC-time])" */
    messages?: string[] | null;
    /** Sub category for the payload. E.g. Payment Category, MoneyTransfer Source. */
    entityType?: string | null;
    /** The date for the actual period for which this object is done. */
    logicalDate?: string | null;
    /** Reference information. E.g. Payment or MoneyTransfer reference number. */
    reference?: string | null;
    /** External id for the object in 3rd party system. */
    externalId?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Accounting Target specific business data for index. */
export interface AccountingTargetData {
    /** Contains the email or id of the responsible for the partner workflow event. */
    partnerMessageAssignedTo?: string | null;
    /** Channel is the technical transport mechanism to accounting software */
    channel?: AccountingChannel | null;
    /** The default export method for exports: whether automatic or manual. */
    method?: ExportMethod | null;
    /** Available methods in manual exports (comma separated string). */
    availableMethods?: string | null;
    /** The default export format for tabular (csv, excel) data. */
    format?: string | null;
    /** Template to which this is based on. */
    templateId?: string | null;
}

/** Request model for Assertion demo */
export interface AssertionDemoCertificateRequest {
    /** Certificate bytes as Base64String */
    certificateBytes?: string | null;
    /** Certificate password for signing. */
    password?: string | null;
    /** Account to impersonate as: Will be set as sub in the token. */
    subject?: string | null;
    /** Potential proxy (partner) account that is in between the current user and the subject.
Will be set as salaxy_proxy_act in the token. */
    proxyActor?: string | null;
    /** E-mail for the user / credential that is using the system.
Will be set as salaxy_user.email. */
    userEmail?: string | null;
}

/** Response model for Assertion demo */
export interface AssertionDemoCertificateResponse {
    /** Token as string */
    token?: string | null;
    /** Token decoded for deisplay purposes. */
    tokenDecoded?: any | null;
    /** If there is an error creating hte certificate, it is displayed here. */
    error?: string | null;
}

/** Contains lists of beneficial owners and other beneficiaries of the company. */
export interface BeneficialOwners {
    /** Additional info about the owned company, e.g. the total number of shares. */
    ownedCompanyDetails?: OwnedCompanyInfo | null;
    /** List of beneficial owners of the company. */
    owners?: BeneficialOwner[] | null;
    /** List of other beneficiaries than beneficial owners of the company */
    beneficiaries?: Beneficiary[] | null;
    /** The workflow data for manual editing and approval purposes. */
    workflowData?: WorkflowData | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Contains additional info of the owned company. */
export interface OwnedCompanyInfo {
    /** Total count of shares. */
    totalNumberOfShares?: number | null;
}

/** Name and ids of the owner and the number/percent of shares. */
export interface BeneficialOwner {
    /** Owned number of shares. */
    numberOfShares?: number | null;
    /** Owned percent of shares. */
    percentOfShares?: number | null;
    /** Address. */
    address?: string | null;
    /** Avatar for the account */
    avatar?: Avatar | null;
    /** Official id of the person or company. */
    officialId?: string | null;
    /** Email address. */
    email?: string | null;
    /** Telephone number. */
    telephone?: string | null;
    /** Bank account number (IBAN) */
    ibanNumber?: string | null;
}

/** Other beneficiary of the company than beneficial owner. */
export interface Beneficiary {
    /** Nationality of the beneficiary. */
    nationality?: string | null;
    /** Avatar for the account */
    avatar?: Avatar | null;
    /** Official id of the person or company. */
    officialId?: string | null;
    /** Email address. */
    email?: string | null;
    /** Telephone number. */
    telephone?: string | null;
    /** Bank account number (IBAN) */
    ibanNumber?: string | null;
}

/** Calculation correction with state. */
export interface CalculationCorrection {
    /** Editable API calculation. */
    calculation?: CorrectionCalculation | null;
    /** State of the calculation. */
    state?: string | null;
    /** Snapshot details for save. */
    snapshot?: SnapshotInput | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Extensions to Corrections */
export interface CorrectionCalculation {
    /** Pricing model */
    pricingModel?: PricingModel | null;
    /** Fixed fee */
    fixedFee?: number | null;
    /** Customer payments info. */
    cfa?: CalcCfa | null;
    /** The employer object for this calculation.
Typically, you do not need to set this before the actual payment process. */
    employer?: CalcEmployer | null;
    /** The Worker (employee) that has performed the work. */
    worker?: CalcWorker | null;
    /** Information about the workflow and state of the calculation. */
    workflow?: CalcWorkflow | null;
    /** The main salary element. 
Alternatively the salary can be set in the Rows object - this will be the only way to set multiple salary rows (not yet supported). */
    salary?: Salary | null;
    /** Set of rows that make up the salary calculation:
Expenses, Benefits, deductions etc. Note that side costs are not rows. */
    rows?: UserDefinedRow[] | null;
    /** DEPRECIATED: Usecase will be replacing this functionality in a next major release.
The Framework Agreement (TES) parameters that affect the framework based side costs etc. of this calculation */
    framework?: TesParameters | null;
    /** A usecase for creating and editing salary calculations.
In practice, a usecase is either a user interface or a microservice that provides a salary calculation
and it may be implemented outside Salaxy.
Provides the possibility to store useacase specific data as part of calculation.
NOTE: This functionality will replace Framework property in a next major release. */
    usecase?: UsecaseData | null;
    /** The results of the calculation. In the API, this is a read-only object. */
    result?: CalculationResult | null;
    /** Information about the work that is not directly related to calculating salary and expenses. */
    info?: CalcInfo | null;
    /** Sharing of the calculation. This object cannot be modified directly, 
use specialized methods in Calculations service. */
    sharing?: CalculationSharing | null;
    /** Contains calculation specific data for accounting (both cost and financial accounting). */
    accounting?: CalculationAccounting | null;
    /** Worktime data that is stored as part of Salary calculation:
work days, absences, holidays and holiday accrual.
In the future may also contain relevant part of timesheet data (work hours). */
    worktime?: CalcWorktime | null;
    /** Readonly workflow data, which is exposed to API. */
    workflowData?: WorkflowData | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Input data for calculation snapshot. */
export interface SnapshotInput {
    /** Reason code for the snapshot. */
    reasonCode?: number | null;
    /** Severity code for snapshot case. */
    severityCode?: number | null;
    /** Free form description. */
    description?: string | null;
    /** Categories for the snapshot case. */
    categories?: string[] | null;
}

/** Cfa allocations. */
export interface CalcCfa {
    /** The date and time of allocation.
This is always UTC. */
    updatedAt?: string | null;
    /** The worker net salary which is booked to the customer funds account. */
    net?: number | null;
    /** The tax amount which is booked to the  customer funds account. */
    tax?: number | null;
    /** The pension amount which is booked to the  customer funds account. */
    pension?: number | null;
    /** The Palkkaus service which is booked to the  customer funds account. */
    service?: number | null;
    /** The Palkkaus fee which is booked to the  customer funds account. */
    fee?: number | null;
    /** The total payment booked to the  customer funds account. */
    readonly total?: number | null;
}

/** Employer of a calculation */
export interface CalcEmployer {
    /** Display image information and type of employer.
NOTE: Recalculate-method retains the values for display purposes if AccountId or IsSelf is not set.
This is mainly for demo and testing in anonymous mode.
However, in storage methods, the value is reset based on values of AccountId or IsSelf
even if they are not set: Anything stored in Avatar will be ignored. */
    avatar?: Avatar | null;
    /** The Palkkaus.fi Account identifier for the Employer. */
    accountId?: string | null;
    /** True if Profile is the current Authorization.
If set to true, will set current Authorization as this contract party.
This overrides any value in AccountId, so be sure to switch this back to false if this is switchable.
Setting to False does not have any immediate effect. */
    isSelf?: boolean | null;
    /** Current address of the employer.
Please note that this is a read only field. */
    contact?: Contact | null;
    /** Official id of the person or company.
Please note that this is a read only field. */
    officialId?: string | null;
}

/** Worker object for the current calculation */
export interface CalcWorker {
    /** Palkkaus.fi Account Id for the worker.
Alternatively you can set the Payment data with the required infromation */
    accountId?: string | null;
    /** Employment Id for the worker. */
    employmentId?: string | null;
    /** Data that is needed for salary payment.
This object may be null if AccountId has been set. 
Also, if AccountId has been set, these properties will be ignored: 
The Worker will decide on payment properties herself. */
    paymentData?: CalcWorkerPaymentData | null;
    /** Display image and properties of the Worker. 
Based on either the AccountId or PaymentData */
    avatar?: Avatar | null;
    /** True if Profile is the currently Account
If set to true, will set current Account as this contract party.
This overrides any value in AccountId, so be sure to switch this back to false if this is switchable.
Setting to False does not have any immediate effect. */
    isSelf?: boolean | null;
    /** Date of birth for the Worker - this affects the side costs. 
Please also set the DateOfBirthAccuracy, if you set this property.
If PaymentData or AccountId lead to a valid Social security number, it will override any age set here. */
    dateOfBirth?: string | null;
    /** Accuracy of the date of birth
If PaymentData or AccountId lead to a valid Social security number, it will override any age set here. */
    dateOfBirthAccuracy?: DateOfBirthAccuracy | null;
    /** New Widthholding tax logic that is based on separately stored tax cards. */
    tax?: CalcTax | null;
    /** Current address of the worker.
Please note that this is a read only field. */
    contact?: Contact | null;
}

/** Defines the properties of salary calculation workflow - typically the workflow from draft to Payment. */
export interface CalcWorkflow {
    /** Status of the calculation from Draft to PaymentSucceeded */
    status?: CalculationStatus | null;
    /** Time when this calculation was paid (if it was paid) to Palkkaus service. */
    paidAt?: string | null;
    /** Time when the salary was paid by Palkkaus service. */
    salaryPaidAt?: string | null;
    /** The estimated date when the salary is withdrawable by the worker. */
    salaryDate?: string | null;
    /** The requested date for the SalaryDate from the employer. */
    requestedSalaryDate?: string | null;
    /** Defines the re-setting of the salary date in the calculation re-calculation. */
    salaryDateKind?: SalaryDateKind | null;
}

/** Defines the main salary that is the bases for the calculation */
export interface Salary {
    /** Type of the salary being calculated */
    kind: SalaryKind;
    /** Amount of e.g. hours, months for the salary. Default is 1. */
    amount?: number | null;
    /** Price of one unit - e.g. hour, month. */
    price: number;
    /** E.g. hour, month. Typically this parameter can be left empty/null and the unit is set according to type. */
    unit?: string | null;
    /** Optional message for the salary row that is shown in reports. If null, will be set according to type. */
    message?: string | null;
    /** If set to true, will calculate the household deduction. Applies only to natural persons - as oppsed to companies. */
    isHouseholdDeductible?: boolean | null;
    /** If tax IsHouseholdDeductible is set to true, please also select the category (categories). 
Note that "OwnPropety" is a default, it does not need to be set: Only set RelativesProperty if necessary. */
    taxDeductionCategories?: TaxDeductionWorkCategories | null;
}

/** This is a user defined calculation row as opposed to CalculationRow that may be either based on a user defined row or generated by the system based on e.g. TES parameters. */
export interface UserDefinedRow {
    /** Zero based row index that can be used to match the row to result rows or when deleting.
NOTE: The Row ID is given values on the fly so setting this will not have any effect at the moment.
It may reorder the entries in later implementations. */
    rowIndex?: number | null;
    /** Wage type. Either a built in wage type in Salaxy or a custom wage type created by the user.
Please note that this type fully determines the <see cref="T:Palkkaus.Model.Calc.CalculationRowType"></see> and the kind. */
    type?: string | null;
    /** Logical type of the row */
    rowType?: CalculationRowType | null;
    /** Description text of the row that is shown in reports. If null, will be set according to type. */
    message?: string | null;
    /** Count for the row - default is one */
    count?: number | null;
    /** Price for the row */
    price?: number | null;
    /** Unit for the row. Guessed based on the RowType and count, but you are better off setting it to be sure. */
    unit?: CalculationRowUnit | null;
    /** Source of the calculation row - affects how the row is handled in editing / recalculation scenarios. */
    source?: CalculationRowSource | null;
    /** Identifier in the source system is a key defined by a source system / partner system.
This is a pass-through string that is passed to the result calculations. */
    sourceId?: string | null;
    /** Accounting related data for the row. */
    accounting?: RowAccounting | null;
    /** Period if different than the Period of calculation.
Will be reported to the National Incomes registry, but also affect some other calculations.
Note that this property may be (and by default is) null. */
    period?: DateRange | null;
    /** Usecase specific data */
    data?: { [key: string]: any; } | null;
}

/** Captures the collection of parameters that different Framework agreements (TES) have. */
export interface TesParameters {
    /** Type of the work framework */
    type?: FrameworkAgreement | null;
    /** Subtype when one framework has several options */
    subType?: TesSubtype | null;
    /** Marker that the payments defined by framework agreement are included in the salary (will not be added by the calculation). */
    isTesIncludedInSalary?: boolean | null;
    /** Number of days may affect calculation of different payments calculated based on a Framework agreement */
    numberOfDays?: number | null;
    /** Travel expences per day */
    dailyTravelExpenses?: number | null;
    /** The amount of kilometers travelled by day - used to define the amount of travel expenses in aomse framework agreements. */
    dailyTravelExpensesKm?: number | null;
    /** Daily expenses amount */
    dailyExpenses?: number | null;
    /** If true will calculate the Finnish child care subsidy */
    isYksityisenHoidonTuki?: boolean | null;
    /** Amount of Finnish child care subsidy */
    yksityisenHoidonTukiAmount?: number | null;
}

/** A usecase for creating and editing salary calculations and other . In practice, a usecase is either a user interface or a microservice that provides the bases for the object. Provides the possibility to store useacase specific data as part of object. NOTE: For Calculations, this functionality will replace TesParameters in the 3.0 version. */
export interface UsecaseData {
    /** Key for the usecase based on which it is resolved. 
Later, this may resolve to a user interface, microservice or a to manifest registering one.
For now, just use a unique string starting with a domain you own. */
    uri?: string | null;
    /** A short label of that can be shown to the end user. */
    label?: string | null;
    /** Optional description of the use case for the end user.
Shown in detail views when explaining the logic of the usecase. */
    description?: string | null;
    /** Usecase specific data */
    data?: { [key: string]: any; } | null;
}

export interface CalculationResult {
    /** Calculation totals that are common to both Worker and Employer. */
    totals?: TotalCalculationDTO | null;
    /** Rows that are compatible with Incomes Register (tulorekisteri) process.
These are available only for calculations paid after 7.2.2019 (TODO: estimation as of writing). */
    irRows?: IrRow[] | null;
    /** The calculation from the Employer point-of-view */
    employerCalc?: EmployerCalculationDTO | null;
    /** The calculation from the Worker point-of-view */
    workerCalc?: WorkerCalculationDTO | null;
    /** The result rows. Note that this collection also contains the main Salary entry as one of the rows. */
    rows?: ResultRow[] | null;
    /** Responsibilities of Employer and parameters that affect those responsibilities. */
    responsibilities?: IEmployerResponsibilities | null;
    /** The validation result for the current calculation.
Please note that this is not serialized into the data storage. */
    validation?: ApiValidation | null;
}

/** Informational object that stores data about the salary calculation / payment that is not directly related to calculating the salary. */
export interface CalcInfo {
    /** Start date of the work */
    workStartDate?: string | null;
    /** End date of the work */
    workEndDate?: string | null;
    /** Description of the work for reporting purposes. Max 32 chars. */
    workDescription?: string | null;
    /** Message from worker to employer - when worker sends the salary calculation to the employer. */
    workerMessage?: string | null;
    /** Message which will be displayed in the payslip. */
    salarySlipMessage?: string | null;
    /** Payment reference number in payment service */
    paymentId?: string | null;
    /** Original Payment reference number */
    originalPaymentId?: string | null;
    /** Channel that is used for payment. */
    paymentChannel?: PaymentChannel | null;
    /** Application id for invoicing etc. purposes. */
    applicationId?: string | null;
    /** The MessageThread Id, if this calculation is referred in a message thread. */
    messageThreadId?: string | null;
    /** Assumed earnings payment report date for the report. */
    reportDate?: string | null;
    /** Notes related to the payment and other backoffice operations: 
For example the justification why the sum is in calculation vs. Paytrail payment. */
    backofficeNotes?: string | null;
    /** Occupation classification, used at least for Accident insurance purposes, but may be used for other reporting. 
For Finnish Salaries use the Statistics Finland 
"Classification of Occupations 2010" (TK10): https://www.stat.fi/meta/luokitukset/ammatti/017-2018-05-15/index_en.html */
    occupationCode?: string | null;
    /** Secondary occupation classification. Some earnings payment reports may require two occupation codes. */
    occupationCode2?: string | null;
    /** Calculated pension insurance payment date. */
    pensionPaymentDate?: string | null;
    /** Pension insurance reference number. */
    pensionPaymentRef?: string | null;
    /** Pension insurance payment specifier. */
    pensionPaymentSpecifier?: string | null;
    /** The Payroll Id, if this calculation is part of a Payroll list. */
    payrollId?: string | null;
    /** Cost center for reporting purposes. */
    costCenter?: string | null;
    /** Identifier of the worker in a source system. Used in imports etc.
This is automatically set from the source id of the employment. */
    workerSourceId?: string | null;
    /** Identifier of the calculation in a source system. Used in imports etc. */
    sourceId?: string | null;
}

/** Defines the properties related to sharing and sending of the calculation. */
export interface CalculationSharing {
    /** Type of sharing for this calculation. */
    type?: SharingUriType | null;
    /** Sharing uri. */
    uri?: string | null;
    /** Email address to which the calculation was shared last time. */
    lastSharedTo?: string | null;
    /** Email address which the calculation was shared as cc last time. */
    lastSharedCc?: string | null;
    /** Last shared message to the employer */
    lastSharedMessage?: string | null;
}

/** Contains calculation specific data for accounting (both cost and financial accounting). */
export interface CalculationAccounting {
    /** Values for cost accounting dimensions */
    dimensions?: CostAccountingDimension[] | null;
}

/** Worktime data that is stored as part of Salary calculation: work days, absences, holidays and holiday accrual. In the future may also contain relevant part of timesheet data (work hours). */
export interface CalcWorktime {
    /** Employment period that is updated from employment at each recalculation (as opposed to holiday specification). */
    employmentPeriod?: DateRange | null;
    /** Wage basis from the current employment relation.
This is for absences and does not presume that holiday years exist for the worker. */
    wageBasis?: WageBasis | null;
    /** Describes the working days in the period.
Currently, uses the DaysCount, but later the full days array will be taken to use.
This includes the absence days (divider in AbsencesDaySalary). */
    workDays?: DateRange | null;
    /** Periods of 'absences'. */
    absencesPeriods?: AbsencePeriod[] | null;
    /** Price for a single absence day. Typically based on MonthlySalary, but may be modified. */
    absencesDailySalary?: number | null;
    /** Specification for the holiday calculation */
    holidaySpec?: HolidaySpecificationForYear | null;
    /** Price for a single holiday day */
    leavesDailySalary?: number | null;
    /** Price for a single bonus day */
    bonusDailySalary?: number | null;
    /** Total remaining amount of holiday pay accrual. */
    holidayPayAccrualRemaining?: number | null;
    /** Total remaining amount of holiday bonus accrual. */
    holidayBonusAccrualRemaining?: number | null;
    /** Accruals for each calendar month in this calculation. */
    accruals?: MonthlyHolidayAccrual[] | null;
    /** Specification for the accrual calculation */
    accrualSpec?: HolidayAccrualCalcSpecification | null;
}

/** The required information for paying the Salary to Worker. */
export interface CalcWorkerPaymentData {
    /** First name of the person. */
    firstName?: string | null;
    /** Last name / Surname of the person. */
    lastName?: string | null;
    /** Gets the Social security number the way the user set it in input.
HOWEVER: The getter will change the string to upper invariant/trim and if the last character is "*", it will be replaced by calculated checksum. */
    socialSecurityNumber?: string | null;
    /** Social security number if valid or null */
    readonly socialSecurityNumberValid?: string | null;
    /** IBAN number for the Bank account */
    ibanNumber?: string | null;
    /** Contact e-mail address. */
    email?: string | null;
    /** Telephone number */
    telephone?: string | null;
}

/** Tax card information stored as part of the Calculation object */
export interface CalcTax {
    /** Identifier for a stored tax card if one is applied to this calculation.
System updates the TaxCardId automatically in Recalculate / Save if it finds a better candidate
and also updates the Snapshot. */
    taxcardId?: string | null;
    /** Snapshot of the tax card for salary slip etc. purposes.
Updated in Recalculate / Save based on TaxCardId */
    snapshot?: TaxcardSnapshot | null;
    /** Possibility to set a fixed widthholding tax amount for this calculation regardless of 
the percentage etc. in the tax card. */
    fixedTaxAmount?: number | null;
    /** The API returns true if there is a valid taxcard for the PaidAt date for this calculation
or if FixedTaxAmount is set for th calculation. */
    isValid?: boolean | null;
    /** Calculated widthholding tax. Note that this is an estimation until the calculation is actually paid.
Also, if the salary is not paid as cash (e.g. fringe benefits), there may not be enough money to make the full deduction. */
    estimatedTax?: number | null;
    /** A flag that during last recalculation, there was a new shared taxcard that was waiting approval. */
    hasNewSharedCard?: boolean | null;
    /** Tax percent that is used in visualization. This is mainly used in Unit testing and anonymous calcultors.
Not used in real paid calculations. This is percent. I.e. for 50% set 50, not 0.5.
If PaymentData or AccountId lead to a valid tax card type and percent, or if there is FixedTaxAmount, this value is not used. */
    taxPercentForVisualization?: number | null;
}

/** Provides row specific data for accounting (both cost and financial accounting). */
export interface RowAccounting {
    /** Percent for VAT calculation expressed as decimal: 24% is 0.24. */
    vatPercent?: number | null;
    /** Total VAT amount splitted by VAT rates.
Please note, that if both {Palkkaus.Model.Calc.RowAccounting.VatPercent} and the {Palkkaus.Model.Calc.RowAccounting.VatEntries} with some entries given,
the {Palkkaus.Model.Calc.RowAccounting.VatEntries} are applied.
Please note that this is null by default. */
    vatEntries?: VatEntry[] | null;
    /** Values for cost accounting dimensions */
    dimensions?: CostAccountingDimension[] | null;
}

/** Calculates the total numbers - the ones that are common to Employer and worker. */
export interface TotalCalculationDTO {
    /** The total pension payment for this calculation */
    pension?: number | null;
    /** The total unemployment payment sum. */
    unemployment?: number | null;
    /** The total of all calculation rows */
    total?: number | null;
    /** The base salary without overtime and other such additions that are part of gross salary. */
    totalBaseSalary?: number | null;
    /** Gross salary is the salary including additions like overtime, but not benefits or expenses */
    totalGrossSalary?: number | null;
    /** Taxable salary is the salary from the taxation point of view - includes some benefits. */
    totalTaxable?: number | null;
    /** Deduction from TotalTaxable to tax at source calculation. */
    taxAtSourceDeduction?: number | null;
    /** DEPRICATED: This is now the same as TotalPensionInsuranceBase. For other social insurances, you may want to use 
TotalUnemploymentInsuranceBase, TotalHealthInsuranceBase or TotalAccidentInsuranceBase, */
    totalSocialSecurityBase?: number | null;
    /** Base income for calculating the Pension insurance contributions. */
    totalPensionInsuranceBase?: number | null;
    /** Base income for calculating the Unemployment insurance contributions. */
    totalUnemploymentInsuranceBase?: number | null;
    /** Base income for calculating the Health insurance contributions. */
    totalHealthInsuranceBase?: number | null;
    /** Base income for calculating the Accident insurance contributions. */
    totalAccidentInsuranceBase?: number | null;
    /** Tax free expenses. */
    totalExpenses?: number | null;
    /** Total sum of rows that are paid through Salaxy Customer Funds account.
This is the Gross sum before side costs, deductions etc., but it is not Gross salary as it includes expenses etc. */
    totalPayable?: number | null;
}

/** Business level modeling corresponding to WageReportsToIRTypes Transaction. Also contains additional data for accounting and integration purposes. */
export interface IrRow {
    /** Type of the row - basically describes the source for this row: 
Either Manual (default) or Usecase logic, which may be legacy / API v02 or new / API v03. */
    type?: IrRowSourceType | null;
    /** Description text of the row that is shown in reports. */
    message?: string | null;
    /** Count for the row. Default is one. */
    count?: number | null;
    /** Price for the row. */
    price?: number | null;
    /** Simple multiplication: Count * Price - no other logic. Not used as Input. */
    total?: number | null;
    /** Unit for the row. If specified as Undefined, set by the server-logic based on row type etc. */
    unit?: Unit | null;
    /** Details for the National Incomes registry */
    irData?: IrDetails | null;
    /** Details from Salaxy internal calulcation point-of-view (logic not in IR). */
    calcData?: IrRowCalculationProperties | null;
    /** Earnings period if different than the report period.
Note that this property may be (and by default is) null. */
    earningPeriod?: DateRange | null;
    /** Period for the calculation row. This is mainly used for absences (AbsencePeriod row type), leaves and holidays (HolidaySalary, HolidayBonus and HolidayCompensation).
Note that this property may be (and by default is) null. */
    period?: DateRange | null;
    /** Accounting related data for the row. */
    accounting?: RowAccounting | null;
    /** Usecase specific data */
    data?: { [key: string]: any; } | null;
}

/** Models the business logic of Employer side of the calculation. For documentation, see the IEmployerCalculation interface. */
export interface EmployerCalculationDTO {
    /** All side cost: The mandatory side costs + Palkkaus and partner fees */
    allSideCosts?: number | null;
    /** The final cost after household decuction from the tax authorities:
Add to the payment the deductions (paid by employer) and deduct House hold deduction (later potentially other such subsidies) */
    finalCost?: number | null;
    /** Household deduction that the tax man will reimburse in taxation.
This is an estimation: There is minimum and maximum limits etc. */
    householdDeduction?: number | null;
    /** The mandatory side costs are Pension (TyEL), Social secuirty and Unemployment insurance. */
    mandatorySideCosts?: number | null;
    /** The Palkkaus.fi fee including potential partner fees. */
    palkkaus?: number | null;
    /** Extra service charge in addition to Palkkaus fee. */
    service?: number | null;
    /** The part of the Pension that Employer pays */
    pension?: number | null;
    /** The social security payment- paid as part of taxation (ennakonpidätys). */
    socialSecurity?: number | null;
    /** Total payment that is Paid to Palkkaus.fi */
    totalPayment?: number | null;
    /** Total payment using pre Insiders register calculation logic.
DEPRICATED: This is provided for special scenarios and may be removed without warning */
    totalPaymentLegacy?: number | null;
    /** Total salary cost is the paid salary, deductions and side costs, but not expenses. */
    totalSalaryCost?: number | null;
    /** The part of the unemployment insurance that the employer pays */
    unemployment?: number | null;
    /** Total deductions that are made from the payment that is paid to Palkkaus and then to Worker */
    totalDeductions?: number | null;
    /** Union payment if it is deducted from the final figure */
    deductionUnionPayment?: number | null;
    /** Pension payments, when paid directly by the Employer - not by Palkkaus.fi */
    deductionPensionSelfPayment?: number | null;
    /** Unemployment insurance (TVR) payments, when paid directly by the Employer - not by Palkkaus.fi */
    deductionUnemploymentSelfPayment?: number | null;
    /** Salary advance - this part has already been paid. */
    deductionSalaryAdvance?: number | null;
    /** Foreclosure that has already been paid by the employer. */
    deductionForeclosure?: number | null;
    /** Tax and social security payments, when paid directly by the Employer - not by Palkkaus.fi */
    deductionTaxAndSocialSecuritySelfPayment?: number | null;
    /** Worker salary and expense payments, when paid directly by the Employer - not by Palkkaus.fi */
    deductionWorkerSelfPayment?: number | null;
    /** Foreclosure that Palkkaus.fi pays in behalf of employer. */
    foreclosureByPalkkaus?: number | null;
    /** Other deductions that are deducted from the net salary. */
    deductionOtherDeductions?: number | null;
}

/** The Worker side of the calculation. SalarySlip is largely written based on this calculation. */
export interface WorkerCalculationDTO {
    /** The benefits as valued by the tax authority. */
    benefits?: number | null;
    /** All the items that are deducted from the salary (this is also the order if there is not enough payable money):
SalaryAdvance + Tax + Pension + UnemploymentInsurance + UnionPayment + OtherDeductions */
    deductions?: number | null;
    /** The payment that is made to the Worker based on salary after all deductions.
Does not include expenses. */
    salaryPayment?: number | null;
    /** The salary advance that was paid to the Worker */
    salaryAdvance?: number | null;
    /** The foreclosure that been deducted from the salary by the employer. */
    foreclosure?: number | null;
    /** Ennakonpidätys: The taxes that were deducted from the worker salary. */
    tax?: number | null;
    /** Lähdevero: The tax at source that were deducted from the worker salary. */
    taxAtSource?: number | null;
    /** Net salary after tax - before worker foreclosure or deductions of the side costs */
    salaryAfterTax?: number | null;
    /** Net salary after tax and foreclosure. */
    salaryAfterTaxAndForeclosure?: number | null;
    /** Part of the Pension that is taken from the Worker side of the salary. */
    pension?: number | null;
    /** Workers part of the unemployment insurance. */
    unemploymentInsurance?: number | null;
    /** The social security payment. NOT paid as a part of tax withhold . */
    socialSecurity?: number | null;
    /** The union payment that is deducted from the Worker salarya s per workers request. */
    unionPayment?: number | null;
    /** Widthholding tax: The original calulated version - there might not be enough money to finally pay this. */
    fullTax?: number | null;
    /** Tax at source: The original calulated version - there might not be enough money to finally pay this. */
    fullTaxAtSource?: number | null;
    /** The salary advance that was paid to the Worker
The original calulated version - there might not be enough money to finally pay this. */
    fullSalaryAdvance?: number | null;
    /** Part of the Pension that is taken from the Worker side of the salary.
The original calulated version - there might not be anough money to finally pay this. */
    fullPension?: number | null;
    /** Workers part of the unemployment insurance.
The original calulated version - there might not be anough money to finally pay this. */
    fullUnemploymentInsurance?: number | null;
    /** The social security payment. NOT paid as a part of tax withhold .
The original calculted version. */
    fullSocialSecurity?: number | null;
    /** The union payment that is deducted from the Worker salarya s per workers request. */
    fullUnionPayment?: number | null;
    /** The sum that is at the end paid to the Worker:
Salary payment + expenses */
    totalWorkerPayment?: number | null;
    /** Total payment using pre Insiders register calculation logic.
DEPRICATED: This is provided for special scenarios and may be removed without warning */
    totalWorkerPaymentLegacy?: number | null;
    /** The side costs that are deducted from the Worker salary according to law:
Pension, Unemployment and Union payment. Tax is not included in this number.
This is not an official number, really used in the charts etc. */
    workerSideCosts?: number | null;
    /** Other deductions that are deducted from the net salary.
The original calulated version - there might not be enough money to finally deduct this. */
    fullOtherDeductions?: number | null;
    /** Part of the other deductions that are deducted from the net salary. */
    otherDeductions?: number | null;
    /** Prepaid expenses that are deducted from the expenses to be paid to the worker.
The original calulated version - there might not be enough money to finally deduct this. */
    fullPrepaidExpenses?: number | null;
    /** Part of the prepaid expenses that are deducted from the expenses. */
    prepaidExpenses?: number | null;
}

/** Defines a Calculation row in the calculation results */
export interface ResultRow {
    /** Row index that matches this row to a user defined row (which is zero-based).
If the row is generated by calculation business logic (e.g. based on framework agreement), the index is -1. */
    userRowIndex?: number | null;
    /** Wage type. Either a built in wage type in Salaxy or a custom wage type created by the user.
Please note that this type fully determines the <see cref="T:Palkkaus.Model.Calc.CalculationRowType"></see> and the kind. */
    type?: string | null;
    /** Logical type of the row */
    rowType?: CalculationRowType | null;
    /** Source of the calculation row - affects how the row is handled in editing / recalculation scenarios. */
    rowSource?: CalculationRowSource | null;
    /** Description text of the row that is shown in reports. If null, will be set according to type. */
    message?: string | null;
    /** Count for the row - default is one */
    count?: number | null;
    /** Price for the row */
    price?: number | null;
    /** Unit for the row */
    unit?: CalculationRowUnit | null;
    /** Total for the row - always Price * Count */
    total?: number | null;
    /** Base salary (Peruspalkka) is the monthly salary or total salary without addiotions (overtime, holidays etc.) */
    totalBaseSalary?: number | null;
    /** Gross salary (Bruttopalkka) is "real" salary including the additions (overtime, holidays etc.) but not benefits. */
    totalGrossSalary?: number | null;
    /** Taxable income (Ennakonpidätyksen alainen ansio) is the salary from taxation point-of-view. It is basically the Gross Salary plus benefits. */
    totalTaxable?: number | null;
    /** Social Security Base (Sosiaaliturvan alainen ansio) is typically the same as TotalTaxable, 
but e.g. child care subsidy (yksityisen hoidon tuki) is handled differently. */
    totalSocialSecurityBase?: number | null;
    /** Taxfree expenses compensation */
    totalExpenses?: number | null;
    /** Deductions from the salary: Union payment, Advance, Foreclosure */
    totalDeduction?: number | null;
    /** Identifier in the source system is a key defined by a source system / partner system.
This is a pass-through string that is kept as-is in the Salaxy system. */
    sourceId?: string | null;
    /** Period if different than the Period of calculation.
Will be reported to the National Incomes registry, but also affect some other calculations.
Note that this property may be (and by default is) null. */
    period?: DateRange | null;
    /** Accounting related data for the row. */
    accounting?: RowAccounting | null;
    /** Usecase specific data */
    data?: { [key: string]: any; } | null;
}

/** Parameters that affect the calculation. EmployerResponsibilities is historical name - currentlty to object holds also other properties that are not well described as responsibilities. These based on the EmployerGroups selection or properties of the Employer and Worker snapshots as well as this Calculation */
export interface IEmployerResponsibilities {
    /** Employer groups that are set on Example calculations.
These will be replaced by properties from Worker / Employer when these persons are set. */
    employerGroups?: EmployerGroups | null;
    /** Pension is not paid if the salary to this Worker is less than a certain amount in a month (about 60€)
or worker is less than 17 or more than 64 years old. */
    readonly noPensionPayment?: boolean | null;
    /** If worker is less than 16 or more than 67, social secuiry payment is not paid */
    readonly noSocialSecurity?: boolean | null;
    /** If Worker is less than 17 or more than 64, TVR is not paid.
Also if the Employer has no accident insurance. */
    readonly noTvr?: boolean | null;
    /** The name of the Pension company because this affects the Pension percentage used in the calculation (only in contract situation).
It also needs to be shown in the reports. */
    readonly pensionCompany?: PensionCompany | null;
    /** Pension discount percent. */
    readonly pensionDiscountPercent?: number | null;
    /** Customer specific pension percent. */
    readonly pensionPercent?: number | null;
    /** Company for the current insurance */
    readonly insuranceCompany?: InsuranceCompany | null;
    /** Percent for calculating the estimate for the accident insurance amount to pay. */
    readonly insurancePercent?: number | null;
    /** Percent for calculating the estimate for the group life insurance amount to pay. */
    readonly groupLifeInsurancePercent?: number | null;
    /** Accident insurance contract number. */
    readonly insuranceContractNumber?: string | null;
    /** If the Worker is from 53 to 62 years old, more of the Pension payment 
is deducted from the Worker side of the salary (less for the Employer).
NOTE: People from 63 to 67 years pay the same amount as 17-52 years old. */
    readonly pensionOldAgePayment?: boolean | null;
    /** The employer should have a Pension contract (not a temporary employer).
It does not necessarily mean that the user has a contract yet.
NOTE: At the moment, this is not used for calculation - only in the Side costs visualizer tool. */
    readonly pensionRegularEmployer?: boolean | null;
    /** If true, the employer has a Pension contract and makes the payments 
in a monthly schedule which means that Pension interest is calculated for the 20th of the next month.
Currently, this is only enabled to Etera - other companies will follow. */
    readonly isPensionMonthlyContract?: boolean | null;
    /** If true, the employer pays the Unemployment insurance directly to TVR.
As of writing, this is true for all companies and with calculations starting 1.8.2018,
false for households or calculations before the date. */
    readonly unemploymentSelfPayment?: boolean | null;
    /** The assumed salary payment date from the worker perspective.
The system calculates the nearest possible salary date if no any salary date has been given by the
employer. If given, the system confirms the given date.
This date affects the yearly percents used in the salary calculation. */
    readonly calculationPaymentDate?: string | null;
    /** The age range that is used in the business logic that determines the employer responsibilities.
This property replaces the EmployerGroups.AgeRange that was previous get/set. 
This is based on WorkerDateOfBirth and CalculationPaymentDate. */
    readonly pensionAgeRange?: AgeRange | null;
    /** Date of birth for the Worker - this affects the side costs. 
Please also set the DateOfBirthAccuracy, if you set this property.
If SocialSecurityNumber is set, it will override any value set here. */
    readonly workerDateOfBirth?: string | null;
    /** Accuracy of the date of birth
If SocialSecurityNumber is set, it will override any value set here. */
    readonly workerDateOfBirthAccuracy?: DateOfBirthAccuracy | null;
    /** Pension calculation type. */
    pensionCalculation?: PensionCalculation | null;
    /** Rules (e.g. effect of monthly lower limit) for pension calculation. */
    pensionRule?: PensionRule | null;
    /** Type of the employment relation */
    employmentType?: EmploymentRelationType | null;
    /** Taxcard type from the employment point of view. */
    employmentTaxcard?: EmploymentRelationTaxcard | null;
    /** Worker's preferred salary payment method: bank account, external etc. */
    salaryPaymentMethod?: EmploymentRelationSalaryPaymentMethod | null;
    /** Type of additional income earner data by National Incomer Register classification . If several types apply, all of them should be selected. */
    irIncomeEarnerTypes?: IncomeEarnerType[] | null;
    /** Sub organization code for the Incomes Registry. */
    readonly subOrgCode?: string | null;
    /** Employment registration code for Incomes Registry. */
    employmentRegCode?: string | null;
    /** Tax and social security payments are paid directly by the Employer - not by Palkkaus.fi */
    readonly taxAndSocialSecuritySelfPayment?: boolean | null;
    /** Worker salary and expense payments are paid directly by the Employer - not by Palkkaus.fi */
    readonly workerSelfPayment?: boolean | null;
    /** Pension payments are paid directly by the Employer - not by Palkkaus.fi */
    readonly pensionSelfPayment?: boolean | null;
    /** Pension insurance contract number. */
    readonly pensionContractNumber?: string | null;
    /** Status for indicating whether the total amount of paid salaries exceeds the thresold for higher unemployment insurance percent. */
    readonly unemploymentPayrollLimitStatus?: UnemploymentPayrollLimitStatus | null;
    /** Options for the delivery of the payslip to the worker. */
    readonly salarySlipDeliveryMethods?: WorkerSalarySlipDeliveryMethod[] | null;
}

/** Common base class / interface for data validation. */
export interface ApiValidation {
    /** If true, the data is valid - no errors. */
    readonly isValid?: boolean | null;
    /** If true, has required fields missing data. */
    readonly hasAllRequiredFields?: boolean | null;
    /** Validation errors on invalid field values. 
Note that required fields missing error messages are not here. Only the invalid values. */
    readonly errors?: ApiValidationError[] | null;
}

/** Id of the cost accounting dimension with optional percentage for shared costs. */
export interface CostAccountingDimension {
    /** Dimension Id. */
    id?: string | null;
    /** Cost accounting dimension value id. */
    value?: string | null;
    /** Sharing percent for the dimension. */
    percent?: number | null;
}

/** Extends the Holiday specification with the properties of employment relation that are required for a specific year. */
export interface HolidaySpecificationForYear {
    /** Wage basis for a Holiday Year.
When this is changed, you need to make a rerun to the previous calculations in the holiday year.
NOTE: This is not in HolidaySpecification because, the same value is stored in Employment relation. */
    wageBasis?: WageBasis | null;
    /** Employment period for the purposes of holiday calculation (annual leave accrual).
When this is changed, you need to make a rerun to the previous calculations in the holiday year. */
    employmentPeriod?: DateRange | null;
    /** Defines how the holidays are handled for the worker. */
    code?: HolidayCode | null;
    /** Defines how the holiday pay is calculated. */
    holidayPayCalculation?: HolidayPayCalculation | null;
    /** Defines the number of holidays that the worker is entitled per month worked.
If the value is set to 0 (default), the number is 2 for first year and 2,5 thereafter as defined in the law.
To actually se the daysPerMonth to zero, use code value other than Permanent14Days or Permanent35Hours. */
    accrualFixed?: number | null;
    /** For {Palkkaus.Model.Worktime.Holidays.HolidayPayCalculation.HolidayCompensation} the compensation percent.
Holiday compensation as percent of salary (11.5% is 0.115) */
    compensation?: number | null;
    /** For {Palkkaus.Model.Worktime.Holidays.HolidayPayCalculation.PercentageBasedPay} the percent.
Holiday pay as percent of salary (11.5% is 0.115) */
    holidayPayPercent?: number | null;
    /** Method for paying holiday bonus in this salary calculation. */
    bonusMethod?: HolidayBonusPaymentMethod | null;
    /** Holiday bonus for the worker (lomaraha, lomaltapaluuraha).
Typically 0.5 for 50%. */
    bonus?: number | null;
}

/** Holiday Accrual for a calendar month in releation to a calculation. */
export interface MonthlyHolidayAccrual {
    /** First day of month for the holiday month */
    month?: string | null;
    /** Holiday accrual for this month.
Note that -1 is indication that accrual should not be updated for this particylar month.
There is no possiblity for negative accrual. */
    daysAccrued?: number | null;
    /** Number of absence days used in the calculation. */
    absencesDays?: number | null;
    /** Work days in determining the accrual for the month in 14 days rule. */
    workDays?: number | null;
    /** Work hours in determining the accrual fot the month in 35 hour rule. */
    workHours?: number | null;
    /** Id of the calculation that this accrual is related to. */
    calcId?: string | null;
}

/** Info covering most important accrual year parameters. */
export interface HolidayAccrualCalcSpecification {
    /** Year as integer */
    year?: number | null;
    /** Defines how the holidays are handled for the worker. */
    code?: HolidayCode | null;
    /** Wage basis for a Holiday Year. */
    wageBasis?: WageBasis | null;
    /** Default accrual for months where the Accrual occurs. */
    defaultAccrual?: number | null;
}

/** Basic information about the taxcard: This object has the information printed in SalarySlip etc. but not the full salaries paid to the taxcard etc. */
export interface TaxcardSnapshot {
    /** Year that the tax card is valid for. Typically this means from February of this year to January of the following. */
    forYear: number;
    /** Validity for the taxcard as expressed in the card.
Note that the end date may not be reliable if new taxcard has replaced this one. */
    validity?: DateRange | null;
    /** Tax percent as percent. I.e. for 50% set 50, not 0.5. */
    taxPercent?: number | null;
    /** Income up to which the TaxPercent can be used.
Any income above the limit is taxed with ExcessTaxPercent. */
    incomeLimit?: number | null;
    /** Cumulative income on the taxcard - including this calculation.
Note that with shared taxcards, this may include income from other employers. */
    cumulativeIncome?: number | null;
    /** Tax percentage that is used in calculating the widthholding tax for the part of income above the IncomeLimit.
This is percent. I.e. for 50% set 50, not 0.5. */
    taxPercent2?: number | null;
    /** A Worker may request a minimum percent that is deducted even if the effective tax percent would be lower.
This can be used if Worker knows that he/she will be earning more in the year than what was estimated when the taxcard was created. */
    taxPercentMin?: number | null;
    /** TaxPercentMin set by owner of the card.
This overrides the tax percent min set by the taxcard sharer. */
    taxPercentMinOwned?: number | null;
    /** The income type of the taxacard if fetched from the tax authorities taxcard API. */
    incomeType?: TaxcardApiIncomeType | null;
    /** Type of the taxcard as of 2019, when the taxcards logic was simplified by the Finnish tazx authorities. */
    kind?: TaxcardKind | null;
    /** Uri to the file copy of the tax card. 
Set by the system as part of the upload process, do not change in the API though it may be technically possible. This may have unintended results. */
    fileUri?: string | null;
    /** Uri to the preview image of the tax card. 
Set by the system as part of the upload process, do not change in the API though it may be technically possible. This may have unintended results. */
    previewUri?: string | null;
    /** Explicit value of when the item was last checked. At the moment, updated in API fetches only, but may be used later for other checks.
Undefined value is 1.1.2000 */
    lastChecked?: string | null;
}

/** For VAT breakdown of a receipt (ALV-erittely) represents a single VAT rate and the revenue and tax with that rate. */
export interface VatEntry {
    /** Tax amount of specific VAT rate in euro.
This value is mandatory, if the collection of VatEntries contains more than one item. */
    tax?: number | null;
    /** Applied VAT rate. This is always mandatory. */
    vatRate?: VatRate | null;
    /** Tax as percent of Net sales (0-1). Currently just informative, but may later be used for Custom non-standard VAT rates. */
    taxPercent?: number | null;
    /** Gross sales for specific VAT rate including the tax (VAT).
This value is mandatory, if the collection of VatEntries contains more than one item. */
    gross?: number | null;
    /** Net sales for specific VAT rate excluding the tax (VAT).
This value is mandatory, if the collection of VatEntries contains more than one item. */
    net?: number | null;
}

/** Reporting details to Incomes registry (Tulorekisteri). */
export interface IrDetails {
    /** The number code in Incomes Register. */
    code?: number | null;
    /** Boolean flags that can be set on transaction. */
    flags?: IrFlags[] | null;
    /** Defines the exceptions to Insurance / Sidecost defaults that are set by the row type. */
    insuranceExceptions?: IrInsuranceExceptions[] | null;
    /** Daily allowance code. */
    dailyAllowance?: AllowanceCode[] | null;
    /** Set this to true if meak benefit is of tax value - false if it si not.
The value should be null if the row is not mealBenefit. */
    mealBenefitIsTaxValue?: boolean | null;
    /** Provides the additional data needed for car benefit. */
    carBenefit?: CarBenefit | null;
    /** If true, report zero amount to IR. */
    noTransactionAmount?: boolean | null;
}

/** Details from Salaxy internal calulcation point-of-view (logic not in IR). */
export interface IrRowCalculationProperties {
    /** Grouping for reports etc. */
    grouping?: CalcGroup | null;
    /** Defines the behavior of the row in Salaxy calculation process. */
    behavior?: CalculationFlag[] | null;
    /** Wage type. Either a built in wage type in Salaxy or a custom wage type created by the user.
Please note that this type fully determines the <see cref="T:Palkkaus.Model.Calc.CalculationRowType"></see> and the kind. */
    type?: string | null;
}

/** Employer groups that are set on Example calculations. These will be replaced by properties from Worker / Employer */
export interface EmployerGroups {
    /** If true, the Employer is a private person.
Otherwise Company or Unknown. */
    isPrivatePerson?: boolean | null;
}

/** Validation errors used in API output. */
export interface ApiValidationError {
    /** Full path to Name of the property / field (Member name in JSON).
This may be null/empty for type General. */
    key?: string | null;
    /** High level type: Specifies the relation to object and its Member. */
    type: ApiValidationErrorType;
    /** Validation error message in the requested language. */
    msg: string;
    /** Validation error long description in the requested language. */
    description?: string | null;
    /** Some error providers may have a unique technical code for error or validator */
    code?: string | null;
}

/** Car benefit Mandatory data group, if the income type is "Car benefit". This data group may not be used with other income types. */
export interface CarBenefit {
    /** Car benefit type */
    carBenefitCode?: CarBenefitCode | null;
    /** Car age group */
    ageGroupCode?: AgeGroupCode | null;
    /** Odometer reading

The value must be greater than or equal to 0 */
    kilometers?: number | null;
    /** Car emissions value

The car emissions value must be greater than or equal to 0, and smaller than or
equal to 100. The car emissions value can only be reported if the payment date
or other reporting date is in 2022–2025. */
    emissionsValue?: number | null;
}

export interface PageResultOfCalculationListItem {
    items?: CalculationListItem[] | null;
    nextPageLink?: string | null;
    count?: number | null;
}

/** Represents a single item in a list of calculations in the user interface. It contains all essential information of the calculation and is basis for searching, filtering and sorting. */
export interface CalculationListItem {
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Person GUID for the owner of the object. */
    ownerId?: string | null;
    /** Metadata for the owner */
    ownerInfo?: AccountInIndex | null;
    /** The main status depending on the type of the object. */
    status?: CalculationStatus | null;
    /** The back office status depending on the type of the object. */
    backOfficeStatus?: string | null;
    /** When the event started. Typically, this is the CreatedAt date, but it may be something else. */
    startAt?: string | null;
    /** This is the end date of the event.
Typically, it is the UserUpdatedAt date, but it may be something else - e.g PaidAt for the calculation. */
    endAt?: string | null;
    /** Gross salary if that is relevant to the transaction. */
    grossSalary?: number | null;
    /** This is the payment from the Owner point-of-view:
Total payment for the Employer and Net salary for the Worker in the case of a calculation.
Only add here the payment, if the payment is really made. */
    payment?: number | null;
    /** Estimated fee of the transaction to Palkkaus.fi. */
    fee?: number | null;
    /** The GUID for the other party. Currently, this is always the PersonID. */
    otherId?: string | null;
    /** The other party (usually a Person) that is involved in the event (e.g Worker if this is a Salary payment by Employer). */
    otherPartyInfo?: AccountInIndex | null;
    /** A very short description describing the object as an event. E.g. "Paid salary" */
    shortText?: string | null;
    /** Business object ids related to this object. E.g. calculations and payrolls in the payment. */
    businessObjects?: string[] | null;
    /** This is valid for calculations only. The estimated date of salary in worker. */
    salaryDate?: string | null;
    /** Business data to include further information of the object. */
    data?: CalculationData | null;
    /** Version number. May be used in conflicts */
    versionNumber?: number | null;
    /** Salaxy uri of the resource. */
    uri?: string | null;
    /** Workflow flags for the object.
Only workflow events with API supported message types are listed. */
    flags?: string[] | null;
    /** Workflow messages for the object.
Only workflow events with API supported message types are listed.
Shown in format "[MessageType]:[Message] ([User] at [UTC-time])" */
    messages?: string[] | null;
    /** Sub category for the payload. E.g. Payment Category, MoneyTransfer Source. */
    entityType?: string | null;
    /** The date for the actual period for which this object is done. */
    logicalDate?: string | null;
    /** Reference information. E.g. Payment or MoneyTransfer reference number. */
    reference?: string | null;
    /** External id for the object in 3rd party system. */
    externalId?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Calculation specific business data for index. */
export interface CalculationData {
    /** A flag indicating if the requested date for the SalaryDate has been set.
If the date has been set, the value of the flag is 'SALA'. */
    requestedSalaryDate?: string | null;
    /** The sum that is at the end paid to the Worker:
Salary payment + expenses */
    workerPayment?: number | null;
    /** The total pension payment for this calculation. */
    pensionPayment?: number | null;
    /** The taxes that were deducted from the worker salary a paid as part of taxation. */
    taxPayment?: number | null;
    /** The social security payment- paid as part of taxation. */
    socialSecurityPayment?: number | null;
    /** Status of the calculation from the end-user point-of-view. */
    status?: CalculationStatus | null;
    /** Payroll id. */
    payrollId?: string | null;
    /** Employment id. */
    employmentId?: string | null;
    /** Use case uri. */
    usecaseUri?: string | null;
    /** The MessageThread Id, if this calculation is referred in a message thread. */
    messageThreadId?: string | null;
    /** Contains the email or id of the responsible for the partner workflow event. */
    partnerMessageAssignedTo?: string | null;
    /** Work start date. */
    workStartDate?: string | null;
    /** Work end date. */
    workEndDate?: string | null;
    /** Payment channel. */
    paymentChannel?: PaymentChannel | null;
    /** Taxable salary is the salary from the taxation point of view - includes some benefits. */
    totalTaxable?: number | null;
    /** Base salary. */
    salary?: number | null;
    /** Salary additions */
    allowances?: number | null;
    /** Benefits. */
    benefits?: number | null;
    /** Deductions */
    deductions?: number | null;
    /** Expenses */
    expenses?: number | null;
}

/** Document in the document flow. */
export interface DocumentFlowItem {
    /** Existing business object in the document flow. */
    item?: IApiListItem | null;
    /** Child items, for example invoices for the calculation. */
    children?: DocumentFlowItem[] | null;
}

/** Interface for the line item for search and listing results. */
export interface IApiListItem {
    /** Person GUID for the owner of the object. */
    ownerId?: string | null;
    /** Metadata for the owner */
    ownerInfo?: AccountInIndex | null;
    /** The back office status depending on the type of the object. */
    backOfficeStatus?: string | null;
    /** When the event started. Typically, this is the CreatedAt date, but it may be something else. */
    startAt?: string | null;
    /** This is the end date of the event.
Typically, it is the UserUpdatedAt date, but it may be something else - e.g PaidAt for the calculation. */
    endAt?: string | null;
    /** Gross salary if that is relevant to the transaction. */
    grossSalary?: number | null;
    /** This is the payment from the Owner point-of-view:
Total payment for the Employer and Net salary for the Worker in the case of a calculation.
Only add here the payment, if the payment is really made. */
    payment?: number | null;
    /** Estimated fee of the transaction to Palkkaus.fi. */
    fee?: number | null;
    /** The GUID for the other party. Currently, this is always the PersonID. */
    otherId?: string | null;
    /** The other party (usually a Person) that is involved in the event (e.g Worker if this is a Salary payment by Employer). */
    otherPartyInfo?: AccountInIndex | null;
    /** A very short description describing the object as an event. E.g. "Paid salary" */
    shortText?: string | null;
    /** Business object ids related to this object. E.g. calculations and payrolls in the payment. */
    businessObjects?: string[] | null;
    /** This is valid for calculations only. The estimated date of salary in worker. */
    salaryDate?: string | null;
    /** Version number. May be used in conflicts */
    versionNumber?: number | null;
    /** Salaxy uri of the resource. */
    uri?: string | null;
    /** Workflow flags for the object.
Only workflow events with API supported message types are listed. */
    flags?: string[] | null;
    /** Workflow messages for the object.
Only workflow events with API supported message types are listed. */
    messages?: string[] | null;
    /** Sub category for the payload. E.g. Payment Category, MoneyTransfer Source. */
    entityType?: string | null;
    /** The date for the actual period for which this object is done. */
    logicalDate?: string | null;
    /** Reference information. E.g. Payment or MoneyTransfer reference number. */
    reference?: string | null;
    /** External id for the object in 3rd party system. */
    externalId?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Pricing partner information. */
    partner?: string | null;
}

/** Calculation is the most important model in the Palkkaus.fi API. We suggest you open the separately provided documentation and especially the class diagram to understand the whole model in detail. */
export interface Calculation {
    /** The employer object for this calculation.
Typically, you do not need to set this before the actual payment process. */
    employer?: CalcEmployer | null;
    /** The Worker (employee) that has performed the work. */
    worker?: CalcWorker | null;
    /** Information about the workflow and state of the calculation. */
    workflow?: CalcWorkflow | null;
    /** The main salary element. 
Alternatively the salary can be set in the Rows object - this will be the only way to set multiple salary rows (not yet supported). */
    salary?: Salary | null;
    /** Set of rows that make up the salary calculation:
Expenses, Benefits, deductions etc. Note that side costs are not rows. */
    rows?: UserDefinedRow[] | null;
    /** DEPRECIATED: Usecase will be replacing this functionality in a next major release.
The Framework Agreement (TES) parameters that affect the framework based side costs etc. of this calculation */
    framework?: TesParameters | null;
    /** A usecase for creating and editing salary calculations.
In practice, a usecase is either a user interface or a microservice that provides a salary calculation
and it may be implemented outside Salaxy.
Provides the possibility to store useacase specific data as part of calculation.
NOTE: This functionality will replace Framework property in a next major release. */
    usecase?: UsecaseData | null;
    /** The results of the calculation. In the API, this is a read-only object. */
    result?: CalculationResult | null;
    /** Information about the work that is not directly related to calculating salary and expenses. */
    info?: CalcInfo | null;
    /** Sharing of the calculation. This object cannot be modified directly, 
use specialized methods in Calculations service. */
    sharing?: CalculationSharing | null;
    /** Contains calculation specific data for accounting (both cost and financial accounting). */
    accounting?: CalculationAccounting | null;
    /** Worktime data that is stored as part of Salary calculation:
work days, absences, holidays and holiday accrual.
In the future may also contain relevant part of timesheet data (work hours). */
    worktime?: CalcWorktime | null;
    /** Readonly workflow data, which is exposed to API. */
    workflowData?: WorkflowData | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Parameters that are changing yearly. This class is made for the change of the year and it is typically updated in December. It is not for recording longer history of numbers. */
export interface YearlyChangingNumbers {
    /** Year for numbers. */
    readonly year?: number | null;
    /** Returns yearly sidecosts. */
    readonly sideCosts?: YearlySideCosts | null;
    /** Returns holidays for the year. */
    holidays?: Holidays | null;
}

/** Encapsulates yearly side costs into one class. */
export interface YearlySideCosts {
    /** Unemployment insurance payment percent - Employer */
    readonly unemploymentEmployerPercent?: number | null;
    /** Unemployment insurance payment percent - Large Employer */
    readonly unemploymentHigherEmployerPercent?: number | null;
    /** Unemployment insurance payment percent - deducted from Worker */
    readonly unemploymentWorkerPercent?: number | null;
    /** Unemployment insurance payment percent for partial owner worker - deducted from Worker */
    readonly unemploymentPartialOwnerWorkerPercent?: number | null;
    /** Pension payment income limit per month */
    readonly tyelIncomeLimit?: number | null;
    /** Pension payment base percentage */
    readonly tyelBasePercent?: number | null;
    /** Pension payment base percentage - deducted from Worker salary */
    readonly tyelWorkerPercent?: number | null;
    /** Pension payment base percentage - deducted from 53-62 year old Worker */
    readonly tyel53Percent?: number | null;
    /** Pension contract employer six month limit */
    readonly tyelContractEmployerLimit?: number | null;
    /** Social Security payment for employer (SAVA-maksu) */
    readonly socSecPercent?: number | null;
    /** Illness Insurance care percent that is withhold from the Worker. (vakuutetun sairausvakuutusmaksu: päivärahamaksu + sairaanhoitomaksu */
    readonly illnessInsurancePercent?: number | null;
    /** Medical care contribution of the employee's health insurance contribution. */
    readonly healthInsuranceMedicalCareContribution?: number | null;
    /** Daily allowance contribution of the employee's health insurance contribution. */
    readonly healthInsuranceDailyAllowanceContribution?: number | null;
    /** Tax free daily allowance for full day approved by tax authorities. */
    readonly taxFreeDailyAllowance?: number | null;
    /** Tax free daily allowance for half day approved by tax authorities. */
    readonly taxFreeDailyHalfAllowance?: number | null;
    /** Tax free meal allowance approved by tax authorities. */
    readonly taxFreeMealAllowance?: number | null;
    /** Tax free bicycle benefit approved by tax authorities. */
    readonly taxFreeBicycleBenefit?: number | null;
    /** Tax free subsidised sommute benefit approved by tax authorities. */
    readonly taxFreeSubsidisedCommute?: number | null;
    /** Tax free milage allowance approved by tax authorities. */
    readonly taxFreeKmAllowance?: number | null;
    /** Union payment: Rakennusliitto, A (typical) */
    readonly unionPaymentRaksaA?: number | null;
    /** Union payment: Rakennusliitto, AO and TA */
    readonly unionPaymentRaksaAoTa?: number | null;
    /** ALV-% for the fee. */
    readonly palkkausVatPercent?: number | null;
    /** ALV-% for the fee. */
    readonly palkkausVatRate?: VatRate | null;
    /** Household deduction */
    readonly householdDeduction?: number | null;
    /** Household deduction */
    readonly householdDeductionExtended?: number | null;
    /** Household deduction max amount */
    readonly householdDeductionMaxAmount?: number | null;
    /** Household deduction max amount */
    readonly householdDeductionMaxAmountExtended?: number | null;
    /** Tax deduction categories, which extend the deduction. */
    readonly householdDeductionCategoriesExtended?: TaxDeductionWorkCategories[] | null;
    /** Household deduction deductible */
    readonly householdDeductionDeductible?: number | null;
    /** Meal benefit for catering contract */
    readonly mealBenefitCateringContract?: number | null;
    /** Meal benefit for institute */
    readonly mealBenefitInstitute?: number | null;
    /** Meal benefit for restaurant worker */
    readonly mealBenefitRestaurantWorker?: number | null;
    /** Meal benefit for teacher */
    readonly mealBenefitTeacher?: number | null;
    /** Meal ticket lower limit */
    readonly mealTicketLowerLimit?: number | null;
    /** Meal ticket upper limit */
    readonly mealTicketUpperLimit?: number | null;
    /** Taxable-% of meal ticket */
    readonly mealTicketTaxable?: number | null;
    /** Foreclosure: protected portion. */
    readonly protectedPortionBase?: number | null;
    /** Foreclosure: protected portion for each dependant. */
    readonly protectedPortionDependant?: number | null;
}

export interface HolidayDate {
    date?: string | null;
    holiday?: Holiday | null;
    readonly holidayGroups?: HolidayGroup[] | null;
    localName?: string | null;
    name?: string | null;
}

/** Holidays for the entire year. */
export interface YearlyHolidays {
    /** Year for the holidays. */
    readonly year?: number | null;
    /** Holidays for the year. */
    readonly holidays?: holidays | null;
}

/** Data that is needed for determening PeriodRecalculationParams and thus at the end recalculating holidays and absences to a calculation. */
export interface PeriodRecalculationData {
    /** The salary calculation that should be recalculated. */
    calc?: Calculation | null;
    /** Current employment data. */
    employment?: Employment | null;
    /** Holiday year with holidays that should be added as salary rows.
If not provided, holidays are not calculated. */
    holidayYear?: HolidayYear | null;
    /** Absences that should be deducted from monthly salary.
If not provided, absences are not calculated. */
    absences?: WorkerAbsences | null;
}

/** Employment relation: The relation between Employer and Worker as well as the personal info of the worker. */
export interface Employment {
    /** General information about the Employment relation. */
    info?: EmploymentRelationInfo | null;
    /** Describes the work that is being performed in this Employment Relation. */
    work?: WorkDescription | null;
    /** Contains values that are needed when creating an employment, but where changing is restricted in the future:
E.g. names and personalId are required when creating a new employment, but once a calculation is created (or at least paid),
editing of theses is no longer possible. See the editing rules for individual properties. */
    identity?: EmploymentIdentity | null;
    /** Properties of the employment for international situations: Working abroad or foreign worker. */
    international?: EmploymentRelationInternational | null;
    /** Contacts stored in the employment. */
    contacts?: ContactAdvanced[] | null;
    /** Usecase is data related to the source and processing of the Employment data outside the Salaxy backend service / system.
Typically, Usecase data would be processed by an external system that has originally created the 
Employment Relation (Worker / Employee in many systems). E.g. expenses system, hourly reporting system. */
    usecase?: UsecaseData | null;
    /** Defines how the holidays are specified to this Worker. */
    holidays?: HolidaySpecification | null;
    /** Contains read-only personal information for the worker typically managed by the Worker account:
Names, personal ID and contact. Currently, this data is edited in Person or WorkerAccount containers, not in the employment relation. */
    personalInfo?: AccountInIndex | null;
    /** If true, the Worker has registered and maintains his / her own personal info.
If false, the Worker account is created and still maintained by the Employer. */
    isRegistered?: boolean | null;
    /** Workflow data, which is exposed to API. */
    workflowData?: WorkflowData | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Holiday year is in Finland from April to end of march. This is the time from which the holidays for the following summer and year are determined. */
export interface HolidayYear {
    /** Year as integer. This value is required when inserting and cannot be edited later. 
Period will be set accordingly, or adjusted in case it is set below. */
    year: number;
    /** Salaxy ID of the worker. This value is required when inserting and cannot be edited later.
WorkerSnapshot is automatically updated upon save. */
    workerId?: string | null;
    /** The employment relation for the worker whose holidays are managed. */
    employmentId: string;
    /** The holiday period for the year: Should always be 2.5.[Year]-30.4.[Year+1] */
    period?: DateRange | null;
    /** Specifies how the holidays are handled.
If the Spec.Code is Undefined in Save, the contents is fetched from the current employment relation. */
    spec?: HolidaySpecificationForYear | null;
    /** Calculated Holiday pay for the year. */
    holidayPay?: HolidayPay | null;
    /** Accrual of holidays (lomakirjanpito). */
    accrual?: HolidayAccrual | null;
    /** Payments related to Annual Leaves (holidays). */
    leaves?: AnnualLeaves | null;
    /** Basic information for the Worker. 
Automatically updated upon save based on WorkerId.
Mainly for the listings etc. */
    workerSnapshot?: Avatar | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** General information about the Employment relation. */
export interface EmploymentRelationInfo {
    /** The Account ID of the Worker if Worker */
    workerAccountId?: string | null;
    /** Identifier in a source system. Used in imports etc. */
    sourceId?: string | null;
    /** User friendly employment relation type that is used to set other more technical types and Incomes Registry properties. */
    type?: EmploymentRelationType | null;
    /** The bank account number for salary payment. */
    ibanNumber?: string | null;
    /** Type of additional income earner data by National Incomer Register classification . If several types apply, all of them should be selected. */
    irIncomeEarnerTypes?: IncomeEarnerType[] | null;
    /** Type for the pension insurance. */
    pensionCalculation?: PensionCalculation | null;
    /** Rules (e.g. effect of monthly lower limit) for pension calculation. */
    pensionRule?: PensionRule | null;
    /** The id of the pension company. */
    pensionCompany?: PensionCompany | null;
    /** The pension contract number. */
    pensionContractNumber?: string | null;
    /** The id of the insurance company. */
    insuranceCompany?: InsuranceCompany | null;
    /** The accident insurance contract number. */
    insuranceContractNumber?: string | null;
    /** Taxcard type from the employment point of view. */
    taxcard?: EmploymentRelationTaxcard | null;
    /** Status of this employment relationship */
    status?: EmploymentRelationStatus | null;
    /** Worker's preferred salary payment method: bank account, external etc. */
    salaryPaymentMethod?: EmploymentRelationSalaryPaymentMethod | null;
    /** Start date of the Employment Relation. */
    startDate?: string | null;
    /** End date of the Employment Relation. */
    endDate?: string | null;
    /** Duration of the employment. If true, the employment relation is for a fixed term.
Otherwise (which is the default) the employment relation continues until further notice. */
    isFixedTerm?: boolean | null;
    /** Indicates that the employment relation has been terminated.
Saving with this status also makes the employment relation Archived. */
    isTerminated?: boolean | null;
    /** Employment registration code for Incomes Registry. */
    employmentRegCode?: string | null;
}

/** Describes the work that is being performed - mainly for Employment relation purposes. */
export interface WorkDescription {
    /** Free text description of the work that is being performed. */
    description?: string | null;
    /** Occupation classification, used at least for Accident insurance purposes, but may be used for other reporting. 
For Finnish Salaries use the Statistics Finland 
"Classification of Occupations 2010" (TK10): https://www.stat.fi/meta/luokitukset/ammatti/017-2018-05-15/index_en.html */
    occupationCode?: string | null;
    /** Secondary occupation classification. Some earnings payment reports may require two occupation codes. */
    occupationCode2?: string | null;
    /** Contains default calculation rows for the worker.
Typically used for setting for example monthly salary or hourly salary price for workers. */
    salaryDefaults?: UserDefinedRow[] | null;
    /** Default bases for wage. */
    wageBasis?: WageBasis | null;
    /** Number of hours per month defined in the employment contract. */
    monthlyHours?: number | null;
    /** Contains calculation specific data for accounting (both cost and financial accounting). */
    accounting?: CalculationAccounting | null;
}

/** Contains values that are needed when creating an employment, but where changing is restricted in the future: E.g. names and personalId are required when creating a new employment, but once a calculation is created (or at least paid), editing of theses is no longer possible. See the editing rules for individual properties. */
export interface EmploymentIdentity {
    /** First name of the Worker. Value is required when creating a new employment, it cannot be modified after initial create:
Instead you should just delete the Worker (only allowed if no paid salaries etc.) and create a new one. */
    firstName?: string | null;
    /** Last name of the worker. Editing rules are the same as with FirstName. */
    lastName?: string | null;
    /** Personal ID (hetu) of the worker (currently required). Editing rules are the same as with FirstName. */
    personalId?: string | null;
    /** Avatar picture. If set, this is used in avatar instead of Initials (automatic FirstName/LastName) and color.
May be changed until the Worker registers to the service. After this, the Worker can upload their own image or choose to remove the image. */
    avatarImg?: string | null;
    /** Avatar color for visual icon together with initials. Use web compatible rgb values, e.g. "#FF00FF" or "rgb(255, 0, 255)".
Editing rules are the same as with AvatarImg. */
    color?: string | null;
    /** Language of the user in user interfaces and print-outs (most significantly the salary slip).
Editing rules are the same as with AvatarImg. */
    language?: Language | null;
}

/** Properties of the employment for international situations: Working abroad or foreign worker. */
export interface EmploymentRelationInternational {
    /** Country of residence for non-recident of Finland (rajatusti verovelvollinen) */
    country?: Country | null;
    /** Identifier for non-recident of Finland in the country of residence.
Type of the identifier is specified in IdType. */
    foreignId?: string | null;
    /** Type of ForeignId. */
    idType?: InternationalIdentifier | null;
    /** The non-resident taxcard (or percent without taxcard) that is used if the taxcard in Employment.Info.Taxcard is set to TaxAtSource. */
    taxAtSource?: TaxAtSource | null;
    /** Types of social security for international situations. */
    socialSecurity?: InternationalSocialSecurityType | null;
    /** Exceptions to standard social security cases. */
    socialSecurityExceptions?: InternationalSocialSecurityException[] | null;
}

/** Advanced contact information with strongly typed country and type information. */
export interface ContactAdvanced {
    /** Type of contact when specification allows several contacts. */
    type?: ContactType | null;
    /** Contact e-mail address. Always lower invariant, trimmed and empty string set to null. */
    email?: string | null;
    /** Telephone number */
    telephone?: string | null;
    /** Street address */
    street?: string | null;
    /** Postal code */
    postalCode?: string | null;
    /** City or community (postitoimipaikka) */
    city?: string | null;
    /** Country as defined as */
    country?: Country | null;
    /** Name of the country as free text if Country is Other. */
    countryOtherName?: string | null;
}

/** Specifies how the holidays are handled for this Worker. */
export interface HolidaySpecification {
    /** Defines how the holidays are handled for the worker. */
    code?: HolidayCode | null;
    /** Defines how the holiday pay is calculated. */
    holidayPayCalculation?: HolidayPayCalculation | null;
    /** Defines the number of holidays that the worker is entitled per month worked.
If the value is set to 0 (default), the number is 2 for first year and 2,5 thereafter as defined in the law.
To actually se the daysPerMonth to zero, use code value other than Permanent14Days or Permanent35Hours. */
    accrualFixed?: number | null;
    /** For {Palkkaus.Model.Worktime.Holidays.HolidayPayCalculation.HolidayCompensation} the compensation percent.
Holiday compensation as percent of salary (11.5% is 0.115) */
    compensation?: number | null;
    /** For {Palkkaus.Model.Worktime.Holidays.HolidayPayCalculation.PercentageBasedPay} the percent.
Holiday pay as percent of salary (11.5% is 0.115) */
    holidayPayPercent?: number | null;
    /** Method for paying holiday bonus in this salary calculation. */
    bonusMethod?: HolidayBonusPaymentMethod | null;
    /** Holiday bonus for the worker (lomaraha, lomaltapaluuraha).
Typically 0.5 for 50%. */
    bonus?: number | null;
}

/** Calculated holiday pay for the year. */
export interface HolidayPay {
    /** Calculated price for a single holiday day based on the regular monthly salary.
Please note that this is applicable for accounting purposes (holiday pay debt) only. */
    readonly normalMonthlyPayDailySalary?: number | null;
    /** The picked monthly salary from the holiday year's calculations.
Please note that the calculator logic does not use this value but the NormalMonthlyPayManual or enterd monthly salary in the calculation. */
    readonly normalMonthlyPay?: number | null;
    /** For NormalMonthlyPay the manually entered regular monthly salary. */
    normalMonthlyPayManual?: number | null;
    /** For AverageDailyPay the calculated price for a single holiday day. */
    averageDailyPayDailySalary?: number | null;
    /** For AverageDailyPay the calculated average daily pay. */
    averageDailyPay?: number | null;
    /** For AverageDailyPay the manually entered average daily pay. */
    averageDailyPayManual?: number | null;
    /** For AverageDailyPay the total pay received or due for time worked during the holiday credit year. */
    averageDailyPayBase?: number | null;
    /** For AverageDailyPay the number of days the employee was at work.
This number does not include the one eighth of the hours worked in excess of the  statutory regular daily working hours which is added to the number of days at work used in the calculation. */
    averageDailyPayDays?: number | null;
    /** Multiplier used in the calculation of the average daily pay. */
    averageDailyPayMultiplier?: number | null;
    /** For AverageHourlyPay the calculated price for a single holiday day. */
    averageHourlyPayDailySalary?: number | null;
    /** For AverageHourlyPay the calculated average hourly pay. */
    averageHourlyPay?: number | null;
    /** For AverageHourlyPay the manually entered average hourly pay. */
    averageHourlyPayManual?: number | null;
    /** For AverageHourlyPay the total pay received or due for time worked during the holiday credit year. */
    averageHourlyPayBase?: number | null;
    /** For AverageHourlyPay the number of hours the employee was at work. */
    averageHourlyPayHours?: number | null;
    /** Multiplier used in the calculation of the average hourly pay. */
    averageHourlyPayMultiplier?: number | null;
    /** For PercentageBasedPay the calculated price for a single holiday day. */
    percentageBasedPayDailySalary?: number | null;
    /** For PercentageBasedPay the calculated total holiday pay. */
    percentageBasedPay?: number | null;
    /** For PercentageBasedPay the manually entered total holiday pay. */
    percentageBasedPayManual?: number | null;
    /** For PercentageBasedPay the total pay received or due for time worked during the holiday credit year. */
    percentageBasedPayBase?: number | null;
    /** For PercentageBasedPay the percent for the calculation. */
    percentageBasedPayPercent?: number | null;
    /** For OtherPay the manually entered pay, the price for a single holiday day. */
    otherPay?: number | null;
    /** For HolidayCompensation the calculated price for a single holiday day. */
    compensationPayDailySalary?: number | null;
    /** For HolidayCompensation the calculated total holiday compensation pay. */
    compensationPay?: number | null;
    /** For HolidayCompensation the manually entered total holiday compensation pay. */
    compensationPayManual?: number | null;
    /** For HolidayCompensation the total pay received or due for time worked during the holiday credit year. */
    compensationPayBase?: number | null;
    /** Accrual used in the calculation of the holiday daily pay. */
    accrual?: number | null;
}

/** Yearly log for Holiday accrual. */
export interface HolidayAccrual {
    /** Holiday accrual entries during the period. */
    months?: HolidayAccrualEntry[] | null;
    /** The period for holiday accrual.
This is also the period of the holiday year that the Worker is Employed,
i.e. it may be shorter than HolidayYear Period if the employment relation 
begins or ends within the holiday year. */
    period?: DateRange | null;
    /** Default accrual for months where the Accrual occurs.
When Holiday year is recalculated, this is determined either from Employment Period or AccrualFixed if set. */
    defaultAccrual?: number | null;
    /** Start saldo from the previous year. */
    startSaldo?: number | null;
    /** Total for the current year. This does not include Start saldo. */
    readonly total?: number | null;
    /** End saldo from the previous year. This is Total + Start Saldo. */
    readonly endSaldo?: number | null;
}

/** Data about the annual leaves planned and used during the holiday year. */
export interface AnnualLeaves {
    /** Planned annual leaves. */
    planned?: AnnualLeave[] | null;
    /** Paid or otherwise handled annual leaves.
PRELIMINARY: This property is under revision - it may be moved or renamed without being a breaking change. */
    paid?: AnnualLeavePayment[] | null;
}

/** The information about tax at source, typically from  non-resident taxcard (lähdeverokortti) for non-residents. */
export interface TaxAtSource {
    /** Tax percent. As of writing, this is 35% by default and 15% for athletes and performingg artists,
but the percentage may change and bust be checked from the taxcard (or legistlattion if there is no card available). */
    percent?: number | null;
    /** Monthly deduction (e.g. 510 €/month) if one can be used for this card. */
    deductionMonthly?: number | null;
    /** Daily deduction (e.g. 17 €/day) if one can be used for this card. */
    deductionDaily?: number | null;
}

/** Entry in the Yearly Holiday Accrual list. */
export interface HolidayAccrualEntry {
    /** Index of the month from 0-11 for easier iteration.
This is also the real identifier of the month when editing the entries through API.
Months 4-12 are index 0-8 and month 1-3 are index 9-11 */
    index?: number | null;
    /** First day of month for the holiday month */
    month?: string | null;
    /** Days added to holiday Accrual: Typically days per month. */
    daysAccrued?: number | null;
    /** Source of the holiday accrual. */
    source?: HolidayAccrualSource | null;
    /** Identier of the calculation if Kind */
    calcId?: string | null;
    /** Additional information as recorded by the Employer. */
    notes?: string | null;
}

/** A planned annual Leave - not sure whether it will kept or is it just planned */
export interface AnnualLeave {
    /** Identifies a single leave. */
    id?: string | null;
    /** The planned holiday period. */
    period?: DateRange | null;
    /** Additional information as recorded by the Employer. */
    notes?: string | null;
}

/** Payment related to annual leave: holiday salary, bonus and compensation */
export interface AnnualLeavePayment {
    /** Type of the payment entry */
    kind?: AnnualLeavePaymentKind | null;
    /** The reference date: Typically the Paid at date.
The items are typically sorted based on this. */
    date?: string | null;
    /** Days of holidays that are paid or compensated */
    holidayDays?: number | null;
    /** Salary that is paid for holidays */
    holidaySalary?: number | null;
    /** Compensation that is paid for holidays not kept. */
    holidayCompensation?: number | null;
    /** Bonus for either Holiday Salary or Compensation. */
    holidayBonus?: number | null;
    /** If the payment is defined by a calculation, stores the calculation ID. */
    calcId?: string | null;
    /** If true, the payment can be ignored. */
    isDisabled?: boolean | null;
    /** Identifies a single leave. */
    id?: string | null;
    /** The planned holiday period. */
    period?: DateRange | null;
    /** Additional information as recorded by the Employer. */
    notes?: string | null;
}

/** Represents a calendar event in iCalendar compatible way. */
export interface CalendarEvent {
    /** Type of object that stores the event recurrence.
Type of CalendarEvent is stored separately into the database and all properties can be edited.
For other types, you need edit the original object (Calculation, Payload etc.) */
    payloadType?: ApiItemType | null;
    /** The part of the data that provides the compliance to iCalendar VEVENT data model defined in RFC 5545, 
not including the properties that are standard in Salaxy (e.g. id/uid, createdAt etc.). */
    event?: CalendarVEvent | null;
    /** Occurence information based on the event. */
    occurenceInfo?: CalendarEventOccurenceInfo | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Stores the calendar even data that is compatible with RFC 5545 VEVENT component. */
export interface CalendarVEvent {
    /** Unique identifier: This is the ID of the parent. */
    uid?: string | null;
    /** Timestamp for the item: This may be important for processing of items to some calendar items, hence stored separately from other dates. */
    timeStamp?: string | null;
    /** The start date/time of the event.
NOTE, unlike in iCalendar, in our model Start is always required and then either End or Duration is used to determine the duration. */
    start?: string | null;
    /** The end date/time of the event.
Note that if Duration is set, it will override this property whenever saved or recalculated. */
    end?: string | null;
    /** The duration of the event. 
Note that if set to something else than null / zero, this property will always override the End date/datetime. */
    duration?: string | null;
    /** Returns true if the event is an all-day event: Start and End are dates ("yyyy-MM-dd"), not date-times ("yyyy-MM-ddThh:mm:ss"). */
    isAllDay?: boolean | null;
    /** The event status as defined in https://tools.ietf.org/html/rfc5545#section-3.8.1.11
or in Salaxy process. Other statuses default to undefined. */
    status?: CalendarEventStatus | null;
    /** Short, one-line summary: Text that is typically shown in calendar views. */
    summary?: string | null;
    /** Categorization of the event */
    categories?: string[] | null;
    /** The attendees for the event. */
    attendees?: CalendarAttendee[] | null;
    /** The Alarms (notifications) and other Actions (scripts) related to the event. */
    actions?: CalendarAction[] | null;
    /** Priority is specified as an integer in the range 0 to 9.
A value of 0 specifies an undefined priority.
A value of 1 is the highest priority, 1-4=HIGH, 5=MEDIUM/Normal and 6-9=LOW.
Negative values may be used by admin functions (not through API) to set priority overrides. */
    priority?: number | null;
    /** The full description text. */
    description?: string | null;
    /** Attachments for calendar events. */
    attachments?: CalendarAttachment[] | null;
    /** The recurrence rules as specified in iCalendar: https://tools.ietf.org/html/rfc5545#section-3.3.10 and https://tools.ietf.org/html/rfc5545#section-3.8.5.3
E.g. "FREQ=DAILY;INTERVAL=10;COUNT=5" */
    recurrenceRules?: string[] | null;
    /** Constant recurrence dates specified by RDATE in iCalendar */
    recurrenceDates?: string[] | null;
    /** Exception dates specified by EXDATE in iCalendar */
    exceptionDates?: string[] | null;
    /** When imported from external system, this contains the original Uid. Null for items created by Salaxy. */
    originalUid?: string | null;
}

/** Information about the occurences of the calendar event when the event was last stored into the storage. */
export interface CalendarEventOccurenceInfo {
    /** If true, the event is a recurring */
    isRecurring?: boolean | null;
    /** First occurence of the event */
    occurencesStart?: string | null;
    /** Last occurence of the event. Please note that only max 1 year from today is calculated. */
    occurencesEnd?: string | null;
    /** Next occurences (max 100) */
    next?: CalendarOccurence[] | null;
    /** Dictionary of executed actions. */
    executedActions?: { [key: string]: string; } | null;
}

/** Describes the calendar attendees in an avatar-visualization compatible way. */
export interface CalendarAttendee {
    /** Account or Credentials uri IF the attendee is a Palkkaus.fi account. Otherwise null. */
    uri?: string | null;
    /** The display name of the attendee (CN) */
    displayName?: string | null;
    /** The E-mail address of the person */
    email?: string | null;
    /** Entity type: person/company. In calendar attendees, defaults to Person. */
    entityType?: LegalEntityType | null;
    /** Type of the Avatar picture. */
    pictureType?: AvatarPictureType | null;
    /** Color - currently only used by type Icon */
    color?: string | null;
    /** Initials - used by PictureType Icon */
    initials?: string | null;
    /** URL of the picture if specified as picture (null in a case of type Icon) */
    url?: string | null;
}

/** Salaxy calendar action is an extension to iCalendar Alarms: It supports the standard alarms: Display, Email and Audio, but also salaxy action scripts. */
export interface CalendarAction {
    /** Unique identifier in the Salaxy context. */
    id?: string | null;
    /** Action type */
    type?: CalendarActionType | null;
    /** Summary text for the action. Subject for E-mail */
    summary?: string | null;
    /** Description text for the action. Body text for Email, Notification message for Display. */
    description?: string | null;
    /** Attendees are E-mail receivers for Email Alert and potentially Display notifications in the future. 
Script actions may also later use them when credentials, accounts or similar are needed fro execution. */
    attendees?: CalendarAttendee[] | null;
    /** Attachment files for the action. Attachments for E-mail. */
    attachments?: CalendarAttachment[] | null;
    /** The duration trigger. Either this or TriggerDateTime must specified. */
    triggerDuration?: string | null;
    /** The fixed date-time trigger. Only used if, Duration is not available.
NOTE that Salaxy implements this feature a bit differently than rfc-5545: The spec says that for a repeating event, 
the alarm should trigger only once (+repeat), but current Salaxy implementation would trigger the alarm the amount of items. */
    triggerDateTime?: string | null;
    /** If specified, the action repeats number of times (in addition to the initial trigger) specified in this parameter with RepeatDuration values.
If Repeat is more than 0, also RepeatDuration must be specified. */
    repeat?: number | null;
    /** Time between the repeats aftern the initial repeat. */
    repeatDuration?: string | null;
}

/** Attachment for calendar event or Action/Alarm. */
export interface CalendarAttachment {
    /** URI of the attachment. This is the default way of specifying attachments.
TODO: Check if the Uri data type works in API. If not, switch to string. */
    uri?: string | null;
    /** Attachment as inline data. Encoded with ValueEncoding. */
    data?: string | null;
    /** The file format type / mime type (e.g. "text/plain"). */
    formatType?: string | null;
    /** Encoding for the inline data.
TODO: Consider making read-only. */
    valueEncoding?: string | null;
}

/** Occurence of a calendar event */
export interface CalendarOccurence {
    /** Identifier of the event that produces this occurence */
    eventId?: string | null;
    /** Summary text for occurence. Max 255 characters. */
    summary?: string | null;
    /** Categorization of the event */
    categories?: string[] | null;
    /** Indicates that the time of the recurrence is irrelevant: Just display the date.
NOTE that in Occurences, when IsAllDay=true, the End is the date when occurence ends (typically same as Start), not the next day as in VEVENT. */
    isAllDay?: boolean | null;
    /** If true, the occurence is based on a recurrence rule. */
    isRecurring?: boolean | null;
    /** The start date/time of the event as ISO 8601 Date ("yyyy-MM-dd") or DateTime ("s"/"yyyy-MM-ddThh:mm:ss") without timezone.
Value should be Date when IsAllDay is true and DateTime, when it is false. */
    start?: string | null;
    /** The end date/time of the event as ISO 8601 Date ("yyyy-MM-dd") or DateTime ("s"/"yyyy-MM-ddThh:mm:ss") without timezone.
Value should be Date when IsAllDay is true and DateTime, when it is false. */
    end?: string | null;
    /** The duration of the event. */
    duration?: string | null;
    /** Collection of action occurences for this event occurence. */
    actions?: CalendarActionOccurence[] | null;
}

/** Occurence of an Action (Alarm in iCalendar) within a Calendar occurence. */
export interface CalendarActionOccurence {
    /** Identifier of the event that produces this action occurence */
    eventId?: string | null;
    /** Identifier of the action that produces this occurence */
    actionId?: string | null;
    /** Action type */
    type?: CalendarActionType | null;
    /** The date/date-time this action is executed. */
    start?: string | null;
    /** Indicates that the time of the recurrence (start) is irrelevant: Just display the date. */
    isAllDay?: boolean | null;
    /** Summary text for occurence. Max 255 characters. */
    summary?: string | null;
}

export interface PageResultOfCalendarEventListItem {
    items?: CalendarEventListItem[] | null;
    nextPageLink?: string | null;
    count?: number | null;
}

/** Represents a single item in a list of calendar events in the search index. */
export interface CalendarEventListItem {
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Person GUID for the owner of the object. */
    ownerId?: string | null;
    /** Metadata for the owner */
    ownerInfo?: AccountInIndex | null;
    /** The main status depending on the type of the object. */
    status?: CalendarEventStatus | null;
    /** The back office status depending on the type of the object. */
    backOfficeStatus?: string | null;
    /** When the event started. Typically, this is the CreatedAt date, but it may be something else. */
    startAt?: string | null;
    /** This is the end date of the event.
Typically, it is the UserUpdatedAt date, but it may be something else - e.g PaidAt for the calculation. */
    endAt?: string | null;
    /** Gross salary if that is relevant to the transaction. */
    grossSalary?: number | null;
    /** This is the payment from the Owner point-of-view:
Total payment for the Employer and Net salary for the Worker in the case of a calculation.
Only add here the payment, if the payment is really made. */
    payment?: number | null;
    /** Estimated fee of the transaction to Palkkaus.fi. */
    fee?: number | null;
    /** The GUID for the other party. Currently, this is always the PersonID. */
    otherId?: string | null;
    /** The other party (usually a Person) that is involved in the event (e.g Worker if this is a Salary payment by Employer). */
    otherPartyInfo?: AccountInIndex | null;
    /** A very short description describing the object as an event. E.g. "Paid salary" */
    shortText?: string | null;
    /** Business object ids related to this object. E.g. calculations and payrolls in the payment. */
    businessObjects?: string[] | null;
    /** This is valid for calculations only. The estimated date of salary in worker. */
    salaryDate?: string | null;
    /** Business data to include further information of the object. */
    data?: CalendarEventData | null;
    /** Version number. May be used in conflicts */
    versionNumber?: number | null;
    /** Salaxy uri of the resource. */
    uri?: string | null;
    /** Workflow flags for the object.
Only workflow events with API supported message types are listed. */
    flags?: string[] | null;
    /** Workflow messages for the object.
Only workflow events with API supported message types are listed.
Shown in format "[MessageType]:[Message] ([User] at [UTC-time])" */
    messages?: string[] | null;
    /** Sub category for the payload. E.g. Payment Category, MoneyTransfer Source. */
    entityType?: string | null;
    /** The date for the actual period for which this object is done. */
    logicalDate?: string | null;
    /** Reference information. E.g. Payment or MoneyTransfer reference number. */
    reference?: string | null;
    /** External id for the object in 3rd party system. */
    externalId?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Calendar event specific business data for index. */
export interface CalendarEventData {
    /** The start date/time of the event. */
    start?: string | null;
    /** The end date/time of the event. */
    end?: string | null;
    /** The duration of the event. */
    duration?: string | null;
    /** Recurrence rules as a CRLF separted string. */
    rRules?: string | null;
    /** Returns true if the event is a recurring event: RRules or Recurrence dates.. */
    isRecurring?: boolean | null;
    /** Returns true if the event is an all-day event. */
    isAllDay?: boolean | null;
    /** Priority is specified as an integer in the range 0 to 9.
A value of 0 specifies an undefined priority.
A value of 1 is the highest priority, 1-4=HIGH, 5=MEDIUM/Normal and 6-9=LOW.
Negative values may be used by admin functions (not through API) to set priority overrides. */
    priority?: number | null;
    /** Status as string */
    status?: string | null;
}

/** Customer invoice is an invoice from Palkkaus / Salaxy to Customer / Partner: Invoice for the usage of service. */
export interface CustomerInvoice {
    /** Header-level information about the invoice. */
    info?: CustomerInvoiceInfo | null;
    /** The data that is the bases for invoicing e.g. calculations, monthly active users etc. */
    bases?: CustomerInvoicingBases[] | null;
    /** If not null, contains a final invoice in Laskupiste format. */
    invoice?: LaskupisteInvoice | null;
    /** Readonly workflow data, which is exposed to API. */
    workflowData?: WorkflowData | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Header level data for the customer invoices. */
export interface CustomerInvoiceInfo {
    /** Status of this invoice entry. */
    status?: CustomerInvoiceStatus | null;
    /** Count of companies (end-customers) in this invoice. */
    companyCount?: number | null;
}

/** Represents the data that is the bases for invoicing e.g. calculations, monthly active users etc. */
export interface CustomerInvoicingBases {
    id?: string | null;
    date?: string | null;
    product?: string | null;
    companyId?: string | null;
    partnerId?: string | null;
    amount?: number | null;
    meta?: { [key: string]: any; } | null;
}

export interface LaskupisteInvoice {
    id?: number | null;
    customerId?: number | null;
    currency?: string | null;
    orderedDate?: string | null;
    invoiceNumber?: number | null;
    invoiceName?: string | null;
    rows?: LaskupisteInvoiceRow[] | null;
    invoiceState?: string | null;
}

/** Single invoice row for Laskupiste */
export interface LaskupisteInvoiceRow {
    productId?: number | null;
    name?: string | null;
    amount?: number | null;
    amountType?: string | null;
    unitPrice?: number | null;
    vatPercent?: number | null;
    specifier?: string | null;
    specifierType?: string | null;
    meta?: { [key: string]: any; } | null;
}

export interface PageResultOfCustomerInvoiceListItem {
    items?: CustomerInvoiceListItem[] | null;
    nextPageLink?: string | null;
    count?: number | null;
}

/** Represents a single item in a list of Customer invoices. Customer invoices are service invoices from Palkkaus / Salaxy to customers and partners. */
export interface CustomerInvoiceListItem {
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Person GUID for the owner of the object. */
    ownerId?: string | null;
    /** Metadata for the owner */
    ownerInfo?: AccountInIndex | null;
    /** The main status depending on the type of the object. */
    status?: CustomerInvoiceStatus | null;
    /** The back office status depending on the type of the object. */
    backOfficeStatus?: string | null;
    /** When the event started. Typically, this is the CreatedAt date, but it may be something else. */
    startAt?: string | null;
    /** This is the end date of the event.
Typically, it is the UserUpdatedAt date, but it may be something else - e.g PaidAt for the calculation. */
    endAt?: string | null;
    /** Gross salary if that is relevant to the transaction. */
    grossSalary?: number | null;
    /** This is the payment from the Owner point-of-view:
Total payment for the Employer and Net salary for the Worker in the case of a calculation.
Only add here the payment, if the payment is really made. */
    payment?: number | null;
    /** Estimated fee of the transaction to Palkkaus.fi. */
    fee?: number | null;
    /** The GUID for the other party. Currently, this is always the PersonID. */
    otherId?: string | null;
    /** The other party (usually a Person) that is involved in the event (e.g Worker if this is a Salary payment by Employer). */
    otherPartyInfo?: AccountInIndex | null;
    /** A very short description describing the object as an event. E.g. "Paid salary" */
    shortText?: string | null;
    /** Business object ids related to this object. E.g. calculations and payrolls in the payment. */
    businessObjects?: string[] | null;
    /** This is valid for calculations only. The estimated date of salary in worker. */
    salaryDate?: string | null;
    /** Business data to include further information of the object. */
    data?: CustomerInvoiceListItemData | null;
    /** Version number. May be used in conflicts */
    versionNumber?: number | null;
    /** Salaxy uri of the resource. */
    uri?: string | null;
    /** Workflow flags for the object.
Only workflow events with API supported message types are listed. */
    flags?: string[] | null;
    /** Workflow messages for the object.
Only workflow events with API supported message types are listed.
Shown in format "[MessageType]:[Message] ([User] at [UTC-time])" */
    messages?: string[] | null;
    /** Sub category for the payload. E.g. Payment Category, MoneyTransfer Source. */
    entityType?: string | null;
    /** The date for the actual period for which this object is done. */
    logicalDate?: string | null;
    /** Reference information. E.g. Payment or MoneyTransfer reference number. */
    reference?: string | null;
    /** External id for the object in 3rd party system. */
    externalId?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Customer Invoice specific business data for index. */
export interface CustomerInvoiceListItemData {
    /** Number of end-companies in the invoice. */
    companyCount?: number | null;
}

/** Dataset models some arbitrary data that is store in storage. This is any data that is not "strongly modeled", for example: Imports from / exports to external systems, reports, data analyses and control data for batch processes. */
export interface Dataset {
    /** Editable metadata info about a dataset. */
    info?: DatasetInfo | null;
    /** The payload of the dataset: The objects or tables that are stored. */
    data?: DatasetDataObject[] | null;
    /** Usecase is data related to the source and processing of the Employment data outside the Salaxy backend service / system.
Typically, Usecase data would be processed by an external system that has originally created the 
Employment Relation (Worker / Employee in many systems). E.g. expenses system, hourly reporting system. */
    usecase?: UsecaseData | null;
    /** Readonly workflow data, which is exposed to API. */
    workflowData?: WorkflowData | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Editable metadata info about a dataset. */
export interface DatasetInfo {
    /** Status of the dataset. */
    status?: DatasetStatus | null;
    /** End-user friendly label that describes the dataset in listings etc. */
    label?: string | null;
    /** The logical type / purpose of the dataset. */
    type?: DatasetType | null;
}

export interface DatasetDataObject {
    /** Technical name (unique key) for the data object */
    name?: string | null;
    /** User friendly label. */
    label?: string | null;
    /** Schema document that contains the schema. */
    schemaDoc?: string | null;
    /** Identifier / path to the schema that defines the data structure for the content. */
    schema?: string | null;
    /** If true, the schema should be interpreted as an array (display in table by default). */
    isArray?: boolean | null;
    /** Data payload / content of the object. */
    content?: any[] | null;
    /** Potential validation data for content.
Note that in many scenarios, validation may not be done / may not be serialized to storage so this property may be null. */
    validation?: ApiValidation | null;
    /** Defines one or multiple views for the dataset object. Typically this is fields to include / exclude from
the views and definitions on how the views should be formatted / edited.
First view is considered the default view and some UI's will only support that one view. */
    views?: DatasetView[] | null;
}

/** Defines a view, typically an array view, for a dataset. */
export interface DatasetView {
    /** Properties / columns that should be shown in the view.
These may be either simple column names or property paths (e.g. "personalInfo.avatar.sortableName") for hierarchical objects. */
    include?: string[] | null;
    /** Properties / columns that should be shown excluded from the view.
Exclusion is used only if Include is not set and it is applied to the "default view":
Default view depends on the renderer, but it is typically just the first level of a hierarchical view,
so exclude values are typically just simple column / property names, not property paths. */
    exclude?: string[] | null;
}

export interface PageResultOfDatasetListItem {
    items?: DatasetListItem[] | null;
    nextPageLink?: string | null;
    count?: number | null;
}

/** Represents a single item in a list of datasets. */
export interface DatasetListItem {
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Person GUID for the owner of the object. */
    ownerId?: string | null;
    /** Metadata for the owner */
    ownerInfo?: AccountInIndex | null;
    /** The main status depending on the type of the object. */
    status?: DatasetStatus | null;
    /** The back office status depending on the type of the object. */
    backOfficeStatus?: string | null;
    /** When the event started. Typically, this is the CreatedAt date, but it may be something else. */
    startAt?: string | null;
    /** This is the end date of the event.
Typically, it is the UserUpdatedAt date, but it may be something else - e.g PaidAt for the calculation. */
    endAt?: string | null;
    /** Gross salary if that is relevant to the transaction. */
    grossSalary?: number | null;
    /** This is the payment from the Owner point-of-view:
Total payment for the Employer and Net salary for the Worker in the case of a calculation.
Only add here the payment, if the payment is really made. */
    payment?: number | null;
    /** Estimated fee of the transaction to Palkkaus.fi. */
    fee?: number | null;
    /** The GUID for the other party. Currently, this is always the PersonID. */
    otherId?: string | null;
    /** The other party (usually a Person) that is involved in the event (e.g Worker if this is a Salary payment by Employer). */
    otherPartyInfo?: AccountInIndex | null;
    /** A very short description describing the object as an event. E.g. "Paid salary" */
    shortText?: string | null;
    /** Business object ids related to this object. E.g. calculations and payrolls in the payment. */
    businessObjects?: string[] | null;
    /** This is valid for calculations only. The estimated date of salary in worker. */
    salaryDate?: string | null;
    /** Business data to include further information of the object. */
    data?: DatasetListItemData | null;
    /** Version number. May be used in conflicts */
    versionNumber?: number | null;
    /** Salaxy uri of the resource. */
    uri?: string | null;
    /** Workflow flags for the object.
Only workflow events with API supported message types are listed. */
    flags?: string[] | null;
    /** Workflow messages for the object.
Only workflow events with API supported message types are listed.
Shown in format "[MessageType]:[Message] ([User] at [UTC-time])" */
    messages?: string[] | null;
    /** Sub category for the payload. E.g. Payment Category, MoneyTransfer Source. */
    entityType?: string | null;
    /** The date for the actual period for which this object is done. */
    logicalDate?: string | null;
    /** Reference information. E.g. Payment or MoneyTransfer reference number. */
    reference?: string | null;
    /** External id for the object in 3rd party system. */
    externalId?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Dataset specific business data for index. */
export interface DatasetListItemData {
    /** Key for the usecase based on which it is resolved. 
Later, this may resolve to a user interface, microservice or a to manifest registering one.
For now, just use a unique string starting with a domain you own. */
    usecaseUri?: string | null;
}

export interface PageResultOfEmploymentListItem {
    items?: EmploymentListItem[] | null;
    nextPageLink?: string | null;
    count?: number | null;
}

/** Represents a single item in a list of employment relations in the user interface. */
export interface EmploymentListItem {
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Person GUID for the owner of the object. */
    ownerId?: string | null;
    /** Metadata for the owner */
    ownerInfo?: AccountInIndex | null;
    /** The main status depending on the type of the object. */
    status?: EmploymentRelationStatus | null;
    /** The back office status depending on the type of the object. */
    backOfficeStatus?: string | null;
    /** When the event started. Typically, this is the CreatedAt date, but it may be something else. */
    startAt?: string | null;
    /** This is the end date of the event.
Typically, it is the UserUpdatedAt date, but it may be something else - e.g PaidAt for the calculation. */
    endAt?: string | null;
    /** Gross salary if that is relevant to the transaction. */
    grossSalary?: number | null;
    /** This is the payment from the Owner point-of-view:
Total payment for the Employer and Net salary for the Worker in the case of a calculation.
Only add here the payment, if the payment is really made. */
    payment?: number | null;
    /** Estimated fee of the transaction to Palkkaus.fi. */
    fee?: number | null;
    /** The GUID for the other party. Currently, this is always the PersonID. */
    otherId?: string | null;
    /** The other party (usually a Person) that is involved in the event (e.g Worker if this is a Salary payment by Employer). */
    otherPartyInfo?: AccountInIndex | null;
    /** A very short description describing the object as an event. E.g. "Paid salary" */
    shortText?: string | null;
    /** Business object ids related to this object. E.g. calculations and payrolls in the payment. */
    businessObjects?: string[] | null;
    /** This is valid for calculations only. The estimated date of salary in worker. */
    salaryDate?: string | null;
    /** Business data to include further information of the object. */
    data?: EmploymentData | null;
    /** Version number. May be used in conflicts */
    versionNumber?: number | null;
    /** Salaxy uri of the resource. */
    uri?: string | null;
    /** Workflow flags for the object.
Only workflow events with API supported message types are listed. */
    flags?: string[] | null;
    /** Workflow messages for the object.
Only workflow events with API supported message types are listed.
Shown in format "[MessageType]:[Message] ([User] at [UTC-time])" */
    messages?: string[] | null;
    /** Sub category for the payload. E.g. Payment Category, MoneyTransfer Source. */
    entityType?: string | null;
    /** The date for the actual period for which this object is done. */
    logicalDate?: string | null;
    /** Reference information. E.g. Payment or MoneyTransfer reference number. */
    reference?: string | null;
    /** External id for the object in 3rd party system. */
    externalId?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Employment specific business data for index. */
export interface EmploymentData {
    /** Type for the pension insurance. */
    pensionCalculation?: PensionCalculation | null;
    /** Taxcard type from the employment point of view. */
    taxcard?: EmploymentRelationTaxcard | null;
    /** Type of the employment relation */
    type?: EmploymentRelationType | null;
    /** Start date of the Employment Relation. */
    startDate?: string | null;
    /** End date of the Employment Relation. */
    endDate?: string | null;
    /** Duration of the employment. If true, the employment relation is for a fixed term.
Otherwise (which is the default) the employment relation continues until further notice. */
    isFixedTerm?: boolean | null;
    /** Indicates that the employment relation has been terminated.
This is the value stored in the database as opposed to */
    isTerminated?: boolean | null;
    /** The search logic returns the active state of the employment here in relation to queried date (or today).
Note that you cannot query based on this dynamic parameter: All values in the search index are null. */
    isActive?: boolean | null;
}

/** Employing relation info for the worker. */
export interface EmployingRelation {
    /** Employer avatar */
    employer?: AccountInIndex | null;
    /** Contact information for the report. Typically the employer, but may be something else.
By desing, the contact information is not filled in for Private Person employers. */
    contact?: Contact | null;
    /** Relevant and public employer settings. */
    settings?: EmployingRelationSettings | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Settings for the employing relation. */
export interface EmployingRelationSettings {
    /** Cost accounting settings for employing relation. */
    costAccounting?: EmployingRelationCostAccounting | null;
}

/** Cost accounting settings in the employing relation. */
export interface EmployingRelationCostAccounting {
    /** Cost accounting dimensions */
    dimensions?: CostAccountingDimensionDefinition[] | null;
}

/** Cost accounting dimension definition. */
export interface CostAccountingDimensionDefinition {
    /** Id for the dimension. */
    id?: string | null;
    /** Default label for the dimension entry. */
    label?: string | null;
    /** Hierarchial object containing selection options for dimension values. */
    options?: CostAccountingDimensionOption[] | null;
    /** If true, multiple values can be set to the dimension and the costs are shared between dimension values. */
    allowCostSharing?: boolean | null;
    /** Defines the visible scopes of the dimension. For example, Scope.Row shows the dimension on row level only. */
    scope?: CostAccountingDimensionScope | null;
}

/** Selectable cost accounting dimension value. */
export interface CostAccountingDimensionOption {
    /** Value for the option. */
    value?: string | null;
    /** Description of the value. */
    text?: string | null;
    /** For option hiearchies, path to this option not including the value itself. */
    path?: string | null;
    /** Defines the visible scopes of the dimension values. For example, Scope.Row shows the dimension value on row level only.
The default is, that the scope is not defined and that the value is visible everywhere. */
    scope?: CostAccountingDimensionScope | null;
}

/** The BlobFile stores metadata about miscellaneous BLOB-files that are stored to the system. For example Receipts and Authorizations. */
export interface BlobFile {
    id?: string | null;
    /** The logical container - first level folder for the file. */
    container?: BlobRepository | null;
    /** Strongly typed logical type of the file. For user files, this is a sub folder. */
    type?: BlobFileType | null;
    /** File type (mime type etc.) based on the ending of the file name.
Null for folders. */
    readonly fileType?: FileType | null;
    /** A user friendly name that can be used in listings.
In the upload scenarios this is usually the original file name when uploaded. 
It is not necessarily unique. No path information */
    userFriendlyName?: string | null;
    /** Technical file name in storage.  In practical terms, this is the relative path
excluding the container part "/[container]/". 
I.e. this property is without the starting slash "/". 
It must be unique and is used for Uri.
For user files this is constructed "[Username]/[Type]/[UniqueFileName].[xxx]" */
    filePath?: string | null;
    /** Full unique URI in the storage */
    blobUri?: string | null;
    /** If created, contains uri to a PNG image for preview purposes. */
    previewUri?: string | null;
    updatedAt?: string | null;
    /** The length of the file in bytes. */
    length?: number | null;
    /** If true, this is a collection (folder in file system) */
    isCollection?: boolean | null;
    metadata?: BlobFileMetadata | null;
    /** The workflow data for manual editing and approval purposes. */
    workflowData?: WorkflowData | null;
}

export interface FileType {
    extension?: string | null;
    mimeType?: string | null;
    isImage?: boolean | null;
    readonly isText?: boolean | null;
}

/** Metadata related to blob files as a strongly typed object. */
export interface BlobFileMetadata {
    /** Whether the document is digitally signed (or manually checked as being signed).
At the time of writing, this is used only for AuthorizationPdf documents. */
    isSigned?: boolean | null;
    /** Logical date for the file. E.g. first of the month for a monthly report. */
    logicalDate?: string | null;
    /** Subtype is internal typing within a BlobFileType. This may or may not be a sub-folder.
There is no enumeration on File level - there may be one under services specific to one BlobFileType. */
    subType?: string | null;
    /** Avatar object related to the report.
For example for the salary payments this is the other party (employer or worker) */
    avatar?: Avatar | null;
    /** Identifier of the original calculation etc. business object. */
    grossSalary?: number | null;
    /** This is the payment from the Owner point-of-view:
Total payment for the Employer and Net salary for the Worker in the case of a calculation. */
    payment?: number | null;
    /** Arbitrary metadata. */
    data?: { [key: string]: any; } | null;
}

export interface PageResultOfFileListItem {
    items?: FileListItem[] | null;
    nextPageLink?: string | null;
    count?: number | null;
}

/** Represents a single item in a list of reports in the user interface. It contains all essential information of the report and is basis for searching, filtering and sorting. */
export interface FileListItem {
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Person GUID for the owner of the object. */
    ownerId?: string | null;
    /** Metadata for the owner */
    ownerInfo?: AccountInIndex | null;
    /** The main status depending on the type of the object. */
    status?: string | null;
    /** The back office status depending on the type of the object. */
    backOfficeStatus?: string | null;
    /** When the event started. Typically, this is the CreatedAt date, but it may be something else. */
    startAt?: string | null;
    /** This is the end date of the event.
Typically, it is the UserUpdatedAt date, but it may be something else - e.g PaidAt for the calculation. */
    endAt?: string | null;
    /** Gross salary if that is relevant to the transaction. */
    grossSalary?: number | null;
    /** This is the payment from the Owner point-of-view:
Total payment for the Employer and Net salary for the Worker in the case of a calculation.
Only add here the payment, if the payment is really made. */
    payment?: number | null;
    /** Estimated fee of the transaction to Palkkaus.fi. */
    fee?: number | null;
    /** The GUID for the other party. Currently, this is always the PersonID. */
    otherId?: string | null;
    /** The other party (usually a Person) that is involved in the event (e.g Worker if this is a Salary payment by Employer). */
    otherPartyInfo?: AccountInIndex | null;
    /** A very short description describing the object as an event. E.g. "Paid salary" */
    shortText?: string | null;
    /** Business object ids related to this object. E.g. calculations and payrolls in the payment. */
    businessObjects?: string[] | null;
    /** This is valid for calculations only. The estimated date of salary in worker. */
    salaryDate?: string | null;
    /** Business data to include further information of the object. */
    data?: FileData | null;
    /** Version number. May be used in conflicts */
    versionNumber?: number | null;
    /** Salaxy uri of the resource. */
    uri?: string | null;
    /** Workflow flags for the object.
Only workflow events with API supported message types are listed. */
    flags?: string[] | null;
    /** Workflow messages for the object.
Only workflow events with API supported message types are listed.
Shown in format "[MessageType]:[Message] ([User] at [UTC-time])" */
    messages?: string[] | null;
    /** Sub category for the payload. E.g. Payment Category, MoneyTransfer Source. */
    entityType?: string | null;
    /** The date for the actual period for which this object is done. */
    logicalDate?: string | null;
    /** Reference information. E.g. Payment or MoneyTransfer reference number. */
    reference?: string | null;
    /** External id for the object in 3rd party system. */
    externalId?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Report specific business data for index. */
export interface FileData {
    /** Contains the email or id of the responsible for the partner workflow event. */
    partnerMessageAssignedTo?: string | null;
    /** Number of workers in the report. */
    workerCount?: number | null;
    /** Number of calculations in the report. */
    calculationCount?: number | null;
    /** Official id for the report. */
    officialId?: string | null;
    /** A user friendly name that can be used in listings.
In the upload scenarios this is usually the original file name when uploaded. 
It is not necessarily unique. No path information */
    userFriendlyName?: string | null;
    /** Technical file name in storage.  In practical terms, this is the relative path
excluding the container part "/[container]/". 
I.e. this property is without the starting slash "/". 
It must be unique and is used for Uri.
For user files this is constructed "[Username]/[Type]/[UniqueFileName].[xxx]" */
    filePath?: string | null;
}

export interface PageResultOfHolidayYearListItem {
    items?: HolidayYearListItem[] | null;
    nextPageLink?: string | null;
    count?: number | null;
}

/** Represents a single item in a list of holiday years  in the user interface. */
export interface HolidayYearListItem {
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Person GUID for the owner of the object. */
    ownerId?: string | null;
    /** Metadata for the owner */
    ownerInfo?: AccountInIndex | null;
    /** The main status depending on the type of the object. */
    status?: string | null;
    /** The back office status depending on the type of the object. */
    backOfficeStatus?: string | null;
    /** When the event started. Typically, this is the CreatedAt date, but it may be something else. */
    startAt?: string | null;
    /** This is the end date of the event.
Typically, it is the UserUpdatedAt date, but it may be something else - e.g PaidAt for the calculation. */
    endAt?: string | null;
    /** Gross salary if that is relevant to the transaction. */
    grossSalary?: number | null;
    /** This is the payment from the Owner point-of-view:
Total payment for the Employer and Net salary for the Worker in the case of a calculation.
Only add here the payment, if the payment is really made. */
    payment?: number | null;
    /** Estimated fee of the transaction to Palkkaus.fi. */
    fee?: number | null;
    /** The GUID for the other party. Currently, this is always the PersonID. */
    otherId?: string | null;
    /** The other party (usually a Person) that is involved in the event (e.g Worker if this is a Salary payment by Employer). */
    otherPartyInfo?: AccountInIndex | null;
    /** A very short description describing the object as an event. E.g. "Paid salary" */
    shortText?: string | null;
    /** Business object ids related to this object. E.g. calculations and payrolls in the payment. */
    businessObjects?: string[] | null;
    /** This is valid for calculations only. The estimated date of salary in worker. */
    salaryDate?: string | null;
    /** Business data to include further information of the object. */
    data?: HolidayYearData | null;
    /** Version number. May be used in conflicts */
    versionNumber?: number | null;
    /** Salaxy uri of the resource. */
    uri?: string | null;
    /** Workflow flags for the object.
Only workflow events with API supported message types are listed. */
    flags?: string[] | null;
    /** Workflow messages for the object.
Only workflow events with API supported message types are listed.
Shown in format "[MessageType]:[Message] ([User] at [UTC-time])" */
    messages?: string[] | null;
    /** Sub category for the payload. E.g. Payment Category, MoneyTransfer Source. */
    entityType?: string | null;
    /** The date for the actual period for which this object is done. */
    logicalDate?: string | null;
    /** Reference information. E.g. Payment or MoneyTransfer reference number. */
    reference?: string | null;
    /** External id for the object in 3rd party system. */
    externalId?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Holiday year specific business data for index. */
export interface HolidayYearData {
    /** Holiday year. */
    year?: number | null;
    /** Employment id. */
    employmentId?: string | null;
}

/** Report for containing all the result data and rules for the holiday pay calculation. */
export interface HolidayPayCalculationReportData {
    /** Holiday year for which the holiday pay is calculated. */
    holidayYear?: HolidayYear | null;
    /** Current settings for the accrual calculations. */
    holidayAccrualSettings?: HolidayAccrualSettings | null;
    /** Applied settings for the holiday pay calculation. */
    holidayPaySettings?: HolidayPaySettings | null;
    /** Detailed calculation data with rows on which the holiday pay calculation is based. */
    calculations?: HolidayPayCalculationReportDataCalc[] | null;
}

/** Settings for the holiday accrual calculations. */
export interface HolidayAccrualSettings {
    /** Defines how the holidays are handled for the worker. */
    code?: HolidayCode | null;
    /** RowTypes, WageTypes or IncomeTypes which accumulate working time.
Default is  null, which means that a default set of types is used. */
    workingTimeTypes?: string[] | null;
}

/** Settings for the holiday pay calculations. */
export interface HolidayPaySettings {
    /** Defines how the holiday pay is calculated. */
    holidayPayCalculation?: HolidayPayCalculation | null;
    /** Possible multipliers for the holiday pay calculation.
Default is  null, which means that a default set of multipliers is used. */
    multipliers?: { [key: string]: number; } | null;
    /** RowTypes, WageTypes or IncomeTypes that are used in the holiday pay calculation and which accumulate working time.
Default is  null, which means that a default set of types is used.
This is applicable only for {Palkkaus.Model.Worktime.Holidays.HolidayPayCalculation.AverageHourlyPay} */
    workingTimeTypes?: string[] | null;
    /** RowTypes, WageTypes or IncomeTypes that are used in the holiday pay calculation and which accumulate overtime.
Default is  null, which means that a default set of types is used.
This is applicable only for {Palkkaus.Model.Worktime.Holidays.HolidayPayCalculation.AverageDailyPay} */
    overtimeTypes?: string[] | null;
    /** RowTypes, WageTypes or IncomeTypes that are used in the holiday pay calculation and which accumulate salary.
Default is  null, which means that a default set of types is used. */
    salaryTypes?: string[] | null;
}

/** Detailed calculation data with rows on which the holiday pay calculation is based. */
export interface HolidayPayCalculationReportDataCalc {
    /** Calculation id. */
    calculationId?: string | null;
    /** Calculation title. */
    calculationTitle?: string | null;
    /** Calculation salary date. */
    salaryDate?: string | null;
    /** Calculation work start date. */
    workStartDate?: string | null;
    /** Calculation work end date. */
    workEndDate?: string | null;
    /** Working days in the calculation.
This is applicable only for {Palkkaus.Model.Worktime.Holidays.HolidayPayCalculation.AverageDailyPay} */
    workingDays?: number | null;
    /** Absences days in the calculation.
This is applicable only for {Palkkaus.Model.Worktime.Holidays.HolidayPayCalculation.AverageDailyPay}. */
    absenceDays?: number | null;
    /** Total salary in the calculation which is calculated into holiday pay. */
    total?: number | null;
    /** Total hours in the calculation which is calculated into holiday pay.
This is applicable only for {Palkkaus.Model.Worktime.Holidays.HolidayPayCalculation.AverageHourlyPay} */
    hours?: number | null;
    /** Total over time hours in the calculation which is calculated into holiday pay.
This is applicable only for {Palkkaus.Model.Worktime.Holidays.HolidayPayCalculation.AverageDailyPay}."/&gt; */
    overtimeHours?: number | null;
    /** Detailed row data on which the holiday pay calculation is based. */
    rows?: HolidayPayCalculationReportDataCalcRow[] | null;
}

/** Detailed row data on which the holiday pay calculation is based. */
export interface HolidayPayCalculationReportDataCalcRow {
    /** The row of the calculation. */
    irRow?: IrRow | null;
    /** Matching RowType, Type or IncomeType which accumulates salary. */
    salaryType?: string | null;
    /** Matching RowType, Type or IncomeType which accumulates working time.
This is applicable only for {Palkkaus.Model.Worktime.Holidays.HolidayPayCalculation.AverageHourlyPay} */
    workingTimeType?: string | null;
    /** Matching RowType, Type or IncomeType which accumulates overtime.
This is applicable only for {Palkkaus.Model.Worktime.Holidays.HolidayPayCalculation.AverageDailyPay} */
    overtimeType?: string | null;
    /** Total salary which is calculated into holiday pay. */
    total?: number | null;
    /** Total hours which is calculated into holiday pay.
This is applicable only for {Palkkaus.Model.Worktime.Holidays.HolidayPayCalculation.AverageHourlyPay} */
    hours?: number | null;
    /** Total over time hours which is calculated into holiday pay.
This is applicable only for {Palkkaus.Model.Worktime.Holidays.HolidayPayCalculation.AverageDailyPay}."/&gt; */
    overtimeHours?: number | null;
}

/** Household yearly data. */
export interface HouseholdYear {
    /** Year for the salaries */
    year?: number | null;
    /** Status of the household deduction process. */
    processingStatus?: HouseholdYearProcessingStatus | null;
    /** Status of user feedback. */
    status?: HouseholdYearStatus | null;
    /** Free text from the account holder to Salaxy backoffice. */
    userFeedbackText?: string | null;
    /** Time when the feedback was given. */
    userFeedbackTime?: string | null;
    /** Amount of accident insurance paid during this year as reported by the user
This is relevant for households for Household deduction: 
This amount can be deducted from the yearly salaries and needs to be reported to tax authorities. */
    insuranceAmount?: number | null;
    /** Name of the spouse with who the household deduction is split */
    spouseName?: string | null;
    /** Finnish Personal ID of the spouse with who the household deduction is split */
    spousePersonalId?: string | null;
    /** Readonly workflow data, which is exposed to API. */
    workflowData?: WorkflowData | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

export interface PageResultOfHouseholdYearListItem {
    items?: HouseholdYearListItem[] | null;
    nextPageLink?: string | null;
    count?: number | null;
}

/** Represents household yearly deduction data. */
export interface HouseholdYearListItem {
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Person GUID for the owner of the object. */
    ownerId?: string | null;
    /** Metadata for the owner */
    ownerInfo?: AccountInIndex | null;
    /** The main status depending on the type of the object. */
    status?: HouseholdYearStatus | null;
    /** The back office status depending on the type of the object. */
    backOfficeStatus?: string | null;
    /** When the event started. Typically, this is the CreatedAt date, but it may be something else. */
    startAt?: string | null;
    /** This is the end date of the event.
Typically, it is the UserUpdatedAt date, but it may be something else - e.g PaidAt for the calculation. */
    endAt?: string | null;
    /** Gross salary if that is relevant to the transaction. */
    grossSalary?: number | null;
    /** This is the payment from the Owner point-of-view:
Total payment for the Employer and Net salary for the Worker in the case of a calculation.
Only add here the payment, if the payment is really made. */
    payment?: number | null;
    /** Estimated fee of the transaction to Palkkaus.fi. */
    fee?: number | null;
    /** The GUID for the other party. Currently, this is always the PersonID. */
    otherId?: string | null;
    /** The other party (usually a Person) that is involved in the event (e.g Worker if this is a Salary payment by Employer). */
    otherPartyInfo?: AccountInIndex | null;
    /** A very short description describing the object as an event. E.g. "Paid salary" */
    shortText?: string | null;
    /** Business object ids related to this object. E.g. calculations and payrolls in the payment. */
    businessObjects?: string[] | null;
    /** This is valid for calculations only. The estimated date of salary in worker. */
    salaryDate?: string | null;
    /** Business data to include further information of the object. */
    data?: HouseholdYearData | null;
    /** Version number. May be used in conflicts */
    versionNumber?: number | null;
    /** Salaxy uri of the resource. */
    uri?: string | null;
    /** Workflow flags for the object.
Only workflow events with API supported message types are listed. */
    flags?: string[] | null;
    /** Workflow messages for the object.
Only workflow events with API supported message types are listed.
Shown in format "[MessageType]:[Message] ([User] at [UTC-time])" */
    messages?: string[] | null;
    /** Sub category for the payload. E.g. Payment Category, MoneyTransfer Source. */
    entityType?: string | null;
    /** The date for the actual period for which this object is done. */
    logicalDate?: string | null;
    /** Reference information. E.g. Payment or MoneyTransfer reference number. */
    reference?: string | null;
    /** External id for the object in 3rd party system. */
    externalId?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Household year specific business data for index. */
export interface HouseholdYearData {
    /** Contains the email or id of the responsible for the partner workflow event. */
    partnerMessageAssignedTo?: string | null;
}

/** Result item of the EInvoice address query. */
export interface EInvoiceAddress {
    /** Name for the company. */
    receiverName?: string | null;
    /** Official id of the company. */
    receiverOfficialId?: string | null;
    /** Receiver EInvoice address of company. */
    receiver?: string | null;
    /** Intermediator id for this receiver address. */
    intermediator?: string | null;
    /** Intermediator name for this receiver address. */
    intermediatorName?: string | null;
}

/** API worker import object. The API uses this object for mass operations for creating or assuring the worker employment relations in the system. */
export interface WorkerImport {
    /** Company number in the the trade register (Y-tunnus). 
Format is "1234567-8" - 7 numbers, one control character, with or without the dash.
Also, the international VAT format is allowed: FI12345678
This field is optional and defaults to the company number of the current account. */
    officialId?: string | null;
    /** Additional parameters for import. Defaults to string. */
    parameters?: { [key: string]: any; } | null;
    /** Item for import. */
    item?: WorkerAccount | null;
    /** Validation for the import */
    validation?: ApiValidation | null;
    /** Result object of the import. */
    result?: ApiImportResultOfString | null;
}

/** Account data that is relevant for a Worker. */
export interface WorkerAccount {
    /** Tha bank account number of the Worker - in Iban format. */
    ibanNumber?: string | null;
    /** If created (and still owned) by an employer, this is the AccountOwnerId of the employer who created this account. */
    employerId?: string | null;
    /** The Person ID of the worker if known. */
    officialPersonId?: string | null;
    /** Age range that is relevant to workers salary calculation and/or employment.
Set this especially if OfficialPersonId is not set. 
If OfficialPersonId is valid, this property is always set based on it. */
    ageRange?: AgeRange | null;
    /** Current Employment Relation: The data that is owned by the Employer about the Worker 
even if the Worker has registered and created an account.
If employer has several Employment Relations, this is the one that is marked as Primary. */
    employment?: WorkerAccountEmployment | null;
    /** Provides validation errors currently only in Save operations,
but potentially in the future also in detail/list views. */
    validation?: ApiValidation | null;
    /** The unique id for the employment. This does not change within one employment. */
    employmentId?: string | null;
    /** Entity type of the account.
Type PersonCreatedByEmployer means that the Worker has not yet signed into the system and there may be multiple instances of the same logical person (Official ID) - one for each employer. */
    entityType?: LegalEntityType | null;
    /** If true the object Account is and Employer account - it has the EmployerInfo object */
    isEmployer?: boolean | null;
    /** If true the object Account is and Worker account - it has the WorkerInfo object */
    isWorker?: boolean | null;
    /** If true, the account has been verified. Typically this means a digitally signed contract.
This means that the account also has an Identity object.
However, as the Identity object contains confidential information, it is not necessarily present in all method calls. */
    isVerified?: boolean | null;
    /** Avatar is the visual representation of the Account. */
    avatar?: Avatar | null;
    /** Contact information for the Account. */
    contact?: Contact | null;
    /** Language of the person/company. */
    language?: Language | null;
    /** Service model for the account. */
    serviceModelId?: string | null;
    /** Workflow data, which is exposed to API. */
    workflowData?: WorkflowData | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Result of the import. Both status and possible item are returned. */
export interface ApiImportResultOfString {
    /** Status of the import */
    status?: ApiImportStatus | null;
    /** Result object of the import. Defaults to id of the imported object. */
    item?: string | null;
}

/** Employment Relation as it is shown as part of WorkerAccount. */
export interface WorkerAccountEmployment {
    /** Type of the employment relation */
    type?: EmploymentRelationType | null;
    /** Type of additional income earner data by National Incomer Register classification . If several types apply, all of them should be selected. */
    irIncomeEarnerTypes?: IncomeEarnerType[] | null;
    /** Describes the work that is being performed in this Employment Relation. */
    work?: WorkDescription | null;
    /** Defines how the holidays are specified to this Worker. */
    holidays?: HolidaySpecification | null;
    /** Usecase is data related to the source and processing of the Employment data outside the Salaxy backend service / system.
Typically, Usecase data would be processed by an external system that has originally created the 
Employment Relation (Worker / Employee in many systems). E.g. expenses system, hourly reporting system. */
    usecase?: UsecaseData | null;
    /** Type for the pension insurance. */
    pensionCalculation?: PensionCalculation | null;
    /** Rules (e.g. effect of monthly lower limit) for pension calculation. */
    pensionRule?: PensionRule | null;
    /** The id of the pension company. */
    pensionCompany?: PensionCompany | null;
    /** The pension contract number. */
    pensionContractNumber?: string | null;
    /** The id of the insurance company. */
    insuranceCompany?: InsuranceCompany | null;
    /** The accident insurance contract number. */
    insuranceContractNumber?: string | null;
    /** Taxcard type from the employment point of view. */
    taxcard?: EmploymentRelationTaxcard | null;
    /** Worker's salary payment method, bank account, external etc. */
    salaryPaymentMethod?: EmploymentRelationSalaryPaymentMethod | null;
    /** Start date of the Employment Relation. */
    startDate?: string | null;
    /** End date of the Employment Relation. */
    endDate?: string | null;
    /** Duration of the employment. If true, the employment relation is for a fixed term.
Otherwise (which is the default) the employment relation continues until further notice. */
    isFixedTerm?: boolean | null;
    /** Indicates that the employment relation has been terminated.
Saving with this status also makes the employment relation Archived. */
    isTerminated?: boolean | null;
    /** If true, the worker is the same person as the actual signed owner of the account. */
    isAccountOwner?: boolean | null;
    /** Identifier in a source system. Used in imports etc. */
    sourceId?: string | null;
    /** Employment registration code for Incomes Registry. */
    employmentRegCode?: string | null;
}

/** API company import object. The API uses this object for mass operations for creating or assuring the customer companies in the system. */
export interface CompanyImport {
    /** Company number in the the trade register (Y-tunnus). 
Format is "1234567-8" - 7 numbers, one control character, with or without the dash.
Also, the international VAT format is allowed: FI12345678
This field is optional and defaults to the company number of the current account. */
    officialId?: string | null;
    /** Additional parameters for import. Defaults to string. */
    parameters?: { [key: string]: any; } | null;
    /** Item for import. */
    item?: AssureCompanyAccountRequest | null;
    /** Validation for the import */
    validation?: ApiValidation | null;
    /** Result object of the import. */
    result?: ApiImportResultOfPartnerCompanyAccountInfo | null;
}

/** Request to assure that a company account exists: Either an account is returned or an account stub (non-verified) will be created. */
export interface AssureCompanyAccountRequest {
    /** Company number in the the trade register (Y-tunnus). 
Format is "1234567-8" - 7 numbers, one control character, with or without the dash.
Also, the international VAT format is allowed: FI12345678 */
    officialId: string;
    /** The account identifier at the partner site. 
If present, this ID is used to restrict the authorization to one account at partner site only. */
    partnerAccountId?: string | null;
    /** Contact e-mail */
    email?: string | null;
    /** Telephone number for the contact person */
    telephone?: string | null;
    /** First name of the contact person */
    contactFirstName?: string | null;
    /** Last name of the contact person */
    contactLastName?: string | null;
    /** The primary partner account for the new company to create.
If the company already exists and has given authorization to the primary partner, and does not have any primary partner, the primary partner will be set.
Please note, that the calling account must have the authorization to the primary partner account, or
be the primary partner itself. */
    proxyPartner?: string | null;
    /** Language preference. */
    language?: Language | null;
}

/** Result of the import. Both status and possible item are returned. */
export interface ApiImportResultOfPartnerCompanyAccountInfo {
    /** Status of the import */
    status?: ApiImportStatus | null;
    /** Result object of the import. Defaults to id of the imported object. */
    item?: PartnerCompanyAccountInfo | null;
}

/** Information about a Customer account for a Partner */
export interface PartnerCompanyAccountInfo {
    /** Account Id */
    accountId?: string | null;
    /** Account Id formatted for dispaly to end user */
    accountIdFormatted?: string | null;
    /** Avatar for display information */
    avatar?: Avatar | null;
    /** If true, the account has a verified owner. */
    isVerified?: boolean | null;
    /** If true, the current user (the partner) is authorized to access the account */
    isAuthorized?: boolean | null;
    /** The partner account ID to which the access is currently restricted. */
    partnerAccountId?: string | null;
}

/** Import object for E-invoice delivery. */
export interface EInvoicingRequest {
    /** Company number in the the trade register (Y-tunnus). 
Format is "1234567-8" - 7 numbers, one control character, with or without the dash.
Also, the international VAT format is allowed: FI12345678
This field is optional and defaults to the company number of the current account. */
    officialId?: string | null;
    /** Additional parameters for import. Defaults to string. */
    parameters?: { [key: string]: any; } | null;
    /** Item for import. */
    item?: string | null;
    /** Validation for the import */
    validation?: ApiValidation | null;
    /** Result object of the import. */
    result?: ApiImportResultOfObject | null;
}

/** Result of the import. Both status and possible item are returned. */
export interface ApiImportResultOfObject {
    /** Status of the import */
    status?: ApiImportStatus | null;
    /** Result object of the import. Defaults to id of the imported object. */
    item?: any | null;
}

/** API calculation import object. The API uses this object for mass operations for adding calculations to a new or existing payroll object. If the calculation object does not contain a valid payroll-ID, a new payroll will be created. Returns payroll ID. */
export interface CalculationImport {
    /** Company number in the the trade register (Y-tunnus). 
Format is "1234567-8" - 7 numbers, one control character, with or without the dash.
Also, the international VAT format is allowed: FI12345678
This field is optional and defaults to the company number of the current account. */
    officialId?: string | null;
    /** Additional parameters for import. Defaults to string. */
    parameters?: { [key: string]: any; } | null;
    /** Item for import. */
    item?: Calculation | null;
    /** Validation for the import */
    validation?: ApiValidation | null;
    /** Result object of the import. */
    result?: ApiImportResultOfString | null;
}

/** API worker check object. The API uses this object for checking the existence of a worker with employment. */
export interface WorkerCheck {
    /** Company number in the the trade register (Y-tunnus). 
Format is "1234567-8" - 7 numbers, one control character, with or without the dash.
Also, the international VAT format is allowed: FI12345678
This field is optional and defaults to the company number of the current account. */
    officialId?: string | null;
    /** Item id to check.
This can be external ID, official ID or Salaxy ID. */
    id?: string | null;
    /** Validation for the import */
    validation?: ApiValidation | null;
    /** Result object of the import. */
    result?: ApiCheckResultOfWorkerAccountOf | null;
}

/** Result of the check. Both status and possible item are returned. */
export interface ApiCheckResultOfWorkerAccountOf {
    /** Status of the check */
    status?: ApiCheckStatus | null;
    /** Result object of the check. Defaults to null. */
    item?: WorkerAccount[] | null;
}

/** Import object for invoice creation. */
export interface InvoicingRequest {
    /** Company number in the the trade register (Y-tunnus). 
Format is "1234567-8" - 7 numbers, one control character, with or without the dash.
Also, the international VAT format is allowed: FI12345678
This field is optional and defaults to the company number of the current account. */
    officialId?: string | null;
    /** Additional parameters for import. Defaults to string. */
    parameters?: { [key: string]: any; } | null;
    /** Item for import. */
    item?: string | null;
    /** Validation for the import */
    validation?: ApiValidation | null;
    /** Result object of the import. */
    result?: ApiImportResultOfInvoiceOf | null;
}

/** Result of the import. Both status and possible item are returned. */
export interface ApiImportResultOfInvoiceOf {
    /** Status of the import */
    status?: ApiImportStatus | null;
    /** Result object of the import. Defaults to id of the imported object. */
    item?: Invoice[] | null;
}

/** Invoice for the pending payment in the business system. For example, a salary gross payment created for the salary calculation and delivered as an e-invoice to the employer. For example, a salary net payment, created for the employer which is self paying the net payment to the worker. */
export interface Invoice {
    /** Group indicator.
Invoices with the same group id can be paid in the same batch. */
    group?: string | null;
    /** Invoice header details. */
    header?: InvoiceHeader | null;
    /** Invoice recipient details. */
    recipient?: InvoiceRecipient | null;
    /** Invoice payer details. */
    payer?: InvoicePayer | null;
    /** List of invoice rows. */
    rows?: InvoiceRow[] | null;
    /** Invoice data in XML or json format. */
    content?: string | null;
    /** Invoice in pdf format. */
    pdf?: string | null;
    /** The workflow data for manual editing and approval purposes. */
    workflowData?: WorkflowData | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Header for the invoice */
export interface InvoiceHeader {
    /** Payment reference (e.g. RF0710010831).
Please note that in salary payment scenarios, this is not necessarily unique. */
    referenceNumber?: string | null;
    /** Invoice Date. */
    date?: string | null;
    /** Due date for the invoice. */
    dueDate?: string | null;
    /** The date for the actual period for which this invoice is done.
For salaries, this is salary date, for monthly / quarterly payments, this is the first day of period. */
    logicalDate?: string | null;
    /** Total amount for the invoice excluding VAT. */
    totalExVat?: number | null;
    /** Total payable amount for the invoice including VAT. */
    total?: number | null;
    /** Already paid amount of the invoice.
This is applicable only for some periodic invoices, like tax invoices, which may be paid in parts. */
    totalPaid?: number | null;
    /** The free text that is displayed / sent with the invoice.
May have multiple lines. */
    message?: string | null;
    /** Channel that is used for paying the invoice. */
    channel?: PaymentChannel | null;
    /** Invoice type. */
    type?: InvoiceType | null;
    /** The external ID is used for matching the executed payment from the 3rd party system
to the pending payment in the Palkkaus system. */
    externalId?: string | null;
    /** The current notified status of the invoice in external system. */
    status?: InvoiceStatus | null;
    /** The time when the object status was last updated. */
    statusAt?: string | null;
    /** List of business object ids (typically calculations) on which the payment is based on. */
    businessObjects?: string[] | null;
    /** The count of paid business objects (typically calculations) which the invoices is based on.
This is applicable only for some periodic invoices, like tax invoices, which may be paid in parts. */
    paidBusinessObjectsCount?: number | null;
    /** Period for the Invoice: Work period, month / quarter of sidecosts etc. */
    period?: DateRange | null;
    /** The payment type of the invoice. If the payment channel does not support the requested payment type (e.g. Salary),
it should set here the payment type that it used (e.g. Default).
Payment channel should also expect new types to be introduced, without that being a breaking change.
Currently, we expect Default always be supported. */
    paymentType?: InvoicePaymentType | null;
}

/** Payment receiver party of the invoice. */
export interface InvoiceRecipient {
    /** The full name of the payment receiver for payment purposes. */
    fullName?: string | null;
    /** The International Bank Account Number of the receiver. */
    iban?: string | null;
    /** This is an official identifier of the party: Finnish Personal Id (HETU) for a Person or Company Id (Y-tunnus) for a company or association.
WARNING: This is currently needed for Finvoice only (https://www.finanssiala.fi/finvoice/Sivut/default.aspx). As such we consider removing it from persons. 
Please inform if you use this property! */
    officialId?: string | null;
    /** Identifier in a source system. Used in imports etc. */
    sourceId?: string | null;
    /** Optional contact info. Not available for all recipients. */
    contact?: Contact | null;
    /** The ultimate beneficiary of the money: 
This may be a Palkkaus.fi Worker Account (Avatar id is not null)
or some other entity: Tax authorities, pension company etc. (Avatar id is null).
Typically beneficiary is the same as Iban, OfficialId, FullName and Contact in this object,
but this is not true in edge cases (e.g. customer funds account). */
    beneficiary?: AccountInIndex | null;
}

/** Payment payer party of the invoice. */
export interface InvoicePayer {
    /** Avatar is the visual representation of the party. */
    avatar?: Avatar | null;
    /** Contact information for the party. */
    contact?: Contact | null;
    /** Official identifier of the party:
Finnish HETU (Soc. sec. number) for a Person or Y-tunnus (Company ID for a company or association). */
    officialId?: string | null;
    /** Optional ID for identifying the party in the third party system.
This is the same partner key that is given as part of Single Sign-On process. */
    partnerKey?: string | null;
}

/** Row for the invoice */
export interface InvoiceRow {
    /** Article Identifier is given by seller, EAN etc.
In the case of Salaxy salaries, this is CalculationRowType. */
    articleId?: string | null;
    /** Name of the product or service.
In the case of Salaxy salaries, this is language versioned text of CalculationRowType. */
    articleName?: string | null;
    /** Message (RowFreeText in Finvoice) is the message is mainly designed for accounting systems. */
    message?: string | null;
    /** Count (DeliveredQuantity in Finvoice) is the quantity of product or service. */
    count?: number | null;
    /** Price including VAT (UnitPriceVatIncludedAmount, Yksikköhinta verollinen) */
    price?: number | null;
    /** Price of one product or service without Vat (UnitPriceAmount, Yksikköhinta veroton). 
Yksikköhinta voidaan ilmoittaa myös verollisena UnitPriceVatIncludedAmount- elementissä laskutuskäytännön ja verottajan ALV-ohjeistuksen mukaan. */
    priceExVat?: number | null;
    /** Vat percent related to the product or service (RowVatRatePercent, Alv%)
Please note that eg. 24% is valued as 0.24 */
    vatPercent?: number | null;
    /** Row total excluding VAT (RowVatExcludedAmount, Yhteensä veroton) */
    totalExVat?: number | null;
    /** Row total with VAT (RowAmount, Yhteensä verollinen) */
    total?: number | null;
    /** Suggested account number (RowNormalProposedAccountIdentifier). */
    accountingAccountNumber?: string | null;
    /** Textual code for accounting mapping (RowProposedAccountText, Raportointikoodi).
In Finvoice: "Accounting information agreed between seller and buyer." */
    accountingCode?: string | null;
    /** Business object id (typically calculation) on which the row is based on. */
    businessObject?: string | null;
}

/** Check object for invoice settings. */
export interface InvoiceSettingsCheck {
    /** Company number in the the trade register (Y-tunnus). 
Format is "1234567-8" - 7 numbers, one control character, with or without the dash.
Also, the international VAT format is allowed: FI12345678
This field is optional and defaults to the company number of the current account. */
    officialId?: string | null;
    /** Item id to check.
This can be external ID, official ID or Salaxy ID. */
    id?: string | null;
    /** Validation for the import */
    validation?: ApiValidation | null;
    /** Result object of the import. */
    result?: ApiCheckResultOfInvoiceSettings | null;
}

/** Result of the check. Both status and possible item are returned. */
export interface ApiCheckResultOfInvoiceSettings {
    /** Status of the check */
    status?: ApiCheckStatus | null;
    /** Result object of the check. Defaults to null. */
    item?: InvoiceSettings | null;
}

/** Settings related to invoices that are sent to customers. */
export interface InvoiceSettings {
    /** Receiver's address for the e-invoice. */
    eInvoiceReceiver?: string | null;
    /** Receiver's operator for the e-invoice. */
    eInvoiceIntermediator?: string | null;
    /** SEPA maksatustunnus */
    sepaBankPartyId?: string | null;
    /** Employer's bank account number */
    ibanNumber?: string | null;
}

/** Contains order data for Varma pensions (TyEL, YEL) and required operations. */
export interface VarmaPensionOrder {
    /** Orderer information. */
    orderer?: InvoiceParty | null;
    /** Action for the order. */
    action?: VarmaPensionOrderAction | null;
    /** Validation information. */
    validation?: ApiValidation | null;
    /** YEL data for the order */
    yel?: VarmaPensionOrderYel | null;
    /** TyEL data for the order */
    tyel?: VarmaPensionOrderTyel | null;
}

/** Party in an Varma Invoice: Either Payer or Recipient. */
export interface InvoiceParty {
    /** Finnish Company ID (Y-tunnus). */
    companyId?: string | null;
    /** Organisation name */
    companyName?: string | null;
    /** Contact information */
    contact?: Contact | null;
    /** Contact person Full name */
    contactPersonName?: string | null;
}

/** Varma pension order YEL details. */
export interface VarmaPensionOrderYel {
    /** Personal id number. */
    personalId?: string | null;
    /** Payer definition. */
    payer?: VarmaPensionOrderYelPayer | null;
    /** If true, indicates that existing contract will be moved to Varma. */
    isMove?: boolean | null;
    /** Estimated yearly income. */
    yearlyIncome?: number | null;
    /** Start date for the new pension. */
    startDate?: string | null;
    /** Movement timing. (Q1,Q2,Q3 or Q4, or as soon as possible) */
    moveMoment?: string | null;
    /** Indicates if the existing yearly income estimate will be changed. */
    isYearlyIncomeChange?: boolean | null;
}

/** Varma pension order TyEL details. */
export interface VarmaPensionOrderTyel {
    /** Personal id number. */
    personalId?: string | null;
    /** If true, indicates that existing contract will be moved to Varma. */
    isMove?: boolean | null;
    /** Estimated yerly income. */
    yearlyIncome?: number | null;
    /** Start year for the new order. */
    startYear?: string | null;
    /** Start month for the new order. */
    startMonth?: string | null;
    /** Movement timing. (Q1,Q2,Q3 or Q4, or as soon as possible) */
    moveMoment?: string | null;
}

/** Local Tapiola insurance order API object. */
export interface LocalTapiolaInsuranceOrder {
    /** Status of the Local Tapiola insurance order. */
    status?: LocalTapiolaInsuranceOrderStatus | null;
    /** Information about the company placing the Local Tapiola insurance order. */
    company?: LocalTapiolaInsuranceOrderCompanyInfo | null;
    /** Information about the Local Tapiola worker insurance order. */
    items?: LocalTapiolInsuranceOrderInfo[] | null;
    /** Validation information. */
    validation?: ApiValidation | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Information required for an insured company with a Local Tapiola occupational accident insurance. */
export interface LocalTapiolaInsuranceOrderCompanyInfo {
    /** Company details. */
    details?: AccountInIndex | null;
    /** Company address. */
    address?: Contact | null;
    /** If true, the address of the Principal Place Of Business differs from the company address. */
    hasPrincipalBusinessAddress?: boolean | null;
    /** Address of the principal place of business. */
    principalBusinessAddress?: Contact | null;
    /** Information of the insured companys delegate person. */
    contactPerson?: LocalTapiolaInsuranceOrderCompanyContactPerson | null;
    /** Company owner structure is too complex to be fully represented with simple form data
i.e. list of InsuranceOrderCompanyOwnerInfo objects. */
    complexOwnerStructure?: boolean | null;
    /** List of beneficial owners of the company. */
    owners?: BeneficialOwner[] | null;
    /** List of other beneficiaries than beneficial owners of the company */
    beneficiaries?: Beneficiary[] | null;
}

/** Information required with a Local Tapiola worker accident insurance order. */
export interface LocalTapiolInsuranceOrderInfo {
    /** Type of the Local Tapiola insurance order. */
    orderType?: LocalTapiolaInsuranceOrderType | null;
    /** Start date of the insurance. Only valid for new occupational accident insurance and
entrepreneur insurance. If insurance is moved to Local Tapiola from another insurance
company, StartingPoint should be used instead. */
    startDate?: string | null;
    /** Billing interval (1, 2, 3 or 4 times per year). Applies only to entrepreneur insurance. */
    billingInterval?: number | null;
    /** Name of the old insurance company, if the insurance is transferred to Local Tapiola
from some other insurance company. */
    oldInsuranceCompany?: string | null;
    /** Industry that the company operates in. */
    industry?: string | null;
    /** Occupation types and income estimates. Can be many entries for an occupational accident
insurance and only a single entry for an entrepreneur insurance. */
    occupations?: LocalTapiolaInsuranceOrderOccupation[] | null;
    /** Name of the entrepreneur. */
    insuredName?: string | null;
    /** Social security number of the entrepreneur. */
    insuredOfficialId?: string | null;
}

/** Information required for a company contact person with a Local Tapiola occupational accident insurance. */
export interface LocalTapiolaInsuranceOrderCompanyContactPerson {
    /** The authorization type of for the contact person. */
    authorizationType?: LocalTapiolaInsuranceOrderAuthorizationType | null;
    /** Avatar for the account */
    avatar?: Avatar | null;
    /** Official id of the person or company. */
    officialId?: string | null;
    /** Email address. */
    email?: string | null;
    /** Telephone number. */
    telephone?: string | null;
    /** Bank account number (IBAN) */
    ibanNumber?: string | null;
}

/** Occupation information required with a new Local Tapiola worker occupational accident insurance order. */
export interface LocalTapiolaInsuranceOrderOccupation {
    /** Occupation code. */
    occupationCode?: string | null;
    /** Occupation name. */
    occupationName?: string | null;
    /** Estimated annual salary income. */
    estimatedIncome?: number | null;
}

export interface PageResultOfInvoiceListItem {
    items?: InvoiceListItem[] | null;
    nextPageLink?: string | null;
    count?: number | null;
}

/** Represents a single item in a list of invoices in the user interface. It contains all essential information of the report and is basis for searching, filtering and sorting. */
export interface InvoiceListItem {
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Person GUID for the owner of the object. */
    ownerId?: string | null;
    /** Metadata for the owner */
    ownerInfo?: AccountInIndex | null;
    /** The main status depending on the type of the object. */
    status?: InvoiceStatus | null;
    /** The back office status depending on the type of the object. */
    backOfficeStatus?: string | null;
    /** When the event started. Typically, this is the CreatedAt date, but it may be something else. */
    startAt?: string | null;
    /** This is the end date of the event.
Typically, it is the UserUpdatedAt date, but it may be something else - e.g PaidAt for the calculation. */
    endAt?: string | null;
    /** Gross salary if that is relevant to the transaction. */
    grossSalary?: number | null;
    /** This is the payment from the Owner point-of-view:
Total payment for the Employer and Net salary for the Worker in the case of a calculation.
Only add here the payment, if the payment is really made. */
    payment?: number | null;
    /** Estimated fee of the transaction to Palkkaus.fi. */
    fee?: number | null;
    /** The GUID for the other party. Currently, this is always the PersonID. */
    otherId?: string | null;
    /** The other party (usually a Person) that is involved in the event (e.g Worker if this is a Salary payment by Employer). */
    otherPartyInfo?: AccountInIndex | null;
    /** A very short description describing the object as an event. E.g. "Paid salary" */
    shortText?: string | null;
    /** Business object ids related to this object. E.g. calculations and payrolls in the payment. */
    businessObjects?: string[] | null;
    /** This is valid for calculations only. The estimated date of salary in worker. */
    salaryDate?: string | null;
    /** Business data to include further information of the object. */
    data?: InvoiceData | null;
    /** Version number. May be used in conflicts */
    versionNumber?: number | null;
    /** Salaxy uri of the resource. */
    uri?: string | null;
    /** Workflow flags for the object.
Only workflow events with API supported message types are listed. */
    flags?: string[] | null;
    /** Workflow messages for the object.
Only workflow events with API supported message types are listed.
Shown in format "[MessageType]:[Message] ([User] at [UTC-time])" */
    messages?: string[] | null;
    /** Sub category for the payload. E.g. Payment Category, MoneyTransfer Source. */
    entityType?: string | null;
    /** The date for the actual period for which this object is done. */
    logicalDate?: string | null;
    /** Reference information. E.g. Payment or MoneyTransfer reference number. */
    reference?: string | null;
    /** External id for the object in 3rd party system. */
    externalId?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Invoice specific business data for index. */
export interface InvoiceData {
    /** Contains the email or id of the responsible for the partner workflow event. */
    partnerMessageAssignedTo?: string | null;
    /** Channel that is used for paying the invoice. */
    channel?: PaymentChannel | null;
    /** Invoice Date. */
    date?: string | null;
    /** Due date for the invoice. */
    dueDate?: string | null;
    /** Start of period for the Invoice: Work period, month / quarter of sidecosts etc. */
    periodStart?: string | null;
    /** End of period for the Invoice: Work period, month / quarter of sidecosts etc. */
    periodEnd?: string | null;
    /** Already paid amount of the invoice.
This is applicable only for some periodic invoices, like tax invoices, which may be paid in parts. */
    totalPaid?: number | null;
    /** The count of paid business objects (typically calculations) which the invoices is based on.
This is applicable only for some periodic invoices, like tax invoices, which may be paid in parts. */
    paidBusinessObjectsCount?: number | null;
    /** The time when the object status was last updated. */
    statusAt?: string | null;
}

/** Defines a set of calculations based on identifiers potentially unsaved Calculation objects as well as Payrolls. */
export interface CalculationCollection {
    /** Collection of calculation ID's to be fetched from storage */
    ids?: string[] | null;
    /** Collection of payroll ID's to be fetched from storage */
    payrollIds?: string[] | null;
    /** Collection of inline calculations that may be saved or not */
    calcs?: Calculation[] | null;
    /** Collection of inline Payroll objects that may be saved or not */
    payrolls?: PayrollDetails[] | null;
}

/** New version 03 of Payroll. Payroll (Palkkalista) is a list of employees who receive salary or wages from a particular organization. Typical usecase is that a a company has e.g. a monthly salary list that is paid at the end of month. For next month, a copy is then made from the latest list and the copy is potentially modified with the changes of that particular month. */
export interface PayrollDetails {
    /** Input that defines the Payroll. */
    input?: PayrollInput | null;
    /** General summary information about the Payroll and when it was las processed. */
    info?: Payroll03Info | null;
    /** Snapshots of the calculations based on the ID's specified in Info */
    calcs?: Calculation[] | null;
    /** When saved or validated, provides a validation object for each calculation:
Whether the calculations are ready for payment. */
    validations?: ApiListItemValidation[] | null;
    /** A usecase for creating and editing Payroll lists.
In practice, a usecase is either a user interface or a microservice that provides a Payroll processing
and it may be implemented outside Salaxy.
Provides the possibility to store useacase specific data as part of the Payroll. */
    usecase?: UsecaseData | null;
    /** The workflow data for manual editing and approval purposes. */
    workflowData?: WorkflowData | null;
    /** Stores the data for automation */
    automation?: ApiAutomation | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Input that user defines about the Payroll */
export interface PayrollInput {
    /** Title that can be specified by the end user. */
    title?: string | null;
    /** The Default Salary period for the Payroll.
This may be overriden for an individual calculation. */
    period?: DateRange | null;
    /** The requested date for the SalaryDate from the employer. */
    salaryDate?: string | null;
    /** Defines the re-setting of the salary date in the calculation re-calculation. */
    salaryDateKind?: SalaryDateKind | null;
    /** Channel that is used for payment. */
    paymentChannel?: PaymentChannel | null;
    /** What types of wages are paid with this payroll.
May affect the rendering of the user interface (e.g. for holidays, hours and absences).
Also affects which Workers are show in the add / link dialog by default. */
    wageBasis?: WageBasis | null;
    /** If true, the calculation rows are not updated from employment when the Payroll is copied.
Default is that the rows and other data is updated in copy / create new etc. */
    noUpdateFromEmployment?: boolean | null;
    /** If the Payroll is based on a template, this is the identifier of the template.
The field can be manually set to null / ID to break / reconnect that connection. */
    template?: string | null;
    /** List of calculations that are attached to this calculation. */
    calculations?: string[] | null;
    /** Identifier of the payroll in a source system. Used in imports etc. */
    sourceId?: string | null;
}

/** Provides Read-only information about the Payroll In the case of non-paid Payrolls, this is the latest save/validation. In the case of paid Payrolls, this is the status of the Payroll when it was paid. */
export interface Payroll03Info {
    /** Date that the Info was last updated. */
    date?: string | null;
    /** Count of calculations in this Payroll */
    calcCount?: number | null;
    /** Total gross salary */
    totalGrossSalary?: number | null;
    /** Total payment for the Payroll. */
    totalPayment?: number | null;
    /** Total Palkkaus.fi fees for the Payroll */
    fees?: number | null;
    /** If true, all calculations have been validated and they are valid for payment.
If false, validation has not been done or some calculations are not valid for payment. */
    isReadyForPayment?: boolean | null;
    /** Status for the payroll and its calculations in the payment Workflow. */
    status?: PayrollStatus | null;
    /** Due date for the payroll. Date when the payment should be made to achieve SalaryDate. */
    dueDate?: string | null;
    /** Paid at date for the payroll. (Date of the employer's payment). */
    paymentDate?: string | null;
    /** The estimated date when the salary is withdrawable by the worker. */
    salaryDate?: string | null;
    /** The reference number of the payment after payment is made. */
    paymentId?: string | null;
    /** Original Payment reference number */
    originalPaymentId?: string | null;
    /** Application id for invoicing etc. purposes. */
    applicationId?: string | null;
    /** The MessageThread Id, if this payroll is referred in a message thread. */
    messageThreadId?: string | null;
}

/** ApiValidation object that is specialized for list items. Provides if and index properties for connecting a validation to a specific item in the list */
export interface ApiListItemValidation {
    /** Identifier of the item this validation is for.
Identifiers are not always available (if the item has not been saved), so index is a more generic approach. */
    id?: string | null;
    /** Zero based index of the item this validation is for. */
    index?: number | null;
    /** If true, the data is valid - no errors. */
    readonly isValid?: boolean | null;
    /** If true, has required fields missing data. */
    readonly hasAllRequiredFields?: boolean | null;
    /** Validation errors on invalid field values. 
Note that required fields missing error messages are not here. Only the invalid values. */
    readonly errors?: ApiValidationError[] | null;
}

/** Defines the automation aspect of API objects: Recurrence / Scheduling and Actions (Alarms in ICalendar). */
export interface ApiAutomation {
    /** Returns true, if the item is recurring */
    readonly isRecurring?: boolean | null;
    /** Identifier of a template (potentially a recurring item) that this object is occurence of. */
    occurenceOf?: string | null;
    /** Gets or sets the recurrence rules to set the recurrence. */
    recurrenceRules?: string[] | null;
    /** For a recurring event, gets or sets the rules for the recurring actions */
    actionRules?: CalendarAction[] | null;
}

/** Provides a preview of how an invoice should be created. In the future versions, it is expected to return DIFF information on how potential previously created invoices would behave (e.g. if som invoices would be canceled or changed). */
export interface InvoicePreview {
    /** The invoice that exists / would be created. */
    invoice?: InvoiceListItem | null;
    /** If true, this invoice has already been created. */
    exists?: boolean | null;
}

/** Messages thread groups togehter a set of related messages and/or attachments. */
export interface MessageThread {
    /** Title for the message */
    title?: string | null;
    /** Status for the entire message thread. */
    status?: MessageThreadStatus | null;
    /** The owner of the thread: The entity that has the right to delete or move the thread.
This may or may not be the originator the message thread.
The owner is typically Company or Household, in some cases Worker person.
It should NOT be partner or person from a company. */
    ownerInfo?: Avatar | null;
    /** Palkkaus.fi id (IBAN) of the other party.
The other party is the second entity(besides the owner) in that is juridically in the message.
This may or may not be the originator the message thread.
It is typically the Partner or Palkkaus.fi, but may also be the Worker in the future. */
    otherParty?: string | null;
    /** The other party is the second entity (besides the owner) in that is juridically in the message.
This may or may not be the originator the message thread.
It is typically the Partner or Palkkaus.fi, but may also be the Worker in the future. */
    otherPartyInfo?: Avatar | null;
    /** List of messages and attachments in this thread */
    messages?: Message[] | null;
    /** The workflow from the Owner point-of-view. */
    ownerWorkflow?: MessageThreadWorkflow | null;
    /** The workflow from the other party point-of-view. */
    otherPartyWorkflow?: MessageThreadWorkflow | null;
    /** The workflow data for manual editing and approval purposes. */
    workflowData?: WorkflowData | null;
    /** Provides data for the usecase: The customer or service model level customization that is done for this object.
The customization may define user interface, data model and even scripts or worflow related to the object. */
    usecase?: UsecaseData | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** A message within a messaging thread. */
export interface Message {
    /** Unique identifier for the message. */
    id?: string | null;
    /** Time for the message */
    time?: string | null;
    /** Content type of the message */
    type?: ThreadedMessageType | null;
    /** Textual content: If message, this is the content text.
If other type, short title / description typically shown in the title bar. */
    content?: string | null;
    /** Identifier of the external content.
BlobFile Id for attachments, Calculation ID for calculations etc. */
    contentId?: string | null;
    /** Other misc. data that is used in displaying the content in the immediate message view.
Do not include the entire object here. Just the immediately available data. */
    contentData?: { [key: string]: any; } | null;
    /** Content type specific text for preview.
This may be URI, ID or boolean.
For BlobFile, it is currently the BlobFile Guid (the same as ContentId) or null, 
but in the future, the field may also contain an URL without that being a breaking change! */
    preview?: string | null;
    /** The party / type of the message sender. */
    fromParty?: MessageFrom | null;
    /** If set, specifies the time when the message has been read by the thread owner. */
    readByOwner?: string | null;
    /** If set, specifies the time when the message has been read by the other party. */
    readByOtherParty?: string | null;
    /** Validates the object that is the payload of the message. */
    validation?: ApiValidation | null;
}

/** Defines workflow actions for a message thread. */
export interface MessageThreadWorkflow {
    /** Number of messages that this party has posted that have not been read by the other party. */
    unreadCount?: number | null;
    /** The salary date for the discussion.
Owner's and other party's are typically the same, but they may differ: 
e.g. one may be the requested / estimated date and the other the first possible date if the requested is unrealistic.
NOTE: Unlike in Salaxy, this is always UTC. */
    salaryDate?: string | null;
    /** Time of the last message posted by this party. 
NOTE: Unlike in Salaxy, this is always UTC. */
    updatedAt?: string | null;
    /** Text for the last message (written by this party). This is for preview purposes: May be shortened. */
    lastMessageText?: string | null;
}

export interface PageResultOfMessageListItem {
    items?: MessageListItem[] | null;
    nextPageLink?: string | null;
    count?: number | null;
}

/** Represents a single item in a list of message threads in the user interface. It contains header data of the message thread and is basis for searching, filtering and sorting. */
export interface MessageListItem {
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Person GUID for the owner of the object. */
    ownerId?: string | null;
    /** Metadata for the owner */
    ownerInfo?: AccountInIndex | null;
    /** The main status depending on the type of the object. */
    status?: string | null;
    /** The back office status depending on the type of the object. */
    backOfficeStatus?: string | null;
    /** When the event started. Typically, this is the CreatedAt date, but it may be something else. */
    startAt?: string | null;
    /** This is the end date of the event.
Typically, it is the UserUpdatedAt date, but it may be something else - e.g PaidAt for the calculation. */
    endAt?: string | null;
    /** Gross salary if that is relevant to the transaction. */
    grossSalary?: number | null;
    /** This is the payment from the Owner point-of-view:
Total payment for the Employer and Net salary for the Worker in the case of a calculation.
Only add here the payment, if the payment is really made. */
    payment?: number | null;
    /** Estimated fee of the transaction to Palkkaus.fi. */
    fee?: number | null;
    /** The GUID for the other party. Currently, this is always the PersonID. */
    otherId?: string | null;
    /** The other party (usually a Person) that is involved in the event (e.g Worker if this is a Salary payment by Employer). */
    otherPartyInfo?: AccountInIndex | null;
    /** A very short description describing the object as an event. E.g. "Paid salary" */
    shortText?: string | null;
    /** Business object ids related to this object. E.g. calculations and payrolls in the payment. */
    businessObjects?: string[] | null;
    /** This is valid for calculations only. The estimated date of salary in worker. */
    salaryDate?: string | null;
    /** Business data to include further information of the object. */
    data?: MessageData | null;
    /** Version number. May be used in conflicts */
    versionNumber?: number | null;
    /** Salaxy uri of the resource. */
    uri?: string | null;
    /** Workflow flags for the object.
Only workflow events with API supported message types are listed. */
    flags?: string[] | null;
    /** Workflow messages for the object.
Only workflow events with API supported message types are listed.
Shown in format "[MessageType]:[Message] ([User] at [UTC-time])" */
    messages?: string[] | null;
    /** Sub category for the payload. E.g. Payment Category, MoneyTransfer Source. */
    entityType?: string | null;
    /** The date for the actual period for which this object is done. */
    logicalDate?: string | null;
    /** Reference information. E.g. Payment or MoneyTransfer reference number. */
    reference?: string | null;
    /** External id for the object in 3rd party system. */
    externalId?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Message thread specific business data for index. */
export interface MessageData {
    /** Title for the message */
    title?: string | null;
    /** Last message that was was created by the owner */
    ownerLastMessage?: string | null;
    /** Last message that was created by the other party */
    otherPartyLastMessage?: string | null;
    /** Number of messages by Owner that have not been read by the other party */
    ownerUnreadCount?: number | null;
    /** Number of messages that have been read by the Other party and have not been read by the owner. */
    otherPartyUnreadCount?: number | null;
    /** Contains the email or id of the responsible for the partner workflow event. */
    partnerMessageAssignedTo?: string | null;
    /** Key for the usecase based on which it is resolved. 
Later, this may resolve to a user interface, microservice or a to manifest registering one.
For now, just use a unique string starting with a domain you own. */
    usecaseUri?: string | null;
    /** If true, the message is a salaxy email, generated by the system. */
    isSalaxyEmail?: boolean | null;
    /** Start date of the default salary period */
    periodStart?: string | null;
    /** End date of the default salary period */
    periodEnd?: string | null;
    /** Count of calculations in this Payroll */
    calcCount?: number | null;
    /** Time of the last message posted by owner. */
    ownerUpdatedAt?: string | null;
    /** Time of the last message posted by other party. */
    otherPartyUpdatedAt?: string | null;
}

/** Measurement value. */
export interface Measurement {
    /** Tag for the measurement. */
    tag?: string | null;
    /** Time when the measurement was recorded. */
    timestamp?: string | null;
    /** Actual measurement value. */
    value?: number | null;
}

/** Provides the data for onboarding process for a company. Onboarding is the process where Salaxy gathers sufficient information to at least create an acccount, often even more so that the user can pay a salaary with the account. */
export interface Onboarding {
    /** Type of the account to be created. */
    accountType: WebSiteUserRole;
    /** Partner that should be added as primary authorization when the object is created.
Currently not used in update operations (only New and Signature / VismaSign)
and does not set as primary partner except if exception specifically made for a partner. */
    authorizePartner?: string | null;
    /** The server-side status of the onboarding process.
NOTE that there is a more relaxed user interface-level state in ui.state and ui.stateFullText 
that can be used in onboarding user interfaces. */
    status?: OnboardingStatus | null;
    /** Input that is needed for creating a company account. */
    company?: CompanyInput | null;
    /** Input that is needed for creating a personal account.
This may be 
1) the principal account if the account is created for 1a) Worker or 1b) Household or 
2) creator owner if the account is created for a Company. */
    person?: PersonInput | null;
    /** Possibility to define products. 
These can only be defined to one account as part of the onboarding process: 
If company account is created, the products are always for Company, not for the Person =&gt; 
Person will have default products in that case and they need to be edited in a separate process once the accounts have been created. */
    products?: AccountProducts | null;
    /** Input and post data for digital signature. */
    signature?: SignatureData | null;
    /** Validation status and errors. */
    validation?: AccountValidation | null;
    /** User interface related data: Mainly the state of the UI. */
    ui?: OnboardingUIState | null;
    credentials?: OnboardingCredentials | null;
    /** Custom state object that is guaranteed to survive the round-trip in the onboarding process.
Calling application to the onboarding may pass here any data that it needs after the onboarding process is ready and user has been authenticated. */
    appState?: { [key: string]: string; } | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Represents the input for creating a company account. */
export interface CompanyInput {
    /** If true, creates a company account based on company data. */
    doCreate?: boolean | null;
    /** Official name of the company */
    name: string;
    /** URL to a Logo picture (preferably PNG). This logo should be a square - icon type of logo for avatar. */
    logo?: string | null;
    /** The Business ID (Y-tunnus / Business Identity Code) is a code given to businesses and organizations by the PRH or the Tax Administration. 
It consists of seven digits, a dash and a control mark, for example 1234567-8.
Alternative accepted formats incule international VAT number "FI12345678" or number without the dash: "12345678". */
    businessId: string;
    /** This is an official name of the actor.
It originates from the YTJ or Bank authentication. */
    officialName?: string | null;
    /** If an object with the given BusinessID exists, it is resolved here: The unique ID is set here by the onboarding service. This field cannot be set. */
    resolvedId?: string | null;
    /** Identifier at the partner site - typically an organization ID. */
    partnerAccountId?: string | null;
    /** Company ownership for KYC */
    ownership?: Ownership | null;
    /** If true, will fetch the data from the Finnish Business Infromation System (YTJ/BIS).
Fetching is done firstly based on Business ID, if that is not valid then based on name. */
    doYtjUpdate?: boolean | null;
    /** The details of company data as provided by the Finnish Business Infromation System (YTJ/BIS) */
    ytjDetails?: YtjCompany | null;
    /** A search to Finnish Business Infromation System (YTJ/BIS). This search is triggered if you set the RawInput field. */
    ytjSearch?: YtjSearchResult | null;
    /** The legal type of the company, as categorized by Palkkaus / used in generating IBAN numbers. */
    companyType: CompanyType;
    /** Contact information for the company */
    contact?: Contact | null;
    /** List of roles which this account is member of. */
    roles?: Role[] | null;
    /** Language of the company. */
    language?: Language | null;
}

export interface PersonInput {
    /** If true, creates a personal account based on this data.
Otherwise this is just user data for Company. */
    doCreate?: boolean | null;
    /** Contact information for the user / personal account */
    contact?: Contact | null;
    /** Verification objects for contact verification. */
    contactVerification?: OnboardingContactVerifications | null;
    /** Finnish Personal ID (Henkilötunnus /HETU) */
    personalId?: string | null;
    /** This is an official name of the actor.
It originates from the YTJ or Bank authentication. */
    officialName?: string | null;
    /** If an object with the given PersonalId exists, it is resolved here: The unique ID is set here by the onboarding service. This field cannot be set. */
    resolvedId?: string | null;
    /** First name or company name */
    firstName?: string | null;
    /** Last name, for companies, this should be null */
    lastName?: string | null;
    /** URL of the picture if specified as picture (null in a case of type Icon) */
    picture?: string | null;
    /** Bank account number for salary payment */
    bankAccountIban?: string | null;
    /** Language of the person. */
    language?: Language | null;
}

/** Provides an overview and the possibility to edit products that are enabled to this account */
export interface AccountProducts {
    /** The basic services for Salary payment. */
    baseService?: BaseSalaryProduct | null;
    /** Reports and payments to tax authorities. */
    tax?: TaxProduct | null;
    /** Reports and payments to TVR (the unemployment insurance fund of Finland) */
    unemployment?: UnemploymentProduct | null;
    /** Reports ant payments to Pension companies. */
    pension?: PensionProduct | null;
    /** Reports and payments for mandatory employment insurances. */
    insurance?: InsuranceProduct | null;
    /** Bookkeeping reports for salarypayments */
    accounting?: AccountingProduct | null;
    /** Employer health care from the company Heltti */
    healthCareHeltti?: HealthCareHelttiProduct | null;
    /** Pension payments for an entrepreneur */
    pensionEntrepreneur?: PensionEntrepreneurProduct | null;
    /** Defines the pricing partner, service model and pricing model. */
    pricing?: PricingProduct | null;
}

export interface SignatureData {
    /** Name of the signing person.
By default, this is Onboarding Person, but it may be a completely different person. */
    personName?: string | null;
    /** Personal ID of the person, who has the right to sign. */
    personalId?: string | null;
    /** Email that is sent to Signature provider, if any. */
    email?: string | null;
    /** Telephone that is sent to Signature provider, if any. */
    telephone?: string | null;
    /** If true, the person signing is PEP (Politically Exposed Person */
    isPep?: boolean | null;
    /** TODO: To be removed after Signicat is in production.
Data related to VismaSign signature process (API v01). */
    vismaSignData?: VismaSignV01ObData | null;
    /** Data related to Signicat signature process. */
    signicatData?: SignicatData | null;
    /** The account is authorized to sign on behalf of the actual account. */
    isProcura?: boolean | null;
}

/** Validation errors for the onboarding process */
export interface AccountValidation {
    /** If true the official ID is technically valid.
Official ID is either Finnish Personal ID (HETU, Henkilötunnus) or Business ID (Y-tunnus). */
    isOfficialIdValid?: boolean | null;
    /** If false, none of the accounts in ExistingAccounts cannot be accessed by the current user. */
    isAuthorized?: boolean | null;
    /** TODO: NOt implemented yet - should be implemented
If true, the onboarding object has sufficient data to start the Digital Signature process (Visma Sign).
Depending on the use case this may or may not be required for committing the data as account data. */
    canStartSign?: boolean | null;
    /** If true, the validation process has been completed. The IsValid may be true or false. */
    isCompleted?: boolean | null;
    /** Existing account based on official id (Personal ID / Business ID). */
    existingAccount?: Avatar | null;
    /** If true, the data is valid - no errors. */
    readonly isValid?: boolean | null;
    /** If true, has required fields missing data. */
    readonly hasAllRequiredFields?: boolean | null;
    /** Validation errors on invalid field values. 
Note that required fields missing error messages are not here. Only the invalid values. */
    readonly errors?: ApiValidationError[] | null;
}

/** Stores data for the onboarding user interface. */
export interface OnboardingUIState {
    /** State of the user interface. Typically an enumeration that stores where the UI was. E.g. Wizard step. */
    state?: string | null;
    /** Full description of the user interface state for admin and analyses purposes. */
    stateFullText?: string | null;
    /** URL where the user should be redirected back to when the onboarding process is complete. */
    successUrl?: string | null;
    /** URL where the user should be redirected back to if the process is canceled or there is an urecoverable error. */
    cancelUrl?: string | null;
    /** Response type to OAuth -request */
    oAuthResponseType?: string | null;
    /** Salaxy worker invitation key that points to a Salary slip / calculation that the user is coming to fetch 
in this onboarding process. The Onboarding data is prefilled with the data from th Salary calculation. */
    invitationKey?: string | null;
}

/** Stores information about the credentials that were used in the Onboarding process. */
export interface OnboardingCredentials {
    /** Identifier of the credentials (UserAccount Guid in the database). */
    credentialId?: string | null;
    /** The partner that initiated the Onboarding process. */
    partnerId?: string | null;
}

export interface Ownership {
    /** If true, authorities require tracking the shareholders.
In Finland, with current legistlation, this is if a shareholder has over 25% of the shares. */
    isRequiredTracking?: boolean | null;
    /** List of shareholders for the company */
    shareHolders?: Shareholder[] | null;
}

/** The details of company data as provided by the Finnish Business Infromation System (YTJ/BIS) */
export interface YtjCompany {
    /** The Business ID (Y-tunnus / Business Identity Code) is a code given to businesses and organizations by the PRH or the Tax Administration. 
It consists of seven digits, a dash and a control mark, for example 1234567-8.
Alternative accepted formats incule international VAT number "FI12345678" or number without the dash: "12345678". */
    businessId?: string | null;
    /** Official name of the company. 
Source: Tiedostonimi.Tiedostonimi */
    name?: string | null;
    /** The legal type of the company, as categorized by Palkkaus / used in generating IBAN numbers. */
    companyType?: CompanyType | null;
    /** YTJ's legal type of the company as a string. This is only to be used for display purposes.
Source: YritysHaku.YritysMuoto */
    companyTypeText?: string | null;
    /** The internal YTJ code number for the company's legal type. */
    ytjCompanyType?: YtjCompanyType | null;
    /** Original YTJ company type code. */
    ytjCompanyTypeCode?: number | null;
    /** Contact information for the */
    contact?: Contact | null;
    /** Social security number of the contact person in the company, if available. */
    contactPersonPersonalId?: string | null;
    /** Names are not necessarily avaiable. If they are, they may not be reliable. */
    contactPerson?: string | null;
    /** Mobile for or other company phone.
Difference between Contact.Phone and ContactPhone is that 
this (ContactPhone) is first mobile number, then company general phone if the former was null.
Contact.Phone is fisrt general phone number and mobile number only if not available. */
    contactPhone?: string | null;
    /** Web site address */
    www?: string | null;
    /** The sector where the company is active. (Toimialatieto.Koodi) */
    sectorOfBusinessCode?: number | null;
    /** Text of the sector where company operates. */
    sectorOfBusinessText?: string | null;
}

/** Search result for free text search from the Finnish Business Infromation System (YTJ/BIS). Returns a list of companies without details. */
export interface YtjSearchResult {
    /** The original search string - without trimming etc. that are done in the actual search. */
    rawInput?: string | null;
    /** If true, search is a success. This may mean that no results were found though. */
    isSuccess?: boolean | null;
    /** If true, the searh is too generic. 
Typically either there was more than 200 results or less than 3 characters in the search string. 
Both of these return an error in the API. */
    isTooGeneric?: boolean | null;
    /** Technical status - for developers / admin. */
    status?: string | null;
    /** A message that can be shown to the end user. */
    userMessage?: string | null;
    /** API quota counter */
    counter?: number | null;
    /** Result of the search. */
    result?: YtjSearchResultCompany[] | null;
}

/** Contact verification object for onboarding. */
export interface OnboardingContactVerifications {
    /** Verification for email contact. */
    email?: OnboardingContactVerification | null;
    /** Verification for telephone contact. */
    telephone?: OnboardingContactVerification | null;
}

/** First version of the product that integrates the Palkkaus.fi-salary payments to employers accounting. */
export interface BaseSalaryProduct {
    /** If true, worker salary and expense payments are paid directly by the employer. */
    isWorkerSelfHandling?: boolean | null;
    /** Receiver's address for the e-invoice. */
    eInvoiceReceiver?: string | null;
    /** Receiver's operator for the e-invoice. */
    eInvoiceIntermediator?: string | null;
    /** SEPA maksatustunnus */
    sepaBankPartyId?: string | null;
    /** Identifier for the product */
    readonly id?: string | null;
    /** The main short title for the product / service */
    readonly title?: string | null;
    /** The status text that should give the user.
Restrict the length to 56 characters. */
    readonly status?: string | null;
    /** One paragraph description text */
    readonly description?: string | null;
    /** The logo image for the product. */
    readonly img?: string | null;
    /** Identifier for the main product desription article in the Palkkaus.fi CMS */
    readonly articleId?: string | null;
    /** If true, the product is enabled for the current user */
    enabled?: boolean | null;
    /** If false, it is not bossible to enable this product for the current account / environment. 
Typically, this means that the UI should not show this product. */
    visible?: boolean | null;
    /** Indicates (true-value) if the end user has confirmed the product options.
If false, the end user has not confirmed the option. */
    visited?: boolean | null;
}

/** Service related to integration, reporting and payments to tax authorities. */
export interface TaxProduct {
    /** The reference number for the tax authorities */
    paymentReferenceNumber?: string | null;
    /** Defines how the reporting is done for Incomes registry (Tulorekisteri). */
    irReporting?: TaxReportHandling | null;
    /** If true, tax and social security payments are paid directly by the employer. */
    isTaxAndSocialSecuritySelfHandling?: boolean | null;
    /** Identifier for the product */
    readonly id?: string | null;
    /** The main short title for the product / service */
    readonly title?: string | null;
    /** The status text that should give the user.
Restrict the length to 56 characters. */
    readonly status?: string | null;
    /** One paragraph description text */
    readonly description?: string | null;
    /** The logo image for the product. */
    readonly img?: string | null;
    /** Identifier for the main product desription article in the Palkkaus.fi CMS */
    readonly articleId?: string | null;
    /** If true, the product is enabled for the current user */
    enabled?: boolean | null;
    /** If false, it is not bossible to enable this product for the current account / environment. 
Typically, this means that the UI should not show this product. */
    visible?: boolean | null;
    /** Indicates (true-value) if the end user has confirmed the product options.
If false, the end user has not confirmed the option. */
    visited?: boolean | null;
}

/** Product that helps employer to handle the mandatory unemployment insurance reports and payments. */
export interface UnemploymentProduct {
    /** If true, the account has paid salaries this year outside Palkkaus.fi.
This affects the yearly reporting - Palkkaus needs to contact the account.
Note that this is a shared option with the taxation product. */
    isSalariesPaidThisYear?: boolean | null;
    /** If true, the account has made prepayments or is registered to make prepayments.
Palkkaus needs to contact the account. */
    isPrepayments?: boolean | null;
    /** If true, the account himself handles the unemployment insurance notifications. */
    isNotificationsSelfHandling?: boolean | null;
    /** Identifier for the product */
    readonly id?: string | null;
    /** The main short title for the product / service */
    readonly title?: string | null;
    /** The status text that should give the user.
Restrict the length to 56 characters. */
    readonly status?: string | null;
    /** One paragraph description text */
    readonly description?: string | null;
    /** The logo image for the product. */
    readonly img?: string | null;
    /** Identifier for the main product desription article in the Palkkaus.fi CMS */
    readonly articleId?: string | null;
    /** If true, the product is enabled for the current user */
    enabled?: boolean | null;
    /** If false, it is not bossible to enable this product for the current account / environment. 
Typically, this means that the UI should not show this product. */
    visible?: boolean | null;
    /** Indicates (true-value) if the end user has confirmed the product options.
If false, the end user has not confirmed the option. */
    visited?: boolean | null;
}

/** Pension for Workers: The payments and monthly reporting. */
export interface PensionProduct {
    readonly status?: string | null;
    /** The use has a pension contract done (as opposed to acting as a temporary employer that pays the pension without a acontract). */
    isPensionContractDone?: boolean | null;
    /** The pension company where the user has a contract. */
    pensionCompany?: PensionCompany | null;
    /** Number for the contract. */
    pensionContractNumber?: string | null;
    /** If true, the user handles the reporting and payments himself/herself. */
    isPensionSelfHandling?: boolean | null;
    /** If true, there is a new pending contract. */
    isPendingContract?: boolean | null;
    /** Enabled property set automatically by IsPensionSelfHandling. */
    enabled?: boolean | null;
    /** Identifier for the product */
    readonly id?: string | null;
    /** The main short title for the product / service */
    readonly title?: string | null;
    /** One paragraph description text */
    readonly description?: string | null;
    /** The logo image for the product. */
    readonly img?: string | null;
    /** Identifier for the main product desription article in the Palkkaus.fi CMS */
    readonly articleId?: string | null;
    /** If false, it is not bossible to enable this product for the current account / environment. 
Typically, this means that the UI should not show this product. */
    visible?: boolean | null;
    /** Indicates (true-value) if the end user has confirmed the product options.
If false, the end user has not confirmed the option. */
    visited?: boolean | null;
}

/** Employer insurance. Currently, this is the mandatory employer insurance only. */
export interface InsuranceProduct {
    readonly status?: string | null;
    /** If set to true, the insurance is set to a partner insurance. */
    isPartnerInsurance?: boolean | null;
    /** If true, the user indicates that he/she has already made an insurance contract.
Should also fill in the InsuranceCompany and InsuranceContractNumber */
    isInsuranceContractDone?: boolean | null;
    /** Company for the current insurance */
    insuranceCompany?: InsuranceCompany | null;
    /** Contract number for the current insurance. */
    insuranceContractNumber?: string | null;
    /** Enabled property set automatically by IsPartnerInsurance. */
    enabled?: boolean | null;
    /** Identifier for the product */
    readonly id?: string | null;
    /** The main short title for the product / service */
    readonly title?: string | null;
    /** One paragraph description text */
    readonly description?: string | null;
    /** The logo image for the product. */
    readonly img?: string | null;
    /** Identifier for the main product desription article in the Palkkaus.fi CMS */
    readonly articleId?: string | null;
    /** If false, it is not bossible to enable this product for the current account / environment. 
Typically, this means that the UI should not show this product. */
    visible?: boolean | null;
    /** Indicates (true-value) if the end user has confirmed the product options.
If false, the end user has not confirmed the option. */
    visited?: boolean | null;
}

/** First version of the product that integrates the Palkkaus.fi-salary payments to employers accounting. */
export interface AccountingProduct {
    readonly status?: string | null;
    accountantName?: string | null;
    accountantEmail?: string | null;
    accountantPhone?: string | null;
    /** Enabled property set automatically by AccountantName, AccountantEmail and AccountantPhone. */
    enabled?: boolean | null;
    /** Identifier for the product */
    readonly id?: string | null;
    /** The main short title for the product / service */
    readonly title?: string | null;
    /** One paragraph description text */
    readonly description?: string | null;
    /** The logo image for the product. */
    readonly img?: string | null;
    /** Identifier for the main product desription article in the Palkkaus.fi CMS */
    readonly articleId?: string | null;
    /** If false, it is not bossible to enable this product for the current account / environment. 
Typically, this means that the UI should not show this product. */
    visible?: boolean | null;
    /** Indicates (true-value) if the end user has confirmed the product options.
If false, the end user has not confirmed the option. */
    visited?: boolean | null;
}

/** Employer health care from the company Heltti */
export interface HealthCareHelttiProduct {
    /** Defines the product package */
    package?: HelttiProductPackage | null;
    /** Industry of work */
    industry?: HelttiIndustry | null;
    readonly status?: string | null;
    /** Enabled property set automatically by HelttiProductPackage. */
    enabled?: boolean | null;
    /** Identifier for the product */
    readonly id?: string | null;
    /** The main short title for the product / service */
    readonly title?: string | null;
    /** One paragraph description text */
    readonly description?: string | null;
    /** The logo image for the product. */
    readonly img?: string | null;
    /** Identifier for the main product desription article in the Palkkaus.fi CMS */
    readonly articleId?: string | null;
    /** If false, it is not bossible to enable this product for the current account / environment. 
Typically, this means that the UI should not show this product. */
    visible?: boolean | null;
    /** Indicates (true-value) if the end user has confirmed the product options.
If false, the end user has not confirmed the option. */
    visited?: boolean | null;
}

export interface PensionEntrepreneurProduct {
    readonly status?: string | null;
    /** If true, user wants to order a YEL-contract. */
    tempContractMarker?: boolean | null;
    /** Enabled property set automatically by TempContractMarker. */
    enabled?: boolean | null;
    /** Identifier for the product */
    readonly id?: string | null;
    /** The main short title for the product / service */
    readonly title?: string | null;
    /** One paragraph description text */
    readonly description?: string | null;
    /** The logo image for the product. */
    readonly img?: string | null;
    /** Identifier for the main product desription article in the Palkkaus.fi CMS */
    readonly articleId?: string | null;
    /** If false, it is not bossible to enable this product for the current account / environment. 
Typically, this means that the UI should not show this product. */
    visible?: boolean | null;
    /** Indicates (true-value) if the end user has confirmed the product options.
If false, the end user has not confirmed the option. */
    visited?: boolean | null;
}

/** Defines the pricing partner, service model and pricing model. */
export interface PricingProduct {
    /** Current status of pricing. */
    readonly status?: string | null;
    /** Enabled property set automatically if partner set and partner specific pricing model. */
    enabled?: boolean | null;
    /** Defines the pricing partner, service model and pricing model. */
    pricingPartner?: PersonPricingPartner | null;
    /** Identifier for the product */
    readonly id?: string | null;
    /** The main short title for the product / service */
    readonly title?: string | null;
    /** One paragraph description text */
    readonly description?: string | null;
    /** The logo image for the product. */
    readonly img?: string | null;
    /** Identifier for the main product desription article in the Palkkaus.fi CMS */
    readonly articleId?: string | null;
    /** If false, it is not bossible to enable this product for the current account / environment. 
Typically, this means that the UI should not show this product. */
    visible?: boolean | null;
    /** Indicates (true-value) if the end user has confirmed the product options.
If false, the end user has not confirmed the option. */
    visited?: boolean | null;
}

/** For Visma Sign V01, data that is stored within the onboarding object. */
export interface VismaSignV01ObData {
    /** Document ID identifies the document (one or several files) that are to be signed in Visma Sign storage. */
    documentId?: string | null;
    /** Invitation ID that is used in the signature process */
    invitationId?: string | null;
    /** Category / folder where the item is stored. */
    category?: string | null;
    /** File name in Visma Sign. */
    fileName?: string | null;
    /** Logs the authentication service (e.g. 'tupas-osuuspankki', 'tupas-nordea') for later analyses.
All methods are available in https://sign.visma.net/api/v1/auth/methods (test: https://vismasign.frakt.io/api/v1/auth/methods) */
    authService?: string | null;
}

/** Data about the Signicat process. */
export interface SignicatData {
    /** Identifier of the document that is signed. */
    documentId?: string | null;
    /** Document summary after the signature has been done. */
    documentSummary?: any | null;
    /** URI to the signed PDF document: Full unique URI for the BlobFile. */
    pdfBlobUri?: string | null;
}

/** Defines a shareholder. At the moment, this is only a name and it is used only if the person has more than 25% of the shares. Expect this object to be developed with, Ownership percent or number of shares, Id or other such link to the actual person etc. */
export interface Shareholder {
    /** Name of the shareholder. */
    name?: string | null;
}

/** Search result list level of detail of companies coming from YTJ. */
export interface YtjSearchResultCompany {
    /** The Business ID (Y-tunnus / Business Identity Code) is a code given to businesses and organizations by the PRH or the Tax Administration. 
It consists of seven digits, a dash and a control mark, for example 1234567-8.
Alternative accepted formats incule international VAT number "FI12345678" or number without the dash: "12345678". */
    businessId?: string | null;
    /** Official name of the company. */
    name?: string | null;
    /** Numeric ID ("Yritysavain") */
    id?: number | null;
    /** Type of the company. This is a free text type. Not necessary parseable to company type enumeration in details. */
    type?: string | null;
}

/** Contact verification object for single message type. */
export interface OnboardingContactVerification {
    /** Given pin code. */
    pin?: string | null;
}

/** Legacy pricing partner information stored in the Person object */
export interface PersonPricingPartner {
    /** Partner account id. */
    accountId?: string | null;
    /** Pricing model by the partner. */
    pricingModel?: PricingModel | null;
    /** Fee for one calculation, which is visible and paid by customer.
This is not relevant if the PricingModel is PalkkausFee */
    fixedFee?: number | null;
    /** Service model by the partner. */
    serviceModelId?: string | null;
}

/** Data that is used for displaying the welcome page for the Worker account. */
export interface WelcomeDataWorker {
    /** The welcome page timeline cards. */
    timeline?: ApiListItem[] | null;
    /** Active taxcard added by the Worker or null, if none is added (or none is valid for today). */
    activeTaxcard?: Taxcard | null;
}

/** Full tax card that is stored in database and that is used in tax card percentage calculations. Also contains the salary history in the income log. */
export interface Taxcard {
    /** The Worker, whose salaries are paid based on this tax card. */
    worker?: Avatar | null;
    /** Employment for which the tax card is created. */
    employmentId?: string | null;
    /** The input that is coming from the Worker / Tax authorities */
    card: TaxcardInput;
    /** Calculations that have been paid to this tax card. */
    incomeLog?: TaxCardIncome[] | null;
    /** Read-only calculation results and other logic values on the Taxcard. */
    readonly result?: TaxcardResults | null;
    /** If the item is an employer instance of a shared taxcard, contains the original identifier
as URI ("[Server]/[PayloadType]/[Owner]/[Id]", e.g. "https://test-secure.salaxy.com/CalculationDTO/FI86POYL0009461858/16ea052e-f23f-4b72-83a9-b8f6590f0dc9");
This item cannot be set in Save - only in Approve method. */
    copyOfUri?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Input from user for a tax card: What is written in the card plus the state infomration that is directly editable by the user. */
export interface TaxcardInput {
    /** The personal ID as written in the tax card. */
    personalId: string;
    /** Tax card approval state */
    state?: TaxcardState | null;
    /** Year that the tax card is valid for. Typically this means from February of this year to January of the following. */
    forYear: number;
    /** Validity for the taxcard as expressed in the card.
Note that the end date may not be reliable if new taxcard has replaced this one. */
    validity?: DateRange | null;
    /** Tax percent as percent. I.e. for 50% set 50, not 0.5. */
    taxPercent?: number | null;
    /** Income up to which the TaxPercent can be used.
Any income above the limit is taxed with ExcessTaxPercent. */
    incomeLimit?: number | null;
    /** Tax percentage that is used in calculating the widthholding tax for the part of income above the IncomeLimit. */
    taxPercent2?: number | null;
    /** A Worker may request a minimum percent that is deducted even if the effective tax percent would be lower.
This can be used if Worker knows that he/she will be earning more in the year than what was estimated when the taxcard was created. */
    taxPercentMin?: number | null;
    /** TaxPercentMin set by owner of the card.
This overrides the tax percent min set by the taxcard sharer. */
    taxPercentMinOwned?: number | null;
    /** Explicit value of when the item was last checked. At the moment, updated in API fetches only, but may be used later for other checks.
Undefined value is 1.1.2000 */
    lastChecked?: string | null;
    /** The income type of the taxacard if fetched from the tax authorities taxcard API. */
    incomeType?: TaxcardApiIncomeType | null;
    /** Withholding Percentage may include Stock Options and Grants (information from the taxcard API).
This property is not currently in use. */
    includesStockOptionsAndGrants?: boolean | null;
    /** Type of the taxcard as of 2019, when the taxcards logic was simplified by the Finnish tazx authorities. */
    kind?: TaxcardKind | null;
    /** Uri to the file copy of the tax card. 
Set by the system as part of the upload process, do not change in the API though it may be technically possible. This may have unintended results. */
    fileUri?: string | null;
    /** Uri to the preview image of the tax card. 
Set by the system as part of the upload process, do not change in the API though it may be technically possible. This may have unintended results. */
    previewUri?: string | null;
}

/** Defines income that is recorded in a Taxcard: A paid salary calulation, income from previous employers or other salaries that affect the income calculation. */
export interface TaxCardIncome {
    /** Type of income */
    type?: TaxCardIncomeType | null;
    /** Calculation id in the Salaxy database.
If the calculation is not in the Salaxy Database, leave this null. */
    id?: string | null;
    /** Owner of the row, typically the employer that paid the salary.
Null meaning that it is the owner of the original taxcard. */
    owner?: string | null;
    /** A short description of the paid calculation.
This is a mandatory field if the Id is null. */
    description?: string | null;
    /** Beginning of the salary payment period from taxation point-of-view.
This is typically the same as CalcInfo.WorkStartDate, but may be different in edge cases. */
    startDate?: string | null;
    /** End of the salary payment period from taxation point-of-view.
This is typically the same as CalcInfo.WorkEndDate, but may be different in edge cases. */
    endDate?: string | null;
    /** The paidAt date which tells mainly to which year the payment should be attributed.
This is reliable only if the salary is paid by Salaxy (TaxCardIncomeType.SalaxyCalculation).
In other cases it is just the reporting date. */
    paidAt?: string | null;
    /** Taxable income from this calculation */
    income?: number | null;
    /** Widthholding tax in euro */
    tax?: number | null;
    /** When loading calculations from the database (in taxcard Save and FindBy with diff), 
this property identifies the differences in the entry. */
    diff?: IncomeLogDiff | null;
}

/** Read-only calculations and other logic methods on a Taxcard. */
export interface TaxcardResults {
    /** Total income for the actual year, which is used for income limit.
Note that this does not include January income that may be paid for previous year taxcard. */
    readonly totalIncome?: number | null;
    /** Total income for January of the following year that is paid for previous year taxcard (this taxcard) if there is no new taxcard for January. */
    readonly totalIncomeJanuary?: number | null;
    /** Payments of the salary calculations that were made using Palkkaus.fi system (as opposed to external salaries etc) 
and that were marked to this card. These are for the actual year, which is used for income limit.
For Shared card, all employers are considered, for Owner copies of shared card, only salaries paid by owner is considered. */
    readonly payment?: number | null;
    /** Payments of the salary calculations that were made using Palkkaus.fi system (as opposed to external salaries etc) 
and that were marked to this card. These are for January of the following year that is paid for previous year taxcard (this taxcard) if there is no new taxcard for January.
For Shared card, all employers are considered, for Owner copies of shared card, only salaries paid by owner is considered. */
    readonly paymentJanuary?: number | null;
    /** Gets the validity of the taxcard today. This value reflects purely the date value - it does not take into account approval or replacement. */
    readonly validityToday?: TaxcardValidity | null;
}

/** Accounting data for reports. */
export interface AccountingData {
    /** All ledgers. */
    ledgerAccounts?: LedgerAccount[] | null;
    /** Basic information and visualization for the accounting target.
Avatar provides the visualization and the name for the target.
E-mail may be used in sending of the material and telephone in contacting the accounting target.
IBAN number has no use. */
    target?: AccountInIndex | null;
    /** The default export format for tabular (csv, excel) data. */
    format?: string | null;
    /** Finnish Business Identifier (Y-tunnus) for the company. */
    officialId?: string | null;
    /** Employer avatar */
    employer?: Avatar | null;
    /** Contact information for the report. Typically the employer, but may be something else. */
    contact?: Contact | null;
    /** Period for the report. */
    period?: DateRange | null;
    /** Summary containing relevant numbers for the report. For example,
number of calculations, gross and net amounts, payment amounts and Palkkaus fee. */
    summary?: AccountingDataSummary | null;
}

/** Represents a single accounting ledger. */
export interface LedgerAccount {
    /** Legder entries */
    entries?: LedgerEntry[] | null;
    /** Account number. */
    accountNumber?: string | null;
    /** Account name. */
    accountName?: string | null;
    /** Account grouping. */
    accountGrouping?: string | null;
    /** Current saldo for the ledger. */
    readonly saldo?: number | null;
}

/** Summary of the accounting data. Contains main figures: totals and workers and employer total figures. */
export interface AccountingDataSummary {
    /** The total number of calculations included in the report. */
    calculationCount?: number | null;
    /** The total number of distinct workers included in the report. */
    workerCount?: number | null;
    /** Total gross salary of the calculations included in the report. */
    readonly totalGrossSalary?: number | null;
    /** Total payment of the calculations included in the report. */
    readonly totalPayment?: number | null;
    /** Calculation totals that are common to both Worker and Employer. */
    totals?: TotalCalculationDTO | null;
    /** The calculation from the Employer point-of-view */
    employerCalc?: EmployerCalculationDTO | null;
    /** The calculation from the Worker point-of-view */
    workerCalc?: WorkerCalculationDTO | null;
    /** Calculation totals of accrued total holiday pay and related sidecosts. */
    holidayCalc?: HolidayCalculationDTO | null;
    /** Validation messages for the accounting data. */
    validation?: ApiValidation | null;
}

/** Represents a single ledger entry. */
export interface LedgerEntry {
    /** Id for the entry. */
    id?: string | null;
    /** Entry date. */
    entryDate?: string | null;
    /** Entry description. */
    description?: string | null;
    /** Debit indicator. */
    isDebit?: boolean | null;
    /** Posted amount. Includes VAT. */
    amount?: number | null;
    /** VAT percent. */
    vatPercent?: number | null;
    /** VAT amount of specific VAT rate. */
    vatAmount?: number | null;
    /** Applied VAT rate. */
    vatRate?: VatRate | null;
    /** Account number. */
    accountNumber?: string | null;
    /** Account name. */
    accountName?: string | null;
    /** Account grouping. */
    accountGrouping?: string | null;
    /** Dimension data. */
    dimension?: { [key: string]: any; } | null;
}

/** Calculation totals of accrued total holiday pay and related sidecosts. */
export interface HolidayCalculationDTO {
    /** Total sum of accrued holiday pays. */
    totalAccruedHolidayPay?: number | null;
    /** Total sum of accrued holiday pays. */
    totalAccruedHolidayBonus?: number | null;
    /** Total sum of social security payments for accrued holiday pays. */
    totalAccruedHolidaySocialSecurity?: number | null;
    /** Total sum of pension payments for accrued holiday pays. */
    totalAccruedHolidayPension?: number | null;
    /** Total sum of unemployment insurance payments for accrued holiday pays. */
    totalAccruedHolidayUnemployment?: number | null;
    /** Total accident insurance. */
    totalAccruedHolidayAccidentInsurance?: number | null;
    /** Total accident insurance. */
    totalAccruedHolidayGroupLifeInsurance?: number | null;
}

/** Contents for the invoice status notification message. */
export interface InvoiceStatusNotification {
    /** Unique ID for the invoice in Salaxy system.
If omitted, the resolving to an invoice will be made using external id. */
    id?: string | null;
    /** External id can be set in the notification for the invoice for later messaging.
If the notification message contains an External Id AND regular Id, the External Id is updated in the Salaxy database.
If the notification contains External Id, but NO regular Id, an invoice is fetched based on External Id.
In the latter case, a non-existent Id or multiple invoices with the same External Id will throw an exception and the entire update process is canceled. */
    externalId?: string | null;
    /** New status for the invoice. Required main payload of the call. */
    status?: InvoiceStatus | null;
    /** Required Date for the transaction (booking date). */
    date?: string | null;
    /** Required realized amount of the transaction. */
    amount?: number | null;
    /** Optional full name of the payment receiver. Should be sent only if the user or process has the possibility of changing the name. */
    receiverFullName?: string | null;
    /** Optional bank account IBAN of the receiver. Should be sent only if the user or process has the possibility of changing the IBAN. */
    receiverIban?: string | null;
    /** Optional payment reference number. Should be sent only if the user or process has the possibility of changing or removing the reference number.
Changing the reference number will typically lead to an error in the back office process that needs to be manually handled. */
    referenceNumber?: string | null;
    /** The payment type of the invoice. If the payment channel does not support the requested payment type (e.g. Salary),
it should set here the payment type that it used (e.g. Default).
Payment channel should also expect new types to be introduced, without that being a breaking change.
Currently, we expect Default always be supported. */
    paymentType?: InvoicePaymentType | null;
}

/** Absence Period with Worker information. */
export interface WorkerAbsencePeriod {
    /** WorkerAbsences storage object that contains the period */
    absencesId?: string | null;
    /** The Worker that owns the Absence period */
    worker?: Avatar | null;
    /** Identifies a single leave. */
    id?: string | null;
    /** Period for the absance. */
    period?: DateRange | null;
    /** Cause / type of the absence */
    causeCode?: AbsenceCauseCode | null;
    /** If true, the absence is paid by the employer. */
    isPaid?: boolean | null;
    /** If true, annual leaves are accrued from the absence. If false, these days are deducted from the accrual.
By default, you may leave this null and it always follows the IsPaid. */
    isHolidayAccrual?: boolean | null;
    /** Amount of salary that is paid for the absense.
Currently not in use: Would be used in Incomes Register integration. */
    amount?: number | null;
    /** Additional information as recorded by the Employer. */
    notes?: string | null;
    /** Identifier in the source system is a key defined by a source system / partner system.
This is a pass-through string that is passed to the result calculations. */
    sourceId?: string | null;
    /** Number of Bonus days to be paid. */
    bonusDaysCount?: number | null;
}

export interface PageResultOfPayrollListItem {
    items?: PayrollListItem[] | null;
    nextPageLink?: string | null;
    count?: number | null;
}

/** Represents a single item in a list of payrolls in the user interface. It contains header data of the payroll and is basis for searching, filtering and sorting. */
export interface PayrollListItem {
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Person GUID for the owner of the object. */
    ownerId?: string | null;
    /** Metadata for the owner */
    ownerInfo?: AccountInIndex | null;
    /** The main status depending on the type of the object. */
    status?: PayrollStatus | null;
    /** The back office status depending on the type of the object. */
    backOfficeStatus?: string | null;
    /** When the event started. Typically, this is the CreatedAt date, but it may be something else. */
    startAt?: string | null;
    /** This is the end date of the event.
Typically, it is the UserUpdatedAt date, but it may be something else - e.g PaidAt for the calculation. */
    endAt?: string | null;
    /** Gross salary if that is relevant to the transaction. */
    grossSalary?: number | null;
    /** This is the payment from the Owner point-of-view:
Total payment for the Employer and Net salary for the Worker in the case of a calculation.
Only add here the payment, if the payment is really made. */
    payment?: number | null;
    /** Estimated fee of the transaction to Palkkaus.fi. */
    fee?: number | null;
    /** The GUID for the other party. Currently, this is always the PersonID. */
    otherId?: string | null;
    /** The other party (usually a Person) that is involved in the event (e.g Worker if this is a Salary payment by Employer). */
    otherPartyInfo?: AccountInIndex | null;
    /** A very short description describing the object as an event. E.g. "Paid salary" */
    shortText?: string | null;
    /** Business object ids related to this object. E.g. calculations and payrolls in the payment. */
    businessObjects?: string[] | null;
    /** This is valid for calculations only. The estimated date of salary in worker. */
    salaryDate?: string | null;
    /** Business data to include further information of the object. */
    data?: PayrollData | null;
    /** Version number. May be used in conflicts */
    versionNumber?: number | null;
    /** Salaxy uri of the resource. */
    uri?: string | null;
    /** Workflow flags for the object.
Only workflow events with API supported message types are listed. */
    flags?: string[] | null;
    /** Workflow messages for the object.
Only workflow events with API supported message types are listed.
Shown in format "[MessageType]:[Message] ([User] at [UTC-time])" */
    messages?: string[] | null;
    /** Sub category for the payload. E.g. Payment Category, MoneyTransfer Source. */
    entityType?: string | null;
    /** The date for the actual period for which this object is done. */
    logicalDate?: string | null;
    /** Reference information. E.g. Payment or MoneyTransfer reference number. */
    reference?: string | null;
    /** External id for the object in 3rd party system. */
    externalId?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Payroll specific business data for index. */
export interface PayrollData {
    /** Contains the email or id of the responsible for the partner workflow event. */
    partnerMessageAssignedTo?: string | null;
    /** Title that can be specified by the end user. */
    title?: string | null;
    /** What types of wages are paid with this payroll.
May affect the rendering of the user interface (e.g. for     holidays, hours and absences).
Also affects which Workers are show in the add / link dialog by default. */
    wageBasis?: WageBasis | null;
    /** Due date for the payroll. Date when the payment should be made to achieve SalaryDate. */
    dueDate?: string | null;
    /** If true, all calculations have been validated and they are valid for payment.
If false, validation has not been done or some calculations are not valid for payment. */
    isReady?: boolean | null;
    /** Paid at date for the payroll. (Date of the employer's payment). */
    paymentDate?: string | null;
    /** Start date of the default salary period */
    periodStart?: string | null;
    /** End date of the default salary period */
    periodEnd?: string | null;
    /** Count of calculations in this Payroll */
    calcCount?: number | null;
    /** If the Payroll is based on a template, this is the identifier of the template. */
    template?: string | null;
    /** ID of the calendar event that is scheduling creation of occurences from this template. */
    calendarEvent?: string | null;
    /** ID of the calendar event that created this occurence. */
    calendarOccurence?: string | null;
    /** The MessageThread Id, if this payroll is referred in a message thread. */
    messageThreadId?: string | null;
    /** Payment channel. */
    paymentChannel?: PaymentChannel | null;
}

/** Record for storing company or employment details. */
export interface Record {
    /** Salaxy ID of the worker / other paty. This value is required when inserting and cannot be edited later.
WorkerSnapshot is automatically updated upon save. */
    otherId?: string | null;
    /** Optional entity id, for example the employment relation for the worker. */
    entityId?: string | null;
    /** Entity type of the business object, which the records are targeted to. */
    entityType?: string | null;
    /** Record type. This should be based on customer specific enumeration. */
    recordType?: string | null;
    /** Start date of the record. */
    startDate?: string | null;
    /** End date of the record. */
    endDate?: string | null;
    /** Title for the record */
    title?: string | null;
    /** Textual content */
    text?: string | null;
    /** Attachments. */
    attachments?: Attachment[] | null;
    /** A usecase for creating and editing records.
In practice, a usecase is either a user interface or a microservice that provides a salary calculation
and it may be implemented outside Salaxy. */
    usecase?: UsecaseData | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Attachment. */
export interface Attachment {
    /** Name of the attachment. E.g. monthly-details-2018-01.pdf */
    fileName?: string | null;
    /** Content for data. */
    contentId?: string | null;
}

export interface PageResultOfRecordListItem {
    items?: RecordListItem[] | null;
    nextPageLink?: string | null;
    count?: number | null;
}

/** Represents a single item in a list of records in the user interface. */
export interface RecordListItem {
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Person GUID for the owner of the object. */
    ownerId?: string | null;
    /** Metadata for the owner */
    ownerInfo?: AccountInIndex | null;
    /** The main status depending on the type of the object. */
    status?: string | null;
    /** The back office status depending on the type of the object. */
    backOfficeStatus?: string | null;
    /** When the event started. Typically, this is the CreatedAt date, but it may be something else. */
    startAt?: string | null;
    /** This is the end date of the event.
Typically, it is the UserUpdatedAt date, but it may be something else - e.g PaidAt for the calculation. */
    endAt?: string | null;
    /** Gross salary if that is relevant to the transaction. */
    grossSalary?: number | null;
    /** This is the payment from the Owner point-of-view:
Total payment for the Employer and Net salary for the Worker in the case of a calculation.
Only add here the payment, if the payment is really made. */
    payment?: number | null;
    /** Estimated fee of the transaction to Palkkaus.fi. */
    fee?: number | null;
    /** The GUID for the other party. Currently, this is always the PersonID. */
    otherId?: string | null;
    /** The other party (usually a Person) that is involved in the event (e.g Worker if this is a Salary payment by Employer). */
    otherPartyInfo?: AccountInIndex | null;
    /** A very short description describing the object as an event. E.g. "Paid salary" */
    shortText?: string | null;
    /** Business object ids related to this object. E.g. calculations and payrolls in the payment. */
    businessObjects?: string[] | null;
    /** This is valid for calculations only. The estimated date of salary in worker. */
    salaryDate?: string | null;
    /** Business data to include further information of the object. */
    data?: RecordData | null;
    /** Version number. May be used in conflicts */
    versionNumber?: number | null;
    /** Salaxy uri of the resource. */
    uri?: string | null;
    /** Workflow flags for the object.
Only workflow events with API supported message types are listed. */
    flags?: string[] | null;
    /** Workflow messages for the object.
Only workflow events with API supported message types are listed.
Shown in format "[MessageType]:[Message] ([User] at [UTC-time])" */
    messages?: string[] | null;
    /** Sub category for the payload. E.g. Payment Category, MoneyTransfer Source. */
    entityType?: string | null;
    /** The date for the actual period for which this object is done. */
    logicalDate?: string | null;
    /** Reference information. E.g. Payment or MoneyTransfer reference number. */
    reference?: string | null;
    /** External id for the object in 3rd party system. */
    externalId?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Record specific business data for index. */
export interface RecordData {
    /** Record type. This should be based on customer specific enumeration. */
    recordType?: string | null;
    /** Key for the usecase based on which it is resolved. 
Later, this may resolve to a user interface, microservice or a to manifest registering one.
For now, just use a unique string starting with a domain you own. */
    usecaseUri?: string | null;
}

/** Reference object. For testing and development purposes only. This object is a typical business object. The implementation is based on the current development conventions. The reference objects have no meaning or use outside development or testing environments, and they should not be used in production for any business purpose. */
export interface ReferenceObject {
    /** Header for the reference object.
Contains typical header data of various types. */
    header?: ReferenceObjectHeader | null;
    /** Collection of events for the reference object. */
    events?: ReferenceObjectEvent[] | null;
    /** A usecase for reference objects.
In practice, a usecase is either a user interface or a microservice that provides an extension to the default Salaxy functionality,
and it may be implemented outside Salaxy. */
    usecase?: UsecaseData | null;
    /** The workflow data for manual editing and approval purposes. */
    workflowData?: WorkflowData | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Header for the reference object. Contains typical header data of various types. */
export interface ReferenceObjectHeader {
    /** A free text property, the description of the object. */
    description?: string | null;
    /** Enumerated property, the status for the object. */
    status?: BootstrapStyle | null;
    /** Nullable date property, the reference date for the object. */
    referenceDate?: string | null;
}

/** A single event in the collection of events for the reference object. Contains typical row specific data of various types. */
export interface ReferenceObjectEvent {
    /** A free text property, the name of the event. */
    name?: string | null;
    /** Nullable date property, the  date for the event. */
    date?: string | null;
    /** Enumerated property, the result for the event. */
    result?: BootstrapStyle | null;
}

export interface PageResultOfReferenceObjectListItem {
    items?: ReferenceObjectListItem[] | null;
    nextPageLink?: string | null;
    count?: number | null;
}

/** List item for Reference object. For testing and development purposes only. This object is a typical list item for the business object. The implementation is based on the current development conventions. The reference objects have no meaning or use outside development or testing environments, and they should not be used in production for any business purpose. */
export interface ReferenceObjectListItem {
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Person GUID for the owner of the object. */
    ownerId?: string | null;
    /** Metadata for the owner */
    ownerInfo?: AccountInIndex | null;
    /** The main status depending on the type of the object. */
    status?: BootstrapStyle | null;
    /** The back office status depending on the type of the object. */
    backOfficeStatus?: string | null;
    /** When the event started. Typically, this is the CreatedAt date, but it may be something else. */
    startAt?: string | null;
    /** This is the end date of the event.
Typically, it is the UserUpdatedAt date, but it may be something else - e.g PaidAt for the calculation. */
    endAt?: string | null;
    /** Gross salary if that is relevant to the transaction. */
    grossSalary?: number | null;
    /** This is the payment from the Owner point-of-view:
Total payment for the Employer and Net salary for the Worker in the case of a calculation.
Only add here the payment, if the payment is really made. */
    payment?: number | null;
    /** Estimated fee of the transaction to Palkkaus.fi. */
    fee?: number | null;
    /** The GUID for the other party. Currently, this is always the PersonID. */
    otherId?: string | null;
    /** The other party (usually a Person) that is involved in the event (e.g Worker if this is a Salary payment by Employer). */
    otherPartyInfo?: AccountInIndex | null;
    /** A very short description describing the object as an event. E.g. "Paid salary" */
    shortText?: string | null;
    /** Business object ids related to this object. E.g. calculations and payrolls in the payment. */
    businessObjects?: string[] | null;
    /** This is valid for calculations only. The estimated date of salary in worker. */
    salaryDate?: string | null;
    /** Business data to include further information of the object. */
    data?: ReferenceObjectData | null;
    /** Version number. May be used in conflicts */
    versionNumber?: number | null;
    /** Salaxy uri of the resource. */
    uri?: string | null;
    /** Workflow flags for the object.
Only workflow events with API supported message types are listed. */
    flags?: string[] | null;
    /** Workflow messages for the object.
Only workflow events with API supported message types are listed.
Shown in format "[MessageType]:[Message] ([User] at [UTC-time])" */
    messages?: string[] | null;
    /** Sub category for the payload. E.g. Payment Category, MoneyTransfer Source. */
    entityType?: string | null;
    /** The date for the actual period for which this object is done. */
    logicalDate?: string | null;
    /** Reference information. E.g. Payment or MoneyTransfer reference number. */
    reference?: string | null;
    /** External id for the object in 3rd party system. */
    externalId?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

export interface ReferenceObjectData {
}

/** Describes a logical generated report. This is a report instance e.g. a monthly report for January 2017. It may contain several files of different types: PDF, preview PNG, HTML etc. */
export interface Report {
    /** Short title for the report that can be shown to the end user. */
    title?: string | null;
    /** Report date: For monthly and yearly reports this is the first day of the year/month.
For ad-hoc reports, this is the start date of the period. */
    reportDate?: string | null;
    /** Type of the report */
    type?: ReportType | null;
    /** PDF report for viewing and printing. This is typically the main report.
For preview and demo, there is typically only HTML version - no PDF. */
    pdfUrl?: string | null;
    /** Thumbnail image for the report. 
For preview and demo data this is typically a fixed image - the thumbnail is only generated when PDF is generated. */
    thumbnail?: string | null;
    /** HTML for the report. Use salaxy-rpt.css for formatting.
For preview and demo, this is the format to show to the user - PDF is not generated. */
    htmlUrl?: string | null;
    /** Some reports are also available in JSON format, from which you can create lists, CSV, Excel files etc. */
    jsonUrl?: string | null;
    /** If true, the report is in preview state, typically in the middle of the month.
This means that the data itself is production, its just not final. */
    isPreview?: boolean | null;
    /** If true, the report is created using demo data - should be used only in the beginning when the user has not paid any salaries. 
This may be e.g. calculations in draft stage or completely invented demo data such as example workers.
Demo data should not be confused to test database (test-api.palkkaus.fi / test-api.salaxy.com): 
Paid calculations in test database are production data. */
    isDemoData?: boolean | null;
    /** Time when the PDF, HTML or JSON URL's expire IF they are generated in a way that
they are callable without authentication for a specified time period.
This property is null if the URL requires authentication. */
    urlsExpireAt?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Deserializable calculation. */
export interface ReportingCalculation {
    /** The employer object for this calculation.
Typically, you do not need to set this before the actual payment process. */
    employer?: CalcEmployer | null;
    /** The Worker (employee) that has performed the work. */
    worker?: CalcWorker | null;
    /** Information about the workflow and state of the calculation. */
    workflow?: CalcWorkflow | null;
    /** The main salary element. 
Alternatively the salary can be set in the Rows object - this will be the only way to set multiple salary rows (not yet supported). */
    salary?: Salary | null;
    /** Set of rows that make up the salary calculation:
Expenses, Benefits, deductions etc. Note that side costs are not rows. */
    rows?: UserDefinedRow[] | null;
    /** DEPRECIATED: Usecase will be replacing this functionality in a next major release.
The Framework Agreement (TES) parameters that affect the framework based side costs etc. of this calculation */
    framework?: TesParameters | null;
    /** A usecase for creating and editing salary calculations.
In practice, a usecase is either a user interface or a microservice that provides a salary calculation
and it may be implemented outside Salaxy.
Provides the possibility to store useacase specific data as part of calculation.
NOTE: This functionality will replace Framework property in a next major release. */
    usecase?: UsecaseData | null;
    /** The results of the calculation. In the API, this is a read-only object. */
    result?: CalculationResult | null;
    /** Information about the work that is not directly related to calculating salary and expenses. */
    info?: CalcInfo | null;
    /** Sharing of the calculation. This object cannot be modified directly, 
use specialized methods in Calculations service. */
    sharing?: CalculationSharing | null;
    /** Contains calculation specific data for accounting (both cost and financial accounting). */
    accounting?: CalculationAccounting | null;
    /** Worktime data that is stored as part of Salary calculation:
work days, absences, holidays and holiday accrual.
In the future may also contain relevant part of timesheet data (work hours). */
    worktime?: CalcWorktime | null;
    /** Readonly workflow data, which is exposed to API. */
    workflowData?: WorkflowData | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Contains accounting rows for one or many calculations. */
export interface AccountingReportTable {
    /** All rows in the report table. */
    rows?: AccountingReportRow[] | null;
    /** Accounting report table type. */
    tableType?: AccountingReportTableType | null;
    /** Finnish Business Identifier (Y-tunnus) for the company. */
    businessId?: string | null;
    /** Employer avatar */
    employer?: Avatar | null;
    /** Contact information for the report. Typically the employer, but may be something else. */
    contact?: Contact | null;
    /** Period for the report. */
    period?: DateRange | null;
    /** Summary containing relevant numbers for the report. For example,
number of calculations, gross and net amounts, payment amounts and Palkkaus fee. */
    summary?: AccountingReportTableSummary | null;
}

/** Accounting report table row. */
export interface AccountingReportRow {
    /** Row type. Default is the Booking. */
    rowType?: AccountingReportRowType | null;
    /** Amount for the row: May be positive or negative(depending on the depet/credit and account type). */
    amount?: number | null;
    /** Percentage of the value added tax that is included in the amount. */
    vatPercent?: number | null;
    /** Proposed account number for the row. */
    accountNumber?: string | null;
    /** Proposed account text for the row. */
    accountText?: string | null;
    /** Returns product code. */
    productCode?: string | null;
    /** Returns product name. (Code or ResultCode in this order). */
    productName?: string | null;
    /** Text for the booking entry / header. */
    text?: string | null;
    /** Space separated set of class names for CSS styling purposes. */
    styles?: string | null;
    /** Count of units. Default is 1. */
    count?: number | null;
    /** Price for the unit. */
    price?: number | null;
    /** Unit identifier; */
    unit?: string | null;
    /** Additional information for the row. */
    additionalInformation?: string | null;
}

/** Summary of the accounting report. Contains main figures: totals and workers and employer total figures. */
export interface AccountingReportTableSummary {
    /** The total number of calculations included in the report. */
    count?: number | null;
    /** Calculation totals that are common to both Worker and Employer. */
    totals?: TotalCalculationDTO | null;
    /** The calculation from the Employer point-of-view */
    employerCalc?: EmployerCalculationDTO | null;
    /** The calculation from the Worker point-of-view */
    workerCalc?: WorkerCalculationDTO | null;
}

/** Calculation with additional cumulative data. */
export interface CumulativeCalculation {
    /** Cumulative data for the calculation. */
    cumulative?: { [key: string]: CumulativeData; } | null;
    /** The employer object for this calculation.
Typically, you do not need to set this before the actual payment process. */
    employer?: CalcEmployer | null;
    /** The Worker (employee) that has performed the work. */
    worker?: CalcWorker | null;
    /** Information about the workflow and state of the calculation. */
    workflow?: CalcWorkflow | null;
    /** The main salary element. 
Alternatively the salary can be set in the Rows object - this will be the only way to set multiple salary rows (not yet supported). */
    salary?: Salary | null;
    /** Set of rows that make up the salary calculation:
Expenses, Benefits, deductions etc. Note that side costs are not rows. */
    rows?: UserDefinedRow[] | null;
    /** DEPRECIATED: Usecase will be replacing this functionality in a next major release.
The Framework Agreement (TES) parameters that affect the framework based side costs etc. of this calculation */
    framework?: TesParameters | null;
    /** A usecase for creating and editing salary calculations.
In practice, a usecase is either a user interface or a microservice that provides a salary calculation
and it may be implemented outside Salaxy.
Provides the possibility to store useacase specific data as part of calculation.
NOTE: This functionality will replace Framework property in a next major release. */
    usecase?: UsecaseData | null;
    /** The results of the calculation. In the API, this is a read-only object. */
    result?: CalculationResult | null;
    /** Information about the work that is not directly related to calculating salary and expenses. */
    info?: CalcInfo | null;
    /** Sharing of the calculation. This object cannot be modified directly, 
use specialized methods in Calculations service. */
    sharing?: CalculationSharing | null;
    /** Contains calculation specific data for accounting (both cost and financial accounting). */
    accounting?: CalculationAccounting | null;
    /** Worktime data that is stored as part of Salary calculation:
work days, absences, holidays and holiday accrual.
In the future may also contain relevant part of timesheet data (work hours). */
    worktime?: CalcWorktime | null;
    /** Readonly workflow data, which is exposed to API. */
    workflowData?: WorkflowData | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Cumulative data for a single calculation */
export interface CumulativeData {
    /** First and last Salary dates (days when Worker receives the salary) and number of payment days. */
    salaryDates?: DateRange | null;
    /** Working days based on the salary calculations. */
    workingDays?: DateRange | null;
    /** Dictionary of labels of the current data */
    labels?: { [key: string]: string; } | null;
    /** The cumulative data of the calculations. */
    data?: { [key: string]: number; } | null;
    /** The cumulative units of the calculations. */
    units?: { [key: string]: string; } | null;
}

/** A summary report for an employer for a specific period (typically month or year). */
export interface SummaryReportData {
    statistics?: CalculationResultStatistics | null;
    /** Finnish Business Identifier (Y-tunnus) for the company. */
    businessId?: string | null;
    /** Employer avatar */
    employer?: Avatar | null;
    /** Contact information for the report. Typically the employer, but may be something else. */
    contact?: Contact | null;
    /** Start date for the report */
    startDate?: string | null;
    /** End date for the report */
    endDate?: string | null;
    /** The total sum information for the report - this is the main payload of the report */
    result?: CalculationResult | null;
    /** Individual calculations based on which the report is made.
Depending on the request, this may be filled in or null (as opposed to empty list). */
    calculations?: Calculation[] | null;
}

/** Statistics data calculated from the calculation result. */
export interface CalculationResultStatistics {
    /** The total number of calculations included in the report. */
    calculationCount?: number | null;
    /** The total number of distinct workers included in the report. */
    workerCount?: number | null;
    /** WorkerCalc.Pension / Totals.TotalSocialSecurityBase */
    pensionWorkerPercent?: number | null;
    /** WorkerCalc.UnemploymentInsurance / Totals.TotalSocialSecurityBase */
    unemploymentWorkerPercent?: number | null;
    /** WorkerCalc.Tax / Totals.TotalTaxable */
    taxPercent?: number | null;
    /** WorkerCalc.UnionPayment / Totals.TotalTaxable */
    unionPaymentPercent?: number | null;
}

/** Container for calculation report data. */
export interface CalculationReportData {
    /** Calculations as report rows. */
    rows?: { [key: string]: any; }[] | null;
    /** Ir Income type code labels */
    irLabels?: { [key: string]: string; } | null;
    /** Calculation row type labels */
    typeLabels?: { [key: string]: string; } | null;
    /** Total labels */
    totalLabels?: { [key: string]: string; } | null;
}

/** Container for accounting based report data. */
export interface AccountingRowReportData {
    /** Report row created from accounting base rows. */
    rows?: AccountingRowReportDataRow[] | null;
    /** Finnish Business Identifier (Y-tunnus) for the company. */
    officialId?: string | null;
    /** Employer avatar */
    employer?: Avatar | null;
    /** Contact information for the report. Typically the employer, but may be something else. */
    contact?: Contact | null;
    /** Period for the report. */
    period?: DateRange | null;
    /** Summary containing relevant numbers for the report. For example,
number of calculations, gross and net amounts, payment amounts and Palkkaus fee. */
    summary?: AccountingDataSummary | null;
}

/** Report row created from accounting base row data. */
export interface AccountingRowReportDataRow {
    /** Entry group: income type or total type */
    entryCodeGroup?: string | null;
    /** A single code in the code group: single income type code or total row. */
    entryCode?: string | null;
    /** Entry date. */
    entryDate?: string | null;
    /** Entry description. */
    message?: string | null;
    /** Posted amount. Includes VAT. */
    amount?: number | null;
    /** VAT percent. */
    vatPercent?: number | null;
    /** VAT amount of specific VAT rate. */
    vatAmount?: number | null;
    /** Applied VAT rate. This is always mandatory. */
    vatRate?: VatRate | null;
    /** Dimension data. */
    dimension?: { [key: string]: any; } | null;
    /** Additional flags for directing the logic for creating accounting entry based on given entries. */
    flags?: string[] | null;
}

/** The holiday pay debt data report based on given holiday years. */
export interface AccountingHolidayPayDebtReportData {
    /** Finnish Business Identifier (Y-tunnus) for the company. */
    officialId?: string | null;
    /** Employer avatar */
    employer?: Avatar | null;
    /** Contact information for the report. Typically the employer, but may be something else. */
    contact?: Contact | null;
    /** Period for the report. */
    period?: DateRange | null;
    /** Calculated totals of accrued total holiday pay and related sidecosts. */
    holidayCalc?: HolidayCalculationDTO | null;
    /** Individual holiday years and their debt data included in the report. */
    holidayYears?: AccountingHolidayPayDebtReportDataYear[] | null;
}

/** Individual holiday year with the debt data. */
export interface AccountingHolidayPayDebtReportDataYear {
    /** Holiday year for which the debt is calculated. */
    holidayYear?: HolidayYear | null;
    /** Calculation totals of accrued total holiday pay and related sidecosts. */
    holidayCalc?: HolidayCalculationDTO | null;
}

/** A summary report for a worker for a specific period (typically month or year) and selected employer. */
export interface WorkerSummaryReportData {
    statistics?: CalculationResultStatistics | null;
    /** Worker avatar */
    worker?: Avatar | null;
    /** Worker's socials security number */
    workerSocialSecurityNumber?: string | null;
    /** Worker's bank account number */
    workerIbanNumber?: string | null;
    /** Contact information for the report. Typically the employer, but may be something else. */
    workerContact?: Contact | null;
    /** Additional result data for the worker summary report. */
    workerResult?: WorkerSummaryResult | null;
    /** Finnish Business Identifier (Y-tunnus) for the company. */
    businessId?: string | null;
    /** Employer avatar */
    employer?: Avatar | null;
    /** Contact information for the report. Typically the employer, but may be something else. */
    contact?: Contact | null;
    /** Start date for the report */
    startDate?: string | null;
    /** End date for the report */
    endDate?: string | null;
    /** The total sum information for the report - this is the main payload of the report */
    result?: CalculationResult | null;
    /** Individual calculations based on which the report is made.
Depending on the request, this may be filled in or null (as opposed to empty list). */
    calculations?: Calculation[] | null;
}

/** Additional result data for the worker summary report. */
export interface WorkerSummaryResult {
    /** Cash salary row details. */
    cashSalary?: SummaryCalculationRows | null;
    /** Benefits details. */
    benefitsInKind?: SummaryCalculationRows | null;
    /** Expense details. */
    expenses?: SummaryCalculationRows | null;
}

/** Rows and totals for a set of calculation rows. */
export interface SummaryCalculationRows {
    /** Summary rows. */
    rows?: SummaryCalculationRow[] | null;
    /** Total sum of rows. */
    total?: number | null;
}

/** Row containing summary data for the summary report. */
export interface SummaryCalculationRow {
    /** Description text of the row that is shown in reports. */
    message?: string | null;
    /** Count for the row. */
    count?: number | null;
    /** Price for the row. */
    price?: number | null;
    /** Total sum. */
    total?: number | null;
    /** Usecase specific data
This contains especially row label parameters: calculationRowType, kind and code */
    data?: { [key: string]: any; } | null;
}

export interface TaxAtSourceUsecase {
    /** Tax value is either the fixed value (euro) or percentage (0-1) depending on the kind. */
    taxValue?: number | null;
    /** Deduction for the tax at source: Fixed, Monthly or Daily */
    deductionPrice?: number | null;
    /** Count of deduction units: 1 or number of months or days. */
    deductionCount?: number | null;
    /** Value of the deduction: Deduction * DeductionCount */
    deduction?: number | null;
    /** Total taxable value of the salary calculation. */
    totalTaxable?: number | null;
    /** Tax at source related employmment data. */
    employmentData?: TaxAtSource | null;
    /** List of allowed kinds (deductions based on source data).
Currently as a comma separated string. */
    allowedKinds?: string | null;
    /** Primary subtyping of the usecase. */
    kind?: TaxAtSourceKind | null;
}

/** Handles the Calculation of CalculationRowType.IrIncomeType to IrRows */
export interface IrIncomeTypeUsecase {
    /** Reporting details to Incomes registry (Tulorekisteri). */
    irData?: IrDetails | null;
    /** Primary subtyping of the usecase. */
    kind?: TransactionCode | null;
}

/** Handles the Calculation of CalculationRowType.Board to IrRows */
export interface BoardUsecase {
    /** Primary subtyping of the usecase. */
    kind?: BoardKind | null;
}

/** Handles the Calculation of CalculationRowType.Training to IrRows */
export interface TrainingUsecase {
    /** Primary subtyping of the usecase. */
    kind?: TrainingKind | null;
}

/** Handles the Calculation of CalculationRowType.NonProfitOrg to IrRows */
export interface NonProfitOrgUsecase {
    /** Primary subtyping of the usecase. */
    kind?: NonProfitOrgKind | null;
}

/** Handles the Calculation of CalculationRowType.Remuneration to IrRows */
export interface RemunerationUsecase {
    /** Primary subtyping of the usecase. */
    kind?: RemunerationKind | null;
}

/** Handles the Calculation of CalculationRowType.PaidSickLeave to IrRows */
export interface PaidSickLeaveUsecase {
    /** Primary subtyping of the usecase. */
    kind?: PaidSickLeaveKind | null;
}

/** Handles the Calculation of CalculationRowType.OtherCompensation to IrRows */
export interface OtherCompensationUsecase {
    /** Primary subtyping of the usecase. */
    kind?: OtherCompensationKind | null;
}

/** Handles the Calculation of CalculationRowType.EmploymentTermination to IrRows */
export interface EmploymentTerminationUsecase {
    /** Primary subtyping of the usecase. */
    kind?: EmploymentTerminationKind | null;
}

/** Handles the Calculation of CalculationRowType.WorkingTimeCompensation to IrRows */
export interface WorkingTimeCompensationUsecase {
    /** Primary subtyping of the usecase. */
    kind?: WorkingTimeCompensationKind | null;
}

/** Handles both the hourly salary and working time compensation to IrRows */
export interface HourlySalaryWithWorkingTimeCompensationUsecase {
    /** Collection of compensation rows. */
    compensationRows?: WorkingTimeCompensationRow[] | null;
    /** Pricing for the compensation row. */
    pricing?: WorkingTimeCompensationPricing | null;
    /** Primary subtyping of the usecase. */
    kind?: WorkingTimeCompensationKind | null;
}

/** Working time compensation row. */
export interface WorkingTimeCompensationRow {
    /** Count for compensation row. */
    count?: number | null;
    /** Percent for price calculation. */
    percent?: number | null;
    /** Compensation price, fixed price or calculated using percent. */
    price?: number | null;
    /** Message for compensation row */
    message?: string | null;
    /** Unit for compensation row. */
    unit?: CalculationRowUnit | null;
    /** Accounting related data for the row. */
    accounting?: RowAccounting | null;
}

/** Handles the Calculation of CalculationRowType.DailyAllowance to IrRows */
export interface DailyAllowanceUsecase {
    country?: string | null;
    /** If true, the daily allowance is paid in half: The Worker has received 2 free meals (1 if PartialDailyAllowance).
This information is currently not reported to Incomes Register, it is only as information for calculation. */
    isHalf?: boolean | null;
    /** Primary subtyping of the usecase. */
    kind?: DailyAllowanceKind | null;
}

export interface TaxWithholdingUsecase {
    /** Tax percent (0 - 1) {Palkkaus.Model.Usecases.CalculationRows.TaxWithholdingKind.Percentage} or fixed euro amount {Palkkaus.Model.Usecases.CalculationRows.TaxWithholdingKind.FixedValue} for tax with holding. */
    taxValue?: number | null;
    /** Primary subtyping of the usecase. */
    kind?: TaxWithholdingKind | null;
}

/** Optimizes the worker payments using the given target amount. */
export interface TotalWorkerPaymentUsecase {
    /** Calculation row type for adjusting the amount. */
    rowType?: CalculationRowType | null;
    /** Message for the row. */
    message?: string | null;
    /** Primary subtyping of the usecase. */
    kind?: TotalWorkerPaymentKind | null;
}

/** This type of row is currently used only in imports. May later be used also in the calculation. Kind supports format "paid-[code]" and "unpaid-[code]" where code is the Incomes Registry code (also our enumeration numeric value). */
export interface AbsencePeriodUsecase {
    /** If true, the absence is paid by the employer.
If null, uses the default value from the absence cause. */
    isPaid?: boolean | null;
    /** If true, annual leaves are accrued from the absence. If false, these days are deducted from the accrual.
By default, you may leave this null and it always follows the IsPaid. */
    isHolidayAccrual?: boolean | null;
    /** Primary subtyping of the usecase. */
    kind?: AbsenceCauseCode | null;
}

/** Handles the Calculation of CalculationRowType.BicycleBenefitUsecase to IrRows */
export interface BicycleBenefitUsecase {
    /** Deduction from salary */
    deduction?: number | null;
    /** Taxable amount of the benefit. */
    taxable?: number | null;
    /** Number of periods if Kind is PeriodicalDeduction. 
Otherwise this value is null. */
    periodDivider?: number | null;
    /** Primary subtyping of the usecase. */
    kind?: BicycleBenefitKind | null;
}

/** Handles the Calculation of CalculationRowType.SubsidisedCommute to IrRows */
export interface SubsidisedCommuteUsecase {
    /** Deduction from salary */
    deduction?: number | null;
    /** Taxable amount of the benefit. */
    taxable?: number | null;
    /** Number of periods if Kind is PeriodicalDeduction. 
Otherwise this value is null. */
    periodDivider?: number | null;
    /** Primary subtyping of the usecase. */
    kind?: SubsidisedCommuteKind | null;
}

/** Handles the Calculation of CalculationRowType.CarBenefitUsecase to IrRows */
export interface CarBenefitUsecase {
    /** Age group as in A,B,C or I for international. */
    ageGroup?: AgeGroupCode | null;
    /** If true, the calculation is kilometers based. */
    isKilometersBased?: boolean | null;
    /** Number of kilometers is filled in only if that type of benefit calculation is used. */
    kilometers?: number | null;
    /** Car emissions value

The car emissions value must be greater than or equal to 0, and smaller than or
equal to 100. The car emissions value can only be reported if the payment date
or other reporting date is in 2022–2025. */
    emissionsValue?: number | null;
    /** Deduction from salary */
    deduction?: number | null;
    /** Primary subtyping of the usecase. */
    kind?: CarBenefitKind | null;
}

/** Handles the Calculation of CalculationRowType.MealBenefit to IrRows */
export interface MealBenefitUsecase {
    /** Deduction from salary */
    deduction?: number | null;
    /** The taxable price calculated by the server. */
    taxablePrice?: number | null;
    /** If true, the deduction from Worker salary corresponds to taxable value. */
    isTaxValue?: boolean | null;
    /** If true, the deduction from Worker Salary has already been done or will be done and is not added to this calculation. */
    isTaxValueDeductionDone?: boolean | null;
    /** Primary subtyping of the usecase. */
    kind?: MealBenefitKind | null;
}

/** Handles the Calculation of CalculationRowType.UnionPayment to IrRows */
export interface UnionPaymentUsecase {
    /** Reference for the union payment. */
    referenceNumber?: string | null;
    /** The full name of the union for payment purposes. */
    recipientFullName?: string | null;
    /** The International Bank Account Number of the union. */
    iban?: string | null;
    /** Percentage of the total taxable amount to pay.
Please note that this is only applicable for {Palkkaus.Model.Usecases.CalculationRows.UnionPaymentKind.PercentageAndLimits}. */
    paymentPercentage?: number | null;
    /** Maximum payment limit, or null if not desired.
Please note that this is only applicable for {Palkkaus.Model.Usecases.CalculationRows.UnionPaymentKind.PercentageAndLimits}. */
    maximumPayment?: number | null;
    /** Minimum payment limit, or null if not desired.
Please note that this is only applicable for {Palkkaus.Model.Usecases.CalculationRows.UnionPaymentKind.PercentageAndLimits}. */
    minimumPayment?: number | null;
    /** Primary subtyping of the usecase. */
    kind?: UnionPaymentKind | null;
}

/** Handles the Calculation of CalculationRowType.Foreclosure to IrRows */
export interface ForeclosureUsecase {
    /** Reference for the payment. */
    referenceNumber?: string | null;
    /** Length of the salary payment period. */
    periodLength?: number | null;
    /** Count of dependants of the debtor. Typically spouse and children. */
    dependantsCount?: number | null;
    /** Amount of the protected portion for each day. */
    protectedPortionBase?: number | null;
    /** Amount of the protected portion for each dependant for each day. */
    protectedPortionDependant?: number | null;
    /** Income from other sources. */
    incomeFromOtherSources?: number | null;
    /** Additional amount to be left to debtor. */
    additionalAmountLeftToDebtor?: number | null;
    /** Primary subtyping of the usecase. */
    kind?: ForeclosureKind | null;
}

/** Sample object for creating v03 controller */
export interface SampleApiObject {
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

export interface PageResultOfSampleListItem {
    items?: SampleListItem[] | null;
    nextPageLink?: string | null;
    count?: number | null;
}

/** Available Search index data of the Sample object */
export interface SampleListItem {
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Person GUID for the owner of the object. */
    ownerId?: string | null;
    /** Metadata for the owner */
    ownerInfo?: AccountInIndex | null;
    /** The main status depending on the type of the object. */
    status?: string | null;
    /** The back office status depending on the type of the object. */
    backOfficeStatus?: string | null;
    /** When the event started. Typically, this is the CreatedAt date, but it may be something else. */
    startAt?: string | null;
    /** This is the end date of the event.
Typically, it is the UserUpdatedAt date, but it may be something else - e.g PaidAt for the calculation. */
    endAt?: string | null;
    /** Gross salary if that is relevant to the transaction. */
    grossSalary?: number | null;
    /** This is the payment from the Owner point-of-view:
Total payment for the Employer and Net salary for the Worker in the case of a calculation.
Only add here the payment, if the payment is really made. */
    payment?: number | null;
    /** Estimated fee of the transaction to Palkkaus.fi. */
    fee?: number | null;
    /** The GUID for the other party. Currently, this is always the PersonID. */
    otherId?: string | null;
    /** The other party (usually a Person) that is involved in the event (e.g Worker if this is a Salary payment by Employer). */
    otherPartyInfo?: AccountInIndex | null;
    /** A very short description describing the object as an event. E.g. "Paid salary" */
    shortText?: string | null;
    /** Business object ids related to this object. E.g. calculations and payrolls in the payment. */
    businessObjects?: string[] | null;
    /** This is valid for calculations only. The estimated date of salary in worker. */
    salaryDate?: string | null;
    /** Business data to include further information of the object. */
    data?: SampleData | null;
    /** Version number. May be used in conflicts */
    versionNumber?: number | null;
    /** Salaxy uri of the resource. */
    uri?: string | null;
    /** Workflow flags for the object.
Only workflow events with API supported message types are listed. */
    flags?: string[] | null;
    /** Workflow messages for the object.
Only workflow events with API supported message types are listed.
Shown in format "[MessageType]:[Message] ([User] at [UTC-time])" */
    messages?: string[] | null;
    /** Sub category for the payload. E.g. Payment Category, MoneyTransfer Source. */
    entityType?: string | null;
    /** The date for the actual period for which this object is done. */
    logicalDate?: string | null;
    /** Reference information. E.g. Payment or MoneyTransfer reference number. */
    reference?: string | null;
    /** External id for the object in 3rd party system. */
    externalId?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Sample custom data in search index */
export interface SampleData {
    /** A test string */
    test?: string | null;
}

export interface ServiceModel {
    /** Name of the service model */
    name?: string | null;
    /** URL for the icon that represents the service model */
    icon?: string | null;
    /** Service model features, which can be switched on/off. */
    features?: ServiceModelFeatures | null;
    /** Default accounting settings. */
    accounting?: ServiceModelAccounting | null;
    /** Default cost accounting settings. */
    costAccounting?: ServiceModelCostAccounting | null;
    /** Default holiday settings. */
    holiday?: ServiceModelHoliday | null;
    /** Default pricing settings. */
    pricing?: ServiceModelPricing | null;
    /** Default payment channels. */
    payments?: ServiceModelPayments | null;
    /** Partner branding settings: site logo, css etc. */
    branding?: ServiceModelBranding | null;
    /** Reporting layout settings. */
    reporting?: ServiceModelReporting | null;
    /** Default site for customers. */
    site?: ServiceModelSite | null;
    /** Settings related to usecases. */
    usecase?: ServiceModelUsecase | null;
    /** Settings related to messaging. */
    messaging?: ServiceModelMessaging | null;
    /** Settings related to the calculation data delivery by forms. */
    forms?: ServiceModelForms | null;
    /** Readonly workflow data, which is exposed to API. */
    workflowData?: WorkflowData | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Service model features, which can be swithced on/off. */
export interface ServiceModelFeatures {
    /** If true, the messaging is switched on for this service model. */
    messaging?: boolean | null;
    /** If true, the calculation data delivery by forms is switched on. */
    forms?: boolean | null;
    /** If true, the service model accounting settings override company  settings. */
    accounting?: boolean | null;
    /** If true, the service model cost accounting settings override company  settings. */
    costAccounting?: boolean | null;
    /** If true, the service model holiday settings override company  settings. */
    holiday?: boolean | null;
    /** If true, the service model payment settings override company  settings. */
    payments?: boolean | null;
    /** If true, the service model reporting settings override company settings. */
    reporting?: boolean | null;
    /** If true, the service model usecase settings override company settings. */
    usecase?: boolean | null;
}

/** Settings related to Accounting */
export interface ServiceModelAccounting {
    /** Default accounting target. */
    defaultTargetId?: string | null;
    /** Default period selection method:  PaidAt date (paid by employer), Salary date (paid to worker) or Work date (work done). The default is PaidAt date. */
    defaultPeriodDateKind?: PeriodDateKind | null;
    /** Accounting target systems and the rulesets assigned to them. */
    targets?: AccountingTargetSettings[] | null;
}

/** Settings related to Cost Accounting */
export interface ServiceModelCostAccounting {
    /** Cost accounting dimensions */
    dimensions?: CostAccountingDimensionDefinition[] | null;
}

/** Settings related to Holiday */
export interface ServiceModelHoliday {
    /** Settings for holiday pay calculations.
The default is null and the default settings are used. */
    holidayPaySettings?: HolidayPaySettings[] | null;
    /** Settings for the accrual calculations.
The default is null and the default settings are used. */
    holidayAccrualSettings?: HolidayAccrualSettings[] | null;
}

/** Service model specific pricing settings for customers. */
export interface ServiceModelPricing {
    /** Pricing model by the partner. */
    pricingModel?: PricingModel | null;
    /** Fee for one calculation, which is visible and paid by customer.
This is not relevant if the PricingModel is PalkkausFee */
    fixedFee?: number | null;
}

/** Default payment channels for customers. */
export interface ServiceModelPayments {
    /** The default channel when making payments. */
    defaultChannel?: PaymentChannel | null;
    /** Channel specific settings. */
    channels?: PaymentChannelSettings[] | null;
}

/** Service model branding settings: logo, css etc. */
export interface ServiceModelBranding {
    /** Url to logo. */
    logo?: string | null;
    /** Css path. */
    skin?: string | null;
}

/** Defines the settings for producing reports: Mainly PDF's but also HTMl previews. */
export interface ServiceModelReporting {
    /** Identifier of the report layout template in id@partition or URI format. */
    layoutTemplateId?: string | null;
    /** Layouts may define some variables that may be overriden, e.g. colors, margins, font-sizes. */
    layoutTemplateVariables?: string | null;
    /** The company logo that is used by some Layouts */
    logo?: string | null;
}

/** Stores information about the web site that is used for customer (employer) to access the customer web site. */
export interface ServiceModelSite {
    /** Type of web app that the customer is using to interact in the service process. */
    webApp?: CustomerWebApp | null;
    /** Web application URL when the WebApp is Custom. */
    webAppUrl?: string | null;
    /** Name for the web application- */
    webAppName?: string | null;
    /** Override the translated texts for a service model.
Key in the dictionary is a full key starting from the language, e.g. "fi.SALAXY.NG1_Sitemap.home". */
    texts?: { [key: string]: string; } | null;
    /** Sitemap customizations based on product sitemap.
Key is a full sitemap id (dot path) and data is a dataobject that is merged to SiteMap. */
    sitemap?: { [key: string]: any; } | null;
}

/** Usecase related settings. */
export interface ServiceModelUsecase {
    /** Available usecases for the current account. */
    usecases?: UsecaseInSettings[] | null;
}

/** Settings related to Messaging. */
export interface ServiceModelMessaging {
    /** Enable partner communication. Enabled by default. */
    partnerMessages?: boolean | null;
    /** Options for the notification to be sent to the worker after the salary payment. */
    workerSalaryNotifications?: WorkerSalaryNotification[] | null;
    /** Options for the delivery of the payslip to the worker. */
    workerSalarySlipDeliveryMethods?: WorkerSalarySlipDeliveryMethod[] | null;
}

/** Settings related to the calculation data delivery by forms. */
export interface ServiceModelForms {
}

/** Specifies thee properties that are set for this accounting target in relation to the accounting channel. */
export interface AccountingTargetSettings {
    /** Id of the target definition. */
    id?: string | null;
    /** Channel is the technical transport mechanism to accounting software */
    channel?: AccountingChannel | null;
    /** The default export method for exports: whether automatic or manual. */
    method?: ExportMethod | null;
    /** If specified, defines the available methods in manual exports. */
    availableMethods?: ExportMethod[] | null;
    /** The default export format for tabular (csv, excel) data. */
    format?: string | null;
    /** Web hook url for notifications.
If any calculation changes in some past month, this url is called by the system to notify the company about the change.
The month of change ("month") is added as query parameter to the url automatically by the system. */
    webHookUrl?: string | null;
    /** Name and visualization for selection lists. */
    avatar?: Avatar | null;
    /** Usecase specific data */
    data?: { [key: string]: any; } | null;
}

/** Channel-specific payment settings */
export interface PaymentChannelSettings {
    /** Identifies the channel */
    channel?: PaymentChannel | null;
    /** If true, the channel is enabled for the current user */
    isEnabled?: boolean | null;
    /** Read-only property that tells whether the payment channel is available in the current session. */
    isAvailable?: boolean | null;
    /** Usecase specific data */
    data?: { [key: string]: any; } | null;
}

/** Usecase definition. */
export interface UsecaseInSettings {
    /** Uri of the usecase */
    uri?: string | null;
    /** Item type of the usecase */
    itemType?: ApiItemType | null;
    /** Short title for the usecase */
    label?: string | null;
    /** Status of the usecase in the settings.
The status affects the visibilty of the usecase. */
    status?: UsecaseStatus | null;
    /** Order setting for the usecases.
This is needed e.g. ad hoc reports. */
    order?: number | null;
}

export interface PageResultOfServiceModelListItem {
    items?: ServiceModelListItem[] | null;
    nextPageLink?: string | null;
    count?: number | null;
}

/** Represents a partner service model. */
export interface ServiceModelListItem {
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Person GUID for the owner of the object. */
    ownerId?: string | null;
    /** Metadata for the owner */
    ownerInfo?: AccountInIndex | null;
    /** The main status depending on the type of the object. */
    status?: string | null;
    /** The back office status depending on the type of the object. */
    backOfficeStatus?: string | null;
    /** When the event started. Typically, this is the CreatedAt date, but it may be something else. */
    startAt?: string | null;
    /** This is the end date of the event.
Typically, it is the UserUpdatedAt date, but it may be something else - e.g PaidAt for the calculation. */
    endAt?: string | null;
    /** Gross salary if that is relevant to the transaction. */
    grossSalary?: number | null;
    /** This is the payment from the Owner point-of-view:
Total payment for the Employer and Net salary for the Worker in the case of a calculation.
Only add here the payment, if the payment is really made. */
    payment?: number | null;
    /** Estimated fee of the transaction to Palkkaus.fi. */
    fee?: number | null;
    /** The GUID for the other party. Currently, this is always the PersonID. */
    otherId?: string | null;
    /** The other party (usually a Person) that is involved in the event (e.g Worker if this is a Salary payment by Employer). */
    otherPartyInfo?: AccountInIndex | null;
    /** A very short description describing the object as an event. E.g. "Paid salary" */
    shortText?: string | null;
    /** Business object ids related to this object. E.g. calculations and payrolls in the payment. */
    businessObjects?: string[] | null;
    /** This is valid for calculations only. The estimated date of salary in worker. */
    salaryDate?: string | null;
    /** Business data to include further information of the object. */
    data?: ServiceModelData | null;
    /** Version number. May be used in conflicts */
    versionNumber?: number | null;
    /** Salaxy uri of the resource. */
    uri?: string | null;
    /** Workflow flags for the object.
Only workflow events with API supported message types are listed. */
    flags?: string[] | null;
    /** Workflow messages for the object.
Only workflow events with API supported message types are listed.
Shown in format "[MessageType]:[Message] ([User] at [UTC-time])" */
    messages?: string[] | null;
    /** Sub category for the payload. E.g. Payment Category, MoneyTransfer Source. */
    entityType?: string | null;
    /** The date for the actual period for which this object is done. */
    logicalDate?: string | null;
    /** Reference information. E.g. Payment or MoneyTransfer reference number. */
    reference?: string | null;
    /** External id for the object in 3rd party system. */
    externalId?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Service model specific business data for index. */
export interface ServiceModelData {
    /** Contains the email or id of the responsible for the partner workflow event. */
    partnerMessageAssignedTo?: string | null;
    /** Url to logo. */
    logo?: string | null;
    /** Css path. */
    skin?: string | null;
    /** Name for the web application- */
    webAppName?: string | null;
    /** Square icon for the service model. Used in listings etc. */
    icon?: string | null;
}

/** Passes the data about the authorization that is the bases for callin the services that require user authorization. */
export interface UserSession {
    /** If false, the current user needs to be authenticated or authenticated user does not have acces to the system. */
    isAuthorized?: boolean | null;
    /** If false, the current user does not have a credential in the system =&gt; need to redirect to login */
    hasCredential?: boolean | null;
    /** If false, the current user does not have a current account. 
If HasCredential is true, this means that the user should be redirected to Account creation wizard. */
    hasCurrentAccount?: boolean | null;
    /** Authorization status */
    status?: AuthorizationStatus | null;
    /** Avatar that should be shown for the current session.
Typically CurrentAccount.Avatar, but could theoretically be something different. */
    avatar?: Avatar | null;
    /** The current user credentials. */
    currentCredential?: SessionUserCredential | null;
    /** The current Palkkaus.fi-account that the user acting as */
    currentAccount?: IVerifiedAccount | null;
    /** Contains html for system alert. */
    systemAlertHtml?: string | null;
    /** Often needed settings directly in session object.
NOTE: For editing settings, request the full settings object separately. */
    settings?: AccountSettingsInSession | null;
}

/** An account that is verified. Typically this means a digitally signed contract. This means that the account also has an Identity object. However, as the Identity object contains confidential information, it is not necessarily present in all method calls. */
export interface IVerifiedAccount {
    /** Information about the verification of the account. 
NOTE that this object may not be present in many method calls - this is because it contains confidential information. */
    identity?: Identity | null;
    /** If true, the account has been verified. Typically this means a digitally signed contract.
This means that the account also has an Identity object.
However, as the Identity object contains confidential information, it is not necessarily present in all method calls. */
    readonly isVerified?: boolean | null;
    /** Avatar is the visual representation of the Account. */
    avatar?: Avatar | null;
    /** Contact information for the Account. */
    contact?: Contact | null;
    /** Language of the person/company. */
    language?: Language | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated */
    updatedAt?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Pricing partner information. */
    partner?: string | null;
}

/** Read-only account settings in Session: These are the settings that should be immediately available in the regular UI without separate loading. */
export interface AccountSettingsInSession {
    /** Pension contracts for optional selection of cotnract in Worker / Calc UI's */
    pensionContracts?: PensionContract[] | null;
    /** Insurance contracts for optional selection of cotnract in Worker / Calc UI's */
    insuranceContracts?: InsuranceContract[] | null;
    /** If true, the reporting layout is customized and should be loadded from the server in preview and reporting. */
    hasCustomReport?: boolean | null;
    /** The default accounting target for accounting reports. */
    accountingTarget?: AccountingTargetSettings | null;
    /** Partner and service model */
    partner?: PrimaryPartnerSettings | null;
    /** The payment channels that are enabled for the current user. */
    paymentChannels?: PaymentChannel[] | null;
    /** Current default payment channel */
    defaultPaymentChannel?: PaymentChannel | null;
    /** Available usecases for the current user. */
    usecases?: UsecaseInSettings[] | null;
    /** Basic information about the avialable integrations: Server URL and supported behaviors in the future. */
    integration?: IntegrationInSession | null;
    /** Partner messages enabled. */
    partnerMessages?: boolean | null;
    /** Cost accounting model. */
    costAccounting?: CostAccountingInSession | null;
    /** Forms settings for session. */
    forms?: FormsInSession | null;
}

/** Defines a pension contract. */
export interface PensionContract {
    /** The pension company where the user has a contract. */
    company?: PensionCompany | null;
    /** The pension contract number that should be validated accordingly. */
    contractNumber?: string | null;
    /** Sub organization code for the Incomes Registry. */
    subOrgCode?: string | null;
    /** Pension discount percent. */
    pensionDiscountPercent?: number | null;
    /** Custom pension percent. */
    pensionPercent?: number | null;
    /** Read only pension percent which is valid if pension percent is not set. */
    readonly pensionDefaultPercent?: number | null;
    /** Unique identifier (guid) for the contract.
The value is automaticallyh added on the server side: Any input is ignored/invalid. Set as null for new contracts. */
    id?: string | null;
    /** Status of the contract */
    status?: SettingsStatus | null;
    /** If specified, defines the start date for the contract.
If in the future, the the contract is inactive. Null (default) means the contract is valid indefinetely from the past. */
    startDate?: string | null;
    /** If specified, defines the end date for the contract. 
Date is inclusive meaning that if EndDate is 31.12., contract is valid until end-of-year: Valid on 31.12. and invalid 1.1.
If in the past, the the contract is inactive. Null (default) means the contract is valid indefinetely to future. */
    endDate?: string | null;
}

/** Represents an insurance contract for employer or information that the employer knowingly does not have an insurance contract. The latter is legal when only a very small amount of salaries is paid. */
export interface InsuranceContract {
    /** If set to true, the insurance is set to a partner insurance. */
    isPartnerInsurance?: boolean | null;
    /** Company for the current insurance */
    company?: InsuranceCompany | null;
    /** The accident insurance contract number that should be validated accordingly. */
    contractNumber?: string | null;
    /** Percent for calculating the estimate for the accident insurance amount to pay. */
    insurancePercent?: number | null;
    /** Percent for calculating the estimate for the group life insurance amount to pay. */
    groupLifeInsurancePercent?: number | null;
    /** Unique identifier (guid) for the contract.
The value is automaticallyh added on the server side: Any input is ignored/invalid. Set as null for new contracts. */
    id?: string | null;
    /** Status of the contract */
    status?: SettingsStatus | null;
    /** If specified, defines the start date for the contract.
If in the future, the the contract is inactive. Null (default) means the contract is valid indefinetely from the past. */
    startDate?: string | null;
    /** If specified, defines the end date for the contract. 
Date is inclusive meaning that if EndDate is 31.12., contract is valid until end-of-year: Valid on 31.12. and invalid 1.1.
If in the past, the the contract is inactive. Null (default) means the contract is valid indefinetely to future. */
    endDate?: string | null;
}

/** Settings related to the primary partner, service model and settings */
export interface PrimaryPartnerSettings {
    /** Partner account id. */
    accountId?: string | null;
    /** TODO: Consider is this the right place for the all this info or should we have only the input here. */
    info?: AccountantInfo | null;
    /** If true, the accountant is a registered Palkkaus.fi account who typically has access to this account. */
    type?: AccountantType | null;
    /** Id of the service model. */
    serviceModelId?: string | null;
    /** Defines the service model for the customer. */
    serviceModel?: PartnerServiceModel | null;
}

/** Settings related to Integrations that should be immediately available with session without separate load. */
export interface IntegrationInSession {
    /** URL to custom staging / integration server.
Used in running custom usecases and other custom integrations (currently imports). */
    serverUrl?: string | null;
}

/** Cost accounting models for session. */
export interface CostAccountingInSession {
    /** Cost accounting dimensions */
    dimensions?: CostAccountingDimensionDefinition[] | null;
}

/** Settings for session related to the calculation data delivery by forms. */
export interface FormsInSession {
}

/** Accountant details. */
export interface AccountantInfo {
    /** Avatar for the account */
    avatar?: Avatar | null;
    /** Official id of the person or company. */
    officialId?: string | null;
    /** Email address. */
    email?: string | null;
    /** Telephone number. */
    telephone?: string | null;
    /** Bank account number (IBAN) */
    ibanNumber?: string | null;
}

/** Defines how the primary partner services the customer TODO: To be designed, see G:\My Drive\Tech\Phase 7\Settings\Palvelumallit.pptx */
export interface PartnerServiceModel {
    /** The main product package that defines the product features. */
    features?: ServiceModelFeatures | null;
    /** Picing settings. */
    pricing?: ServiceModelPricing | null;
    /** Partner branding settings: site logo, css etc. */
    branding?: ServiceModelBranding | null;
    /** Default site for customers. */
    site?: ServiceModelSite | null;
}

/** Provides the settings for a Company Employer account (all settings details for employer). */
export interface CompanyAccountSettings {
    /** Salary calculation related settings. */
    calc?: CalculationSettings | null;
    /** Reporting and layout related settings. */
    reporting?: ReportingSettings | null;
    /** Primary partner, service model and pricing. */
    partner?: PrimaryPartnerSettings | null;
    /** Defines how accounting is done and to which target it is exported / sent. */
    accounting?: AccountingSettings | null;
    /** Cost accounting settings, e.g. cost centers and projects. */
    costAccounting?: CostAccountingSettings | null;
    /** Holiday settings for accruals and holiday pay calculations. */
    holiday?: HolidaySettings | null;
    /** Settings related to making of the payments. */
    payments?: PaymentSettings | null;
    /** Custom usecases. */
    usecase?: UsecaseSettings | null;
    /** Settings related to messaging. */
    messaging?: MessagingSettings | null;
    /** Settings related to the calculation data delivery by forms. */
    forms?: FormsSettings | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
}

/** Settings that affect the calculation result of the salaries. */
export interface CalculationSettings {
    /** Collection of pension contracts. In most cases, employer has only one, but in edge cases there may be several. */
    pensionContracts?: PensionContract[] | null;
    /** Collection of mandatory accident insurance contracts.
In most cases, employer has only one, but in edge cases there may be several. */
    insuranceContracts?: InsuranceContract[] | null;
    /** Settings related to unemployment insurance. */
    unemploymentInsurance?: UnemploymentInsuranceSettings | null;
    /** Settings related to reporting the salaries to authorities through Incomes Register. */
    incomesRegister?: IncomesRegisterSettings | null;
    /** Contains default calculation rows for the company.
Typically used for setting for example monthly salary or hourly salary price for all workers. */
    salaryDefaults?: UserDefinedRow[] | null;
}

/** Defines the settings for producing reports: Mainly PDF's but also HTMl previews. */
export interface ReportingSettings {
    /** If true, the service model is not applied to this feature. */
    denyServiceModel?: boolean | null;
    /** Identifier of the report layout template in id@partition or URI format. */
    layoutTemplateId?: string | null;
    /** Layouts may define some variables that may be overriden, e.g. colors, margins, font-sizes. */
    layoutTemplateVariables?: string | null;
    /** The company logo that is used by some Layouts */
    logo?: string | null;
}

/** Settings related to Accounting */
export interface AccountingSettings {
    /** If true, the service model is not applied to this feature. */
    denyServiceModel?: boolean | null;
    /** Default accounting target. */
    defaultTargetId?: string | null;
    /** Accounting target systems and the rulesets assigned to them. */
    targets?: AccountingTargetSettings[] | null;
    /** Default period selection method:  PaidAt date (paid by employer), Salary date (paid to worker) or Work date (work done). The default is PaidAt date. */
    defaultPeriodDateKind?: PeriodDateKind | null;
    /** Options for accounting report delivery for the company.
These are not affected by the service model. */
    reportDelivery?: AccountingReportDelivery | null;
    /** Options for accounting report delivery for the Accountant.
These are not affected by the service model. */
    accountantReportDelivery?: AccountingReportDelivery | null;
}

/** Settings related to Cost Accounting */
export interface CostAccountingSettings {
    /** If true, the service model is not applied to this feature. */
    denyServiceModel?: boolean | null;
    /** Cost accounting dimensions */
    dimensions?: CostAccountingDimensionDefinition[] | null;
}

/** Settings related to holiday pay and accrual calculations. */
export interface HolidaySettings {
    /** If true, the service model is not applied to this feature. */
    denyServiceModel?: boolean | null;
    /** Settings for holiday pay calculations.
The default is null and the default settings are used. */
    holidayPaySettings?: HolidayPaySettings[] | null;
    /** Settings for the accrual calculations.
The default is null and the default settings are used. */
    holidayAccrualSettings?: HolidayAccrualSettings[] | null;
}

/** Payment related settings. */
export interface PaymentSettings {
    /** If true, the service model is not applied to this feature. */
    denyServiceModel?: boolean | null;
    /** Settings related to payment methods that use the customer funds account (gross payment). */
    customerFunds?: CustomerFundsSettings | null;
    /** Settings related to invoices: Either salary payment or other invoicing. */
    invoice?: InvoiceSettings | null;
    /** The default channel when making payments. */
    defaultChannel?: PaymentChannel | null;
    /** Channel specific settings. */
    channels?: PaymentChannelSettings[] | null;
}

/** Usecase related settings. */
export interface UsecaseSettings {
    /** If true, the service model is not applied to this feature. */
    denyServiceModel?: boolean | null;
    /** Available usecases for the current account. */
    usecases?: UsecaseInSettings[] | null;
    /** URL to custom staging / integration server.
Used in running custom usecases and other custom integrations (currently imports). */
    serverUrl?: string | null;
}

/** Settings related to Messaging */
export interface MessagingSettings {
    /** If true, the service model is not applied to this feature. */
    denyServiceModel?: boolean | null;
    /** Partner messages enabled. */
    partnerMessages?: boolean | null;
    /** Options for the notification to be sent to the worker after the salary payment. */
    workerSalaryNotifications?: WorkerSalaryNotification[] | null;
    /** Options for the delivery of the payslip to the worker. */
    workerSalarySlipDeliveryMethods?: WorkerSalarySlipDeliveryMethod[] | null;
}

/** Settings related to the calculation data delivery by forms. */
export interface FormsSettings {
    /** If true, the service model is not applied to this feature. */
    denyServiceModel?: boolean | null;
}

/** Settings related to unemployment insurance. */
export interface UnemploymentInsuranceSettings {
    /** Status for indicating whether the total amount of paid salaries exceeds the thresold for higher unemployment insurance percent. */
    payrollLimitStatus?: UnemploymentPayrollLimitStatus | null;
}

export interface IncomesRegisterSettings {
    /** The reference number for the tax authorities */
    taxReferenceNumber?: string | null;
    /** Defines how the reporting is done for Incomes registry (Tulorekisteri). */
    irReporting?: TaxReportHandling | null;
}

/** Settings for Accounting report delivery. */
export interface AccountingReportDelivery {
    /** If true, the delivery is active. */
    isEnabled?: boolean | null;
    /** Address for delivery. Currently only email supported. */
    address?: string | null;
}

/** Settings related to payment methods that use the customer funds account (gross payment). */
export interface CustomerFundsSettings {
    /** If true, worker salary and expense payments are paid directly by the employer. */
    isWorkerSelfHandling?: boolean | null;
    /** If true, the user handles the reporting and payments himself/herself. */
    isPensionSelfHandling?: boolean | null;
    /** If true, tax and social security payments are paid directly by the employer. */
    isTaxAndSocialSecuritySelfHandling?: boolean | null;
}

/** Stores the CSS and images for the report creation. */
export interface ReportingLayoutTemplate {
    /** HTML template for the print header.
Use the following handlebars tags to inject values into the header:

- `{{ date }}` Logical report date, e.g.Salary date for salary slip.
- `{ { today } }` Printing date of the report.
- `{{ title }}` Report specific title, e.g. "Palkkalaskelma".
- `{{ subTitle}}` Report specific sub title, e.g. "Palkkapäivä 1.6.2020".
- `{{&gt; pageNumber }}` Current page number.Rendered as SPAN element.
- `{ {&gt; totalPages } }` total pages in the document.Rendered as SPAN element.
- `{ {&gt; logo } }` The main logo for the page as uploaded to settings.Rendered as SVG or IMG element.
- `{ {&gt; img2 } }` Secondary image as uploaded to settings.Rendered as SVG or IMG element. */
    headerTemplate?: string | null;
    /** HTML template for the print footer.
Use the following handlebars tags to inject values into the footer:

- `{{ date }}` Logical report date, e.g.Salary date for salary slip.
- `{ { today } }` Printing date of the report.
- `{{ title }}` Report specific title, e.g. "Palkkalaskelma".
- `{{ subTitle}}` Report specific sub title, e.g. "Palkkapäivä 1.6.2020".
- `{{&gt; pageNumber }}` Current page number.Rendered as SPAN element.
- `{ {&gt; totalPages } }` total pages in the document.Rendered as SPAN element.
- `{ {&gt; logo } }` The main logo for the page as uploaded to settings.Rendered as SVG or IMG element.
- `{ {&gt; img2 } }` Secondary image as uploaded to settings.Rendered as SVG or IMG element. */
    footerTemplate?: string | null;
    /** Additional CSS that is used to customize the layout of the report. */
    css?: string | null;
    /** Main logo image as embedded SVG or image (HTML).
This should preferably be an SVG or alternatively an image tag with data uri. */
    logo?: string | null;
    /** Secondary image that can be used in header / footer as embedded SVG or image (HTML).
This should preferably be an SVG or alternatively an image tag with data uri. */
    img2?: string | null;
    /** Defines the margins of the content area */
    margin?: ReportingArea | null;
    /** Print background graphics if such are added to the report using css property above. */
    printBackground?: boolean | null;
}

export interface ReportingArea {
    /** Top margin. */
    top?: number | null;
    /** Right margin. */
    right?: number | null;
    /** Bottom margin. */
    bottom?: number | null;
    /** Left margin. */
    left?: number | null;
}

export interface PageResultOfBrandListItem {
    items?: BrandListItem[] | null;
    nextPageLink?: string | null;
    count?: number | null;
}

/** Represents a single item in a list of brands. */
export interface BrandListItem {
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Person GUID for the owner of the object. */
    ownerId?: string | null;
    /** Metadata for the owner */
    ownerInfo?: AccountInIndex | null;
    /** The main status depending on the type of the object. */
    status?: string | null;
    /** The back office status depending on the type of the object. */
    backOfficeStatus?: string | null;
    /** When the event started. Typically, this is the CreatedAt date, but it may be something else. */
    startAt?: string | null;
    /** This is the end date of the event.
Typically, it is the UserUpdatedAt date, but it may be something else - e.g PaidAt for the calculation. */
    endAt?: string | null;
    /** Gross salary if that is relevant to the transaction. */
    grossSalary?: number | null;
    /** This is the payment from the Owner point-of-view:
Total payment for the Employer and Net salary for the Worker in the case of a calculation.
Only add here the payment, if the payment is really made. */
    payment?: number | null;
    /** Estimated fee of the transaction to Palkkaus.fi. */
    fee?: number | null;
    /** The GUID for the other party. Currently, this is always the PersonID. */
    otherId?: string | null;
    /** The other party (usually a Person) that is involved in the event (e.g Worker if this is a Salary payment by Employer). */
    otherPartyInfo?: AccountInIndex | null;
    /** A very short description describing the object as an event. E.g. "Paid salary" */
    shortText?: string | null;
    /** Business object ids related to this object. E.g. calculations and payrolls in the payment. */
    businessObjects?: string[] | null;
    /** This is valid for calculations only. The estimated date of salary in worker. */
    salaryDate?: string | null;
    /** Business data to include further information of the object. */
    data?: BrandData | null;
    /** Version number. May be used in conflicts */
    versionNumber?: number | null;
    /** Salaxy uri of the resource. */
    uri?: string | null;
    /** Workflow flags for the object.
Only workflow events with API supported message types are listed. */
    flags?: string[] | null;
    /** Workflow messages for the object.
Only workflow events with API supported message types are listed.
Shown in format "[MessageType]:[Message] ([User] at [UTC-time])" */
    messages?: string[] | null;
    /** Sub category for the payload. E.g. Payment Category, MoneyTransfer Source. */
    entityType?: string | null;
    /** The date for the actual period for which this object is done. */
    logicalDate?: string | null;
    /** Reference information. E.g. Payment or MoneyTransfer reference number. */
    reference?: string | null;
    /** External id for the object in 3rd party system. */
    externalId?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Brand specific business data for index. */
export interface BrandData {
    /** Url to logo. */
    logo?: string | null;
    /** Css path. */
    skin?: string | null;
}

export interface PageResultOfPrimaryPartnerListItem {
    items?: PrimaryPartnerListItem[] | null;
    nextPageLink?: string | null;
    count?: number | null;
}

/** Represents a single item in a list of primary partners in the user interface. It contains all essential information of the report and is basis for searching, filtering and sorting. */
export interface PrimaryPartnerListItem {
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Person GUID for the owner of the object. */
    ownerId?: string | null;
    /** Metadata for the owner */
    ownerInfo?: AccountInIndex | null;
    /** The main status depending on the type of the object. */
    status?: string | null;
    /** The back office status depending on the type of the object. */
    backOfficeStatus?: string | null;
    /** When the event started. Typically, this is the CreatedAt date, but it may be something else. */
    startAt?: string | null;
    /** This is the end date of the event.
Typically, it is the UserUpdatedAt date, but it may be something else - e.g PaidAt for the calculation. */
    endAt?: string | null;
    /** Gross salary if that is relevant to the transaction. */
    grossSalary?: number | null;
    /** This is the payment from the Owner point-of-view:
Total payment for the Employer and Net salary for the Worker in the case of a calculation.
Only add here the payment, if the payment is really made. */
    payment?: number | null;
    /** Estimated fee of the transaction to Palkkaus.fi. */
    fee?: number | null;
    /** The GUID for the other party. Currently, this is always the PersonID. */
    otherId?: string | null;
    /** The other party (usually a Person) that is involved in the event (e.g Worker if this is a Salary payment by Employer). */
    otherPartyInfo?: AccountInIndex | null;
    /** A very short description describing the object as an event. E.g. "Paid salary" */
    shortText?: string | null;
    /** Business object ids related to this object. E.g. calculations and payrolls in the payment. */
    businessObjects?: string[] | null;
    /** This is valid for calculations only. The estimated date of salary in worker. */
    salaryDate?: string | null;
    /** Business data to include further information of the object. */
    data?: PrimaryPartnerData | null;
    /** Version number. May be used in conflicts */
    versionNumber?: number | null;
    /** Salaxy uri of the resource. */
    uri?: string | null;
    /** Workflow flags for the object.
Only workflow events with API supported message types are listed. */
    flags?: string[] | null;
    /** Workflow messages for the object.
Only workflow events with API supported message types are listed.
Shown in format "[MessageType]:[Message] ([User] at [UTC-time])" */
    messages?: string[] | null;
    /** Sub category for the payload. E.g. Payment Category, MoneyTransfer Source. */
    entityType?: string | null;
    /** The date for the actual period for which this object is done. */
    logicalDate?: string | null;
    /** Reference information. E.g. Payment or MoneyTransfer reference number. */
    reference?: string | null;
    /** External id for the object in 3rd party system. */
    externalId?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Primary partner specific business data for index. */
export interface PrimaryPartnerData {
    /** Human-readable, human decided, recognizable short unique key for the partner:
All lower-case, a-z, 0-9, "-" and "_". Used in URL's etc. */
    key?: string | null;
    /** Display name for the account. */
    name?: string | null;
    /** Description of the primary account. */
    description?: string | null;
}

/** Provides the results of the tax card calculation and business logic. */
export interface TaxcardResult {
    /** Sum of income for this year based on the items marked on the tax card. */
    yearlyPreviousIncome?: number | null;
    /** Provides a decimal number for a recommended widthholding tax IF it is possible to calculate that based on given information.
Null, if the information is not sufficient to give a recommendation. */
    tax?: number | null;
}

export interface PageResultOfTaxcardListItem {
    items?: TaxcardListItem[] | null;
    nextPageLink?: string | null;
    count?: number | null;
}

/** List item of taxcard searches. */
export interface TaxcardListItem {
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Person GUID for the owner of the object. */
    ownerId?: string | null;
    /** Metadata for the owner */
    ownerInfo?: AccountInIndex | null;
    /** The main status depending on the type of the object. */
    status?: TaxcardState | null;
    /** The back office status depending on the type of the object. */
    backOfficeStatus?: string | null;
    /** When the event started. Typically, this is the CreatedAt date, but it may be something else. */
    startAt?: string | null;
    /** This is the end date of the event.
Typically, it is the UserUpdatedAt date, but it may be something else - e.g PaidAt for the calculation. */
    endAt?: string | null;
    /** Gross salary if that is relevant to the transaction. */
    grossSalary?: number | null;
    /** This is the payment from the Owner point-of-view:
Total payment for the Employer and Net salary for the Worker in the case of a calculation.
Only add here the payment, if the payment is really made. */
    payment?: number | null;
    /** Estimated fee of the transaction to Palkkaus.fi. */
    fee?: number | null;
    /** The GUID for the other party. Currently, this is always the PersonID. */
    otherId?: string | null;
    /** The other party (usually a Person) that is involved in the event (e.g Worker if this is a Salary payment by Employer). */
    otherPartyInfo?: AccountInIndex | null;
    /** A very short description describing the object as an event. E.g. "Paid salary" */
    shortText?: string | null;
    /** Business object ids related to this object. E.g. calculations and payrolls in the payment. */
    businessObjects?: string[] | null;
    /** This is valid for calculations only. The estimated date of salary in worker. */
    salaryDate?: string | null;
    /** Business data to include further information of the object. */
    data?: TaxcardData | null;
    /** Version number. May be used in conflicts */
    versionNumber?: number | null;
    /** Salaxy uri of the resource. */
    uri?: string | null;
    /** Workflow flags for the object.
Only workflow events with API supported message types are listed. */
    flags?: string[] | null;
    /** Workflow messages for the object.
Only workflow events with API supported message types are listed.
Shown in format "[MessageType]:[Message] ([User] at [UTC-time])" */
    messages?: string[] | null;
    /** Sub category for the payload. E.g. Payment Category, MoneyTransfer Source. */
    entityType?: string | null;
    /** The date for the actual period for which this object is done. */
    logicalDate?: string | null;
    /** Reference information. E.g. Payment or MoneyTransfer reference number. */
    reference?: string | null;
    /** External id for the object in 3rd party system. */
    externalId?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Tax card specific business data for index. */
export interface TaxcardData {
    /** Year that the tax card is valid for. Typically this means from February of this year to January of the following. */
    forYear?: number | null;
    /** Tax percent as percent. I.e. for 50% set 50, not 0.5. */
    taxPercent?: number | null;
    /** Income up to which the TaxPercent can be used.
Any income above the limit is taxed with ExcessTaxPercent. */
    incomeLimit?: number | null;
    /** Total income paid to the taxcard during the year (forYear). */
    totalIncome?: number | null;
    /** Tax percentage that is used in calculating the widthholding tax for the part of income above the IncomeLimit. */
    taxPercent2?: number | null;
    /** A Worker may request a minimum percent that is deducted even if the effective tax percent would be lower.
This can be used if Worker knows that he/she will be earning more in the year than what was estimated when the taxcard was created. */
    taxPercentMin?: number | null;
    /** The income type of the taxacard if fetched from the tax authorities taxcard API. */
    incomeType?: TaxcardApiIncomeType | null;
    /** The type of the tax card. */
    kind?: TaxcardKind | null;
    /** Employment id. */
    employmentId?: string | null;
    /** Contains the email or id of the responsible for the partner workflow event. */
    partnerMessageAssignedTo?: string | null;
    /** Start date of the taxcard validity */
    start?: string | null;
    /** End date of the taxcard validity. This may be null on NoTaxcard types. */
    end?: string | null;
    /** If the item is an employer instance of a shared taxcard, contains the original identifier
as URI ("/[PayloadType]/[Owner]/[Id]", e.g. "/CalculationDTO/FI86POYL0009461858/16ea052e-f23f-4b72-83a9-b8f6590f0dc9");
This item cannot be set in Save - only in Approve method. */
    copyOfUri?: string | null;
    /** Validity resolved as enumeration in relation to payment date given in the query.
This is not available in direct database OData queries as it is relevant to current / given date. */
    validity?: TaxcardValidity | null;
    /** Uri to the file copy of the tax card. */
    fileUri?: string | null;
    /** Uri to the preview image of the tax card. */
    previewUri?: string | null;
}

/** Provides a a result to query of whether a taxcard exists for a personal ID (no personal information). */
export interface SharedTaxcardExistsResult {
    /** Returns true if a shared taxcard exists. */
    sharedExists?: boolean | null;
    /** Returns true if there is already an owned taxcard for the employer. */
    ownedExists?: boolean | null;
    /** Uri for the Shared taxcard */
    uri?: string | null;
    /** If Owned taxcard exists, it is returned here. */
    ownedTaxcard?: Taxcard | null;
    /** If true there was an error fetching the information.
Typically, this would be that there were too many attempts to fetch Personal ID's and request was classified as phishing.
In this case, you should currently create the employment relation and fetch the taxcard infor after that. 
We may later introduce a "Are you robot" type of interface to go around this (if necessary). */
    isError?: boolean | null;
    /** Type of the taxcard. Undefined if none is found. */
    kind?: TaxcardKind | null;
    /** Validity of the taxcard. Note that this property is null when Exists is false. */
    validity?: DateRange | null;
    /** The personal ID that was used in fetching.
It may be validated and formatted, or just the original string if there were issues. */
    personalId?: string | null;
}

/** Contains the status and necessary data with Workers current taxcards. */
export interface WorkerCurrentTaxcards {
    /** The currently active taxcard if one exists. This property is null by default. */
    active?: Taxcard | null;
    /** All the relevant taxcards as list items.
For Workes own taxcards search (MyTaxcards) this is ownerd cards only */
    list?: TaxcardListItem[] | null;
    /** Employer taxcards from all Employers for the Worker account.
All available within the searched timestring. This list is only available for the Worker, not for the Employer. */
    employers?: TaxcardListItem[] | null;
    /** Personal ID that is used for taxcard binding. This always exists as opposed to Employment. */
    personalId?: string | null;
    /** Employment relation if the search is done based on employment relation ID and not Current worker account. */
    employment?: AccountInIndex | null;
    /** A shared taxcard waiting for approval if one exists. This property is null by default. */
    waitingApproval?: TaxcardWaitingApproval | null;
    /** Employment preference for the taxcard. */
    employmentTaxcard?: EmploymentRelationTaxcard | null;
}

/** Informs the employer that there is a Worker taxcard waiting for approval potentially without revealing personal information. */
export interface TaxcardWaitingApproval {
    /** URI for the shared card: This is the taxcard owned by the Worker and to view it 
you need to request your own copy (would be in FullCard). */
    uri?: string | null;
    /** Type of the taxcard. */
    kind?: TaxcardKind | null;
    /** Status of the taxcard */
    state?: TaxcardState | null;
    /** Time when the taxcard was added. */
    createdAt?: string | null;
    /** Owner account that added the taxcard. */
    owner?: Avatar | null;
    /** If true, the relation has not yet been confirmed:
I.e. the employer has just input the Finnish Personal Id (HETU) of the Worker.
The employment relation is confirmed when salaries are paid or salary request is received from Worker. */
    isRelationUnconfirmed?: boolean | null;
    /** If there is an owner instance of taxcard for the employer, the copy is added here.
Instance exists only if there is a confirmed employment relation or if employer explicitly requests the taxcard. */
    fullCard?: Taxcard | null;
}

/** Test object with value properties. */
export interface TestValues {
    /** Test integer. */
    intValue?: number | null;
    /** Test double. */
    doubleValue?: number | null;
    /** Test decimal. */
    decimalValue?: number | null;
    /** Test string. */
    stringValue?: string | null;
    /** Test DateTime. */
    dateTimeValue?: string | null;
    /** Test Date. */
    dateValue?: string | null;
    /** Test bool. */
    boolValue?: boolean | null;
    /** Test object. */
    objectValue?: any | null;
    /** Test array */
    arrayValue?: any[] | null;
    /** Test enum */
    enumValue?: TestEnum | null;
    /** Free values dictionary. */
    dictValue?: { [key: string]: any; } | null;
}

/** Object containing essential details of the test account */
export interface TestAccountInfo {
    /** Bearer token for authentication. */
    token?: string | null;
    /** The current user credentials. */
    userCredential?: SessionUserCredential | null;
}

/** View model data for Simple Federation Flow sample page in /MyAccount/Federation */
export interface FederationSampleViewModel {
    /** The federation data based on the current user */
    federationData?: OpenIdUserInfoSupportedClaims | null;
    /** Federation data as JSON: Only used by depricated Asp.Net MVC version of the demo view. */
    federationDataJson?: string | null;
    customFederationDataJson?: string | null;
    /** Federation data as JWT */
    token?: string | null;
    /** Certificate password for signing */
    certificatePwd?: string | null;
    /** Uploaded certificate file */
    certificateFile?: HttpPostedFileBase | null;
    /** Certificate bytes as Base64String */
    certificateBytes?: string | null;
    /** Account to impersonate. */
    accountId?: string | null;
}

/** Part of the OpenId specification that is supported by Salaxy federated authentication / Authorization. */
export interface OpenIdUserInfoSupportedClaims {
    /** REQUIRED. Issuer Identifier for the Issuer of the response. 
The iss value is a case-sensitive URL using the https scheme that contains scheme, host, and optionally, port number and path components and no query or fragment components. */
    iss?: string | null;
    /** In Salaxy federation this should be the federation endpoint: "https://secure.salaxy.com/security/federation" in production
OR "https://test-api.salaxy.com/security/federation" in the test environment.
From the spec: REQUIRED. Audience(s) that this ID Token is intended for. 
It MUST contain the OAuth 2.0 client_id of the Relying Party as an audience value. 
It MAY also contain identifiers for other audiences.
In the general case, the aud value is an array of case-sensitive strings.
In the common special case when there is one audience, the aud value MAY be a single case-sensitive string. */
    aud?: string | null;
    /** REQUIRED. Expiration time on or after which the ID Token MUST NOT be accepted for processing. 
The processing of this parameter requires that the current date/time MUST be before the expiration date/time listed in the value.
Implementers MAY provide for some small leeway, usually no more than a few minutes, to account for clock skew. 
Its value is a JSON [RFC7159] number representing the number of seconds from 1970-01-01T00:00:00Z as measured in UTC until the date/time.
See RFC 3339 [RFC3339] for details regarding date/times in general and UTC in particular. */
    exp?: number | null;
    /** REQUIRED. Subject - Identifier for the End-User at the Issuer. */
    sub: string;
    /** End-User's full name in displayable form including all name parts, possibly including titles and suffixes, 
ordered according to the End-User's locale and preferences.
NOTE: In creating account etc., Salaxy will use given_name and family_name separately and therefore ignore the name. */
    name?: string | null;
    /** Given name(s) or first name(s) of the End-User. */
    given_name?: string | null;
    /** Surname(s) or last name(s) of the End-User. */
    family_name?: string | null;
    /** URL of the End-User's profile picture.
This URL MUST refer to an image file (for example, a PNG, JPEG, or GIF image file), rather than to a Web page containing an image. */
    picture?: string | null;
    /** End-User's preferred e-mail address.
Its value MUST conform to the RFC 5322 [RFC5322] addr-spec syntax.
The RP MUST NOT rely upon this value being unique, as discussed in Section 2.5.3. */
    email?: string | null;
    /** True if the End-User's e-mail address has been verified; otherwise false. 
IMPORTANT: In Salaxy federation context, avoid sending non-confirmed e-mails. This may later become an error without being considered a breaking change.
When this Claim Value is true, this means that the OP took affirmative steps to ensure that this e-mail address was controlled by the End-User at the time the verification was performed. 
The means by which an e-mail address is verified is context specific, and dependent upon the trust framework or contractual agreements within which the parties are operating. */
    email_verified?: boolean | null;
    /** End-User's birthday, represented as an ISO 8601:2004 [ISO8601‑2004] YYYY-MM-DD format.
The year MAY be 0000, indicating that it is omitted.
To represent only the year, YYYY format is allowed.
Note that depending on the underlying platform's date related function, providing just year can result in varying month and day, so the implementers need to take this factor into account to correctly process the dates. */
    birthdate?: string | null;
    /** End-User's locale, represented as a BCP47 [RFC5646] language tag.
This is typically an ISO 639-1 Alpha-2 [ISO639‑1] language code in lowercase and an ISO 3166-1 Alpha-2 [ISO3166‑1] country code in uppercase, separated by a dash.
For example, en-US or fr-CA. */
    locale?: string | null;
    /** End-User's preferred telephone number. E.164 [E.164] is RECOMMENDED as the format of this Claim, for example, +1 (425) 555-1212 or +56 (2) 687 2400.
If the phone number contains an extension, it is RECOMMENDED that the extension be represented using the RFC 3966 [RFC3966] extension syntax, for example, +1 (604) 555-1234;ext=5678. */
    phone_number?: string | null;
    /** True if the End-User's phone number has been verified; otherwise false.
When this Claim Value is true, this means that the OP took affirmative steps to ensure that this phone number was controlled by the End-User at the time the verification was performed.
The means by which a phone number is verified is context specific, and dependent upon the trust framework or contractual agreements within which the parties are operating.
When true, the phone_number Claim MUST be in E.164 format and any extensions MUST be represented in RFC 3966 format. */
    phone_number_verified?: boolean | null;
    /** End-User's preferred postal address.
The value of the address member is a JSON [RFC4627] structure containing some or all of the members defined in Section 2.5.1. */
    address?: OpenIdUserInfoAddress | null;
    /** Time the End-User's information was last updated.
Its value is a JSON number representing the number of seconds from 1970-01-01T00:00:00Z as measured in UTC until the date/time. */
    updated_at?: number | null;
    /** Salaxy extension to Open ID Connect UserInfo claims for Company federation. */
    "https://salaxy.com/federation/company"?: UserInfoCompanyAccount | null;
    /** Salaxy extension to Open ID Connect UserInfo claims for Personal account federation. */
    "https://salaxy.com/federation/person"?: UserInfoPersonAccount | null;
    /** Salaxy extension to Open ID Connect UserInfo claims for Application data. */
    "https://salaxy.com/federation/app"?: UserInfoApplication | null;
}

export interface HttpPostedFileBase {
    readonly contentLength?: number | null;
    readonly contentType?: string | null;
    readonly fileName?: string | null;
    readonly inputStream?: Stream | null;
}

/** The Address Claim represents a physical mailing address in OpenID Connect UserInfo response message. This object is modeled according to: http://openid.net/specs/openid-connect-basic-1_0.html#AddressClaim */
export interface OpenIdUserInfoAddress {
    /** Full street address component, which MAY include house number, street name, Post Office Box, and multi-line extended street address information. */
    street_address?: string | null;
    /** City or locality component. */
    locality?: string | null;
    /** Zip code or postal code component. */
    postal_code?: string | null;
}

/** Salaxy extension to Open ID claims for company federation. */
export interface UserInfoCompanyAccount {
    /** If true, the authorization is made for a company account. 
The root user claims are just for a current user acting in behalf of the company.
If false, the entire CompanyClaims object will be ignored. */
    as_company?: boolean | null;
    /** The Business ID (Y-tunnus / Business Identity Code) is a code given to businesses and organizations by the PRH or the Tax Administration. 
It consists of seven digits, a dash and a control mark, for example 1234567-8.
Alternative accepted formats incule international VAT number "FI12345678" or number without the dash: "12345678". */
    business_id: string;
    /** One of the Salaxy Finnish company type shortcuts: fiOy, fiTm, fiRy, fiYy (Other) */
    type: CompanyType;
    /** Company name - the owner of the Salaxy account and shown in salary calculations, reports and invoices.
Typically this is the official full name of the company as in Business registry. */
    name?: string | null;
    /** URL of the Company profile picture.
This URL MUST refer to an image file (for example, a PNG, JPEG, or GIF image file), rather than to a Web page containing an image. 
The URL SHOULD specifically reference a company logo picture (PNG preferred) and it should be a square. If not, it may be converted, cropped and/or extended. */
    picture?: string | null;
    /** The company's preferred e-mail address in relation to salary payments.
Its value MUST conform to the RFC 5322 [RFC5322] addr-spec syntax. */
    email?: string | null;
    /** True if the Company's e-mail address has been verified; otherwise false.
IMPORTANT: In Salaxy federation context, avoid sending non-confirmed e-mails. This may later become an error without being considered a breaking change.
When this Claim Value is true, this means that the OP took affirmative steps to ensure that this e-mail address was controlled by the End-User at the time the verification was performed. 
The means by which an e-mail address is verified is context specific, and dependent upon the trust framework or contractual agreements within which the parties are operating. */
    email_verified?: boolean | null;
    /** Company's preferred telephone number for salary payment purposes. 
E.164 [E.164] is RECOMMENDED as the format of this Claim, for example, +1 (425) 555-1212 or +56 (2) 687 2400.
If the phone number contains an extension, it is RECOMMENDED that the extension be represented using the RFC 3966 [RFC3966] extension syntax, for example, +1 (604) 555-1234;ext=5678. */
    phone_number?: string | null;
    /** True if the Company's phone number has been verified; otherwise false.
When this Claim Value is true, this means that the OP took affirmative steps to ensure that this phone number was controlled by the End-User at the time the verification was performed.
The means by which a phone number is verified is context specific, and dependent upon the trust framework or contractual agreements within which the parties are operating.
When true, the phone_number Claim MUST be in E.164 format and any extensions MUST be represented in RFC 3966 format. */
    phone_number_verified?: boolean | null;
    /** Company's preferred postal address in relation to salary payments.
The value of the address member is a JSON [RFC4627] structure containing some or all of the members defined in Section 2.5.1. */
    address?: OpenIdUserInfoAddress | null;
    /** The primary partner account for the new company to create.
If the company already exists and has given authorization to the primary partner, and does not have any primary partner, the primary partner will be set.
Please note, that the calling account must have the authorization to the primary partner account, or
be the primary partner itself. */
    proxy_partner?: string | null;
    /** The account identifier at the partner site. 
If present, this ID is used to restrict the authorization to one account at partner site only. */
    partner_account_id?: string | null;
}

/** Salaxy extension to Open ID Connect UserInfo claims for Personal account federation. */
export interface UserInfoPersonAccount {
    /** If true, the user issuer indicates that the current user has the right to sign in behalf of the company / association.
In this case the provider must also provide a valid Finnish personal ID in personal_id field. */
    can_sign_company?: boolean | null;
    /** A Finnish Personal ID (Henkilötunnus / HETU) for digital signature.
If can_sign_company is set to true, the issuer should provide a valid personal id here. */
    personal_id?: string | null;
}

/** Salaxy extension to Open ID Connect UserInfo claims for Application data. */
export interface UserInfoApplication {
    /** Return link back to the calling application. Token is added to this string */
    return_link?: string | null;
    /** Return link in case of error or user cancel. */
    cancel_link?: string | null;
    /** Application role that the user has in relation to the account in this session.
Currently supported values are: "noAccess" and "owner"
Also "unknown" (the default if null) is technically supported, but that value is an error in federation process by design. */
    role?: UserInfoApplicationRole | null;
    /** Application specific state data that is sent from the federation provider to the end-application.
This data is guaranteed to survive the onboarding process. */
    state?: { [key: string]: string; } | null;
    /** TEMPORARY */
    custom?: { [key: string]: string; } | null;
}

export interface Stream {
    readonly canRead?: boolean | null;
    readonly canSeek?: boolean | null;
    readonly canTimeout?: boolean | null;
    readonly canWrite?: boolean | null;
    readonly length?: number | null;
    position?: number | null;
    readTimeout?: number | null;
    writeTimeout?: number | null;
}

/** Usecase definition */
export interface Usecase {
    /** Uri with owner information. */
    uri?: string | null;
    /** Short title for the usecase. */
    label?: string | null;
    /** Longer description for what the usecase is used for. */
    description?: string | null;
    /** URL for the icon that represents the service model. 
Supports font-awesome icons v4: https://fontawesome.com/v4.7/ (e.g. "fa-wrench") and images with absolute URL (https). */
    icon?: string | null;
    /** Item type of the usecase */
    itemType?: ApiItemType | null;
    /** The default status of the usecase in the settings.
The status affects the visibilty of the usecase. */
    status?: UsecaseStatus | null;
    /** Order setting for the usecases.
This is needed e.g. ad hoc reports. */
    order?: number | null;
    /** JSON schema defines the data model and the automatically generated default user interface for the usecase. */
    schema?: any | null;
    /** The actions related to this usecase. */
    actions?: UsecaseAction[] | null;
    /** Customized userinterface definitions (views) for the usecase. */
    views?: UsecaseView[] | null;
    /** Readonly workflow data, which is exposed to API. */
    workflowData?: WorkflowData | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

export interface UsecaseAction {
    /** Type of the automation action */
    actionType?: UsecaseActionType | null;
    /** Title of the action */
    label?: string | null;
    /** If true, the button is shown in the user interfaces.
TODO: This property may be removed before final production version =&gt; Set on/off depending on the view. */
    uiShowButton?: boolean | null;
    /** Text for the UI button. */
    uiText?: string | null;
    /** Defines the color of the UI button */
    uiColor?: BootstrapStyle | null;
    /** Description of the action */
    description?: string | null;
    /** The content: The script or other definition. */
    content?: string | null;
}

/** Customized user interface view. */
export interface UsecaseView {
    /** Title of the action */
    label?: string | null;
    /** Description of the action */
    description?: string | null;
    /** The content: The HTML for the view. */
    content?: string | null;
}

export interface PageResultOfUsecaseListItem {
    items?: UsecaseListItem[] | null;
    nextPageLink?: string | null;
    count?: number | null;
}

/** Represents a single item in a list of usecases. */
export interface UsecaseListItem {
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Person GUID for the owner of the object. */
    ownerId?: string | null;
    /** Metadata for the owner */
    ownerInfo?: AccountInIndex | null;
    /** The main status depending on the type of the object. */
    status?: UsecaseStatus | null;
    /** The back office status depending on the type of the object. */
    backOfficeStatus?: string | null;
    /** When the event started. Typically, this is the CreatedAt date, but it may be something else. */
    startAt?: string | null;
    /** This is the end date of the event.
Typically, it is the UserUpdatedAt date, but it may be something else - e.g PaidAt for the calculation. */
    endAt?: string | null;
    /** Gross salary if that is relevant to the transaction. */
    grossSalary?: number | null;
    /** This is the payment from the Owner point-of-view:
Total payment for the Employer and Net salary for the Worker in the case of a calculation.
Only add here the payment, if the payment is really made. */
    payment?: number | null;
    /** Estimated fee of the transaction to Palkkaus.fi. */
    fee?: number | null;
    /** The GUID for the other party. Currently, this is always the PersonID. */
    otherId?: string | null;
    /** The other party (usually a Person) that is involved in the event (e.g Worker if this is a Salary payment by Employer). */
    otherPartyInfo?: AccountInIndex | null;
    /** A very short description describing the object as an event. E.g. "Paid salary" */
    shortText?: string | null;
    /** Business object ids related to this object. E.g. calculations and payrolls in the payment. */
    businessObjects?: string[] | null;
    /** This is valid for calculations only. The estimated date of salary in worker. */
    salaryDate?: string | null;
    /** Business data to include further information of the object. */
    data?: UsecaseListItemData | null;
    /** Version number. May be used in conflicts */
    versionNumber?: number | null;
    /** Salaxy uri of the resource. */
    uri?: string | null;
    /** Workflow flags for the object.
Only workflow events with API supported message types are listed. */
    flags?: string[] | null;
    /** Workflow messages for the object.
Only workflow events with API supported message types are listed.
Shown in format "[MessageType]:[Message] ([User] at [UTC-time])" */
    messages?: string[] | null;
    /** Sub category for the payload. E.g. Payment Category, MoneyTransfer Source. */
    entityType?: string | null;
    /** The date for the actual period for which this object is done. */
    logicalDate?: string | null;
    /** Reference information. E.g. Payment or MoneyTransfer reference number. */
    reference?: string | null;
    /** External id for the object in 3rd party system. */
    externalId?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Usecase specific business data for index. */
export interface UsecaseListItemData {
    /** Contains the email or id of the responsible for the partner workflow event. */
    partnerMessageAssignedTo?: string | null;
    /** Longer description for what the usecase is used for. */
    description?: string | null;
    /** URL for the icon that represents the service model. 
Supports font-awesome icons v4: https://fontawesome.com/v4.7/ (e.g. "fa-wrench") and images with absolute URL (https). */
    icon?: string | null;
    /** Order setting for the usecases.
This is needed e.g. ad hoc reports. */
    order?: number | null;
}

/** Version information for the API object. */
export interface VersionInfo {
    /** Identifier for the version. */
    versionId?: string | null;
    /** Operation which created the version. */
    operation?: string | null;
    /** Date and time when the version was created. */
    date?: string | null;
    /** User account  who created the version. */
    userAccount?: Avatar | null;
}

/** Abstract base class for implementing CRUD objects in the Salaxy API. */
export interface ApiCrudObject {
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

export interface PageResultOfWorkerListItem {
    items?: WorkerListItem[] | null;
    nextPageLink?: string | null;
    count?: number | null;
}

/** Represents a single item in a list of workers in the user interface. It contains all essential information of the worker and is basis for searching, filtering and sorting. */
export interface WorkerListItem {
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Person GUID for the owner of the object. */
    ownerId?: string | null;
    /** Metadata for the owner */
    ownerInfo?: AccountInIndex | null;
    /** The main status depending on the type of the object. */
    status?: string | null;
    /** The back office status depending on the type of the object. */
    backOfficeStatus?: string | null;
    /** When the event started. Typically, this is the CreatedAt date, but it may be something else. */
    startAt?: string | null;
    /** This is the end date of the event.
Typically, it is the UserUpdatedAt date, but it may be something else - e.g PaidAt for the calculation. */
    endAt?: string | null;
    /** Gross salary if that is relevant to the transaction. */
    grossSalary?: number | null;
    /** This is the payment from the Owner point-of-view:
Total payment for the Employer and Net salary for the Worker in the case of a calculation.
Only add here the payment, if the payment is really made. */
    payment?: number | null;
    /** Estimated fee of the transaction to Palkkaus.fi. */
    fee?: number | null;
    /** The GUID for the other party. Currently, this is always the PersonID. */
    otherId?: string | null;
    /** The other party (usually a Person) that is involved in the event (e.g Worker if this is a Salary payment by Employer). */
    otherPartyInfo?: AccountInIndex | null;
    /** A very short description describing the object as an event. E.g. "Paid salary" */
    shortText?: string | null;
    /** Business object ids related to this object. E.g. calculations and payrolls in the payment. */
    businessObjects?: string[] | null;
    /** This is valid for calculations only. The estimated date of salary in worker. */
    salaryDate?: string | null;
    /** Business data to include further information of the object. */
    data?: WorkerData | null;
    /** Version number. May be used in conflicts */
    versionNumber?: number | null;
    /** Salaxy uri of the resource. */
    uri?: string | null;
    /** Workflow flags for the object.
Only workflow events with API supported message types are listed. */
    flags?: string[] | null;
    /** Workflow messages for the object.
Only workflow events with API supported message types are listed.
Shown in format "[MessageType]:[Message] ([User] at [UTC-time])" */
    messages?: string[] | null;
    /** Sub category for the payload. E.g. Payment Category, MoneyTransfer Source. */
    entityType?: string | null;
    /** The date for the actual period for which this object is done. */
    logicalDate?: string | null;
    /** Reference information. E.g. Payment or MoneyTransfer reference number. */
    reference?: string | null;
    /** External id for the object in 3rd party system. */
    externalId?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Worker specific business data for index. */
export interface WorkerData {
    /** Type of the employment relation. */
    type?: EmploymentRelationType | null;
    /** Type for the pension insurance. */
    pensionCalculation?: PensionCalculation | null;
    /** Taxcard type from the employment point of view. */
    taxcard?: EmploymentRelationTaxcard | null;
    /** Start date of the Employment Relation. */
    startDate?: string | null;
    /** End date of the Employment Relation. */
    endDate?: string | null;
    /** Duration of the employment. If true, the employment relation is for a fixed term.
Otherwise (which is the default) the employment relation continues until further notice. */
    isFixedTerm?: boolean | null;
    /** Indicates that the employment relation has been terminated.
Saving with this status also makes the employment relation Archived. */
    isTerminated?: boolean | null;
}

/** AbcSection enumeration */
export enum AbcSection {
    Undefined = "undefined",
    DoNotShow = "doNotShow",
    Employment = "employment",
    Insurance = "insurance",
    Salary = "salary",
    Examples = "examples",
    PalkkausGeneral = "palkkausGeneral",
    PalkkausInstructions = "palkkausInstructions",
    Blog = "blog",
    Press = "press",
    PersonEmployer = "personEmployer",
    HouseholdEmployer = "householdEmployer",
    Worker = "worker",
    Employee = "employee",
    Entrepreneur = "entrepreneur",
    Association = "association",
    BusinessOwner = "businessOwner",
    ProductLongDescription = "productLongDescription",
    DocumentTemplates = "documentTemplates",
    InstructionsAndExamples = "instructionsAndExamples",
}

/** AbsenceCauseCode enumeration */
export enum AbsenceCauseCode {
    Undefined = "undefined",
    UnpaidLeave = "unpaidLeave",
    PersonalReason = "personalReason",
    Illness = "illness",
    PartTimeSickLeave = "partTimeSickLeave",
    ParentalLeave = "parentalLeave",
    SpecialMaternityLeave = "specialMaternityLeave",
    Rehabilitation = "rehabilitation",
    ChildIllness = "childIllness",
    PartTimeChildCareLeave = "partTimeChildCareLeave",
    Training = "training",
    JobAlternationLeave = "jobAlternationLeave",
    StudyLeave = "studyLeave",
    IndustrialAction = "industrialAction",
    InterruptionInWorkProvision = "interruptionInWorkProvision",
    LeaveOfAbsence = "leaveOfAbsence",
    MilitaryRefresherTraining = "militaryRefresherTraining",
    MilitaryService = "militaryService",
    LayOff = "layOff",
    ChildCareLeave = "childCareLeave",
    MidWeekHoliday = "midWeekHoliday",
    AccruedHoliday = "accruedHoliday",
    OccupationalAccident = "occupationalAccident",
    AnnualLeave = "annualLeave",
    PartTimeAbsenceDueToRehabilitation = "partTimeAbsenceDueToRehabilitation",
    Other = "other",
}

/** AccountantType enumeration */
export enum AccountantType {
    Unknown = "unknown",
    UnlinkedPrimaryPartner = "unlinkedPrimaryPartner",
    UnlinkedAccountingOnly = "unlinkedAccountingOnly",
    PendingPrimaryPartner = "pendingPrimaryPartner",
    PrimaryPartner = "primaryPartner",
    None = "none",
}

/** AccountingChannel enumeration */
export enum AccountingChannel {
    Undefined = "undefined",
    Procountor = "procountor",
    VismaNetvisor = "vismaNetvisor",
    VismaFivaldi = "vismaFivaldi",
}

/** AccountingPeriodClosingOption enumeration */
export enum AccountingPeriodClosingOption {
    Default = "default",
    Accounting = "accounting",
    PeriodicInvoices = "periodicInvoices",
    AccountingAndPeriodicInvoices = "accountingAndPeriodicInvoices",
    IrReports = "irReports",
    AccountingAndIrReports = "accountingAndIrReports",
    PeriodicInvoicesAndIrReports = "periodicInvoicesAndIrReports",
    AccountingAndPeriodicInvoicesAndIrReports = "accountingAndPeriodicInvoicesAndIrReports",
}

/** AccountingReportRowType enumeration */
export enum AccountingReportRowType {
    Debit = "debit",
    Credit = "credit",
    Total = "total",
    GroupHeader = "groupHeader",
    GroupTotal = "groupTotal",
    ChildRow = "childRow",
}

/** AccountingReportTableType enumeration */
export enum AccountingReportTableType {
    Classic = "classic",
    Simple = "simple",
    Mapped = "mapped",
}

/** AccountingTargetStatus enumeration */
export enum AccountingTargetStatus {
    Undefined = "undefined",
    OwnedTarget = "ownedTarget",
    ProductTarget = "productTarget",
    SharedTarget = "sharedTarget",
}

/** AgeGroupCode enumeration */
export enum AgeGroupCode {
    A = "a",
    B = "b",
    C = "c",
    U = "u",
}

/** AgeRange enumeration */
export enum AgeRange {
    Unknown = "unknown",
    Age_15 = "age_15",
    Age16 = "age16",
    Age17 = "age17",
    Age18_52 = "age18_52",
    Age53_62 = "age53_62",
    Age63_64 = "age63_64",
    Age65_67 = "age65_67",
    Age68AndOVer = "age68AndOVer",
}

/** AllowanceCode enumeration */
export enum AllowanceCode {
    MealAllowance = "mealAllowance",
    PartialDailyAllowance = "partialDailyAllowance",
    FullDailyAllowance = "fullDailyAllowance",
    InternationalDailyAllowance = "internationalDailyAllowance",
    TaxExemptReimbursementsAbroad = "taxExemptReimbursementsAbroad",
}

/** AnnualLeavePaymentKind enumeration */
export enum AnnualLeavePaymentKind {
    Undefined = "undefined",
    Planned = "planned",
    ManualSalary = "manualSalary",
    ManualCompensation = "manualCompensation",
    ManualBonus = "manualBonus",
    PaidCalc = "paidCalc",
    DraftCalc = "draftCalc",
}

/** ApiCheckStatus enumeration */
export enum ApiCheckStatus {
    Ignored = "ignored",
    Success = "success",
    Warning = "warning",
    Error = "error",
}

/** ApiImportStatus enumeration */
export enum ApiImportStatus {
    Ignored = "ignored",
    Success = "success",
    Warning = "warning",
    Error = "error",
}

/** ApiListItemType enumeration */
export enum ApiListItemType {
    Unknown = "unknown",
    AccountBase = "accountBase",
    CompanyAccount = "companyAccount",
    PersonAccount = "personAccount",
    WorkerAccount = "workerAccount",
    Certificate = "certificate",
    SessionUserCredential = "sessionUserCredential",
    Onboarding = "onboarding",
    Profile = "profile",
    Calculation = "calculation",
    CalculationPaid = "calculationPaid",
    ESalaryPayment = "eSalaryPayment",
    Payment = "payment",
    EarningsPayment = "earningsPayment",
    Employment = "employment",
    WorkerAbsences = "workerAbsences",
    HolidayYear = "holidayYear",
    Taxcard = "taxcard",
    PayrollDetails = "payrollDetails",
    Invoice = "invoice",
    Report = "report",
    BlobFile = "blobFile",
    PayerSummary = "payerSummary",
    CalendarEvent = "calendarEvent",
    Usecase = "usecase",
    Dataset = "dataset",
    Article = "article",
    MessageThread = "messageThread",
    EmailMessage = "emailMessage",
    AccountProducts = "accountProducts",
    VarmaPensionOrder = "varmaPensionOrder",
    IfInsuranceOrder = "ifInsuranceOrder",
    Historical = "historical",
}

/** ApiTestErrorType enumeration */
export enum ApiTestErrorType {
    Default = "default",
    UserFriendly = "userFriendly",
}

/** ApiItemType enumeration */
export enum ApiItemType {
    Undefined = "undefined",
    Calculation = "calculation",
    CalculationPaid = "calculationPaid",
    Dataset = "dataset",
    PayrollDetails = "payrollDetails",
    Invoice = "invoice",
    EarningsPaymentReport = "earningsPaymentReport",
    PayerSummaryReport = "payerSummaryReport",
    Employment = "employment",
    MessageThread = "messageThread",
    CalendarEvent = "calendarEvent",
    ListItems = "listItems",
}

/** ApiValidationErrorType enumeration */
export enum ApiValidationErrorType {
    General = "general",
    Required = "required",
    Invalid = "invalid",
    Warning = "warning",
}

/** AuthenticationMethod enumeration */
export enum AuthenticationMethod {
    Undefined = "undefined",
    EmailPwdLocal = "emailPwdLocal",
    Facebook = "facebook",
    Google = "google",
    Microsoft = "microsoft",
    LinkedIn = "linkedIn",
    Auth0Database = "auth0Database",
    X509 = "x509",
    Salaxy = "salaxy",
    Test = "test",
    WebAuthn = "webAuthn",
    MicrosoftOAuth = "microsoftOAuth",
    GoogleOAuth = "googleOAuth",
    InternalLocalhost = "internalLocalhost",
}

/** AuthorizationStatus enumeration */
export enum AuthorizationStatus {
    Undefined = "undefined",
    OK = "oK",
    AccessDenied = "accessDenied",
    ExpiredOauthToken = "expiredOauthToken",
    InvalidOAuthToken = "invalidOAuthToken",
    NoOauthToken = "noOauthToken",
}

/** AuthorizationType enumeration */
export enum AuthorizationType {
    None = "none",
    EmployerAuthorization = "employerAuthorization",
    WorkerContract = "workerContract",
    CompanyContract = "companyContract",
    Manual = "manual",
    Temporary = "temporary",
}

/** AvatarPictureType enumeration */
export enum AvatarPictureType {
    Icon = "icon",
    Uploaded = "uploaded",
    Gravatar = "gravatar",
}

/** BankPaymentType enumeration */
export enum BankPaymentType {
    Unknown = "unknown",
    Error = "error",
    PaytrailBatch = "paytrailBatch",
    NetvisorPayment = "netvisorPayment",
    SalaryGrossPayment = "salaryGrossPayment",
    RefundPayment = "refundPayment",
    PartialRefundPayment = "partialRefundPayment",
    DoubleRefundPayment = "doubleRefundPayment",
    TransferToEcfaPayment = "transferToEcfaPayment",
    InsuranceGrossPayment = "insuranceGrossPayment",
    NetSalary = "netSalary",
    SalaryAdvance = "salaryAdvance",
    NetSalaryRepayment = "netSalaryRepayment",
    NetSalaryCorrection = "netSalaryCorrection",
    TaxAccount = "taxAccount",
    Tvr = "tvr",
    TvrRfnd = "tvrRfnd",
    PalkkausFees = "palkkausFees",
    BankFees = "bankFees",
    PaytrailFees = "paytrailFees",
    InsuranceLahiTapiola = "insuranceLahiTapiola",
    Tyel = "tyel",
    TyelEteraContract = "tyelEteraContract",
    TyelEteraTemp = "tyelEteraTemp",
    TyelEteraUnknown = "tyelEteraUnknown",
    TyelEloContract = "tyelEloContract",
    TyelEloTemp = "tyelEloTemp",
    TyelEloInitialImport = "tyelEloInitialImport",
    TyelVarmaContract = "tyelVarmaContract",
    TyelVarmaTemp = "tyelVarmaTemp",
    TyelIlmarinenContract = "tyelIlmarinenContract",
    TyelIlmarinenTemp = "tyelIlmarinenTemp",
    Union = "union",
    UnionRaksa = "unionRaksa",
    Foreclosure = "foreclosure",
    SaldoYearBegin = "saldoYearBegin",
    SaldoYearEnd = "saldoYearEnd",
}

/** BenefitCode enumeration */
export enum BenefitCode {
    AccommodationBenefit = "accommodationBenefit",
    TelephoneBenefit = "telephoneBenefit",
    MealBenefit = "mealBenefit",
    OtherBenefits = "otherBenefits",
}

/** BlobFileType enumeration */
export enum BlobFileType {
    Unknown = "unknown",
    AuthorizationPdf = "authorizationPdf",
    Avatar = "avatar",
    TaxCard = "taxCard",
    ExpensesReceipt = "expensesReceipt",
    Raksaloki = "raksaloki",
    Template = "template",
    EInvoice = "eInvoice",
    Temporary = "temporary",
    Settings = "settings",
    Messages = "messages",
    Record = "record",
    MonthlyReport = "monthlyReport",
    YearlyReport = "yearlyReport",
    CalcReport = "calcReport",
}

/** BlobRepository enumeration */
export enum BlobRepository {
    UserFiles = "userFiles",
    VersionHistory = "versionHistory",
    SystemFiles = "systemFiles",
    Payload = "payload",
    Reports = "reports",
    CdnImages = "cdnImages",
    Iam = "iam",
    GitContent = "gitContent",
    FileSystemContent = "fileSystemContent",
}

/** BootstrapStyle enumeration */
export enum BootstrapStyle {
    Default = "default",
    Primary = "primary",
    Success = "success",
    Info = "info",
    Warning = "warning",
    Danger = "danger",
}

/** CalcGroup enumeration */
export enum CalcGroup {
    Undefined = "undefined",
    BaseSalary = "baseSalary",
    SalaryAdditions = "salaryAdditions",
    Benefits = "benefits",
    Expenses = "expenses",
    Deductions = "deductions",
    OtherNoPayment = "otherNoPayment",
    Totals = "totals",
    Disabled = "disabled",
}

/** CalculationFlag enumeration */
export enum CalculationFlag {
    Exclude = "exclude",
    PensionInsurance = "pensionInsurance",
    AccidentInsurance = "accidentInsurance",
    UnemploymentInsurance = "unemploymentInsurance",
    HealthInsurance = "healthInsurance",
    InsurancesDeduction = "insurancesDeduction",
    NoTax = "noTax",
    Tax = "tax",
    TaxDeduction = "taxDeduction",
    CfNoPayment = "cfNoPayment",
    CfPayment = "cfPayment",
    CfDeduction = "cfDeduction",
    CfDeductionAtSalaxy = "cfDeductionAtSalaxy",
}

/** CalculationRefresh enumeration */
export enum CalculationRefresh {
    Default = "default",
    Worker = "worker",
    Employer = "employer",
    Employment = "employment",
    Taxcard = "taxcard",
    Insurances = "insurances",
}

/** CalculationResultRowType enumeration */
export enum CalculationResultRowType {
    Undefined = "undefined",
    TotalBenefits = "totalBenefits",
    TotalExpenses = "totalExpenses",
    TotalSocialSecurityEmployer = "totalSocialSecurityEmployer",
    TotalSocialSecurityEmployerDebt = "totalSocialSecurityEmployerDebt",
    TotalSocialSecurityEmployerPayment = "totalSocialSecurityEmployerPayment",
    TotalPension = "totalPension",
    TotalPensionPayment = "totalPensionPayment",
    TotalPensionEmployer = "totalPensionEmployer",
    TotalPensionEmployerDebt = "totalPensionEmployerDebt",
    TotalPensionWorker = "totalPensionWorker",
    TotalUnemployment = "totalUnemployment",
    TotalUnemploymentPayment = "totalUnemploymentPayment",
    TotalUnemploymentEmployer = "totalUnemploymentEmployer",
    TotalUnemploymentEmployerDebt = "totalUnemploymentEmployerDebt",
    TotalUnemploymentWorker = "totalUnemploymentWorker",
    TotalPalkkaus = "totalPalkkaus",
    TotalSalary = "totalSalary",
    TotalTax = "totalTax",
    TotalTaxPayment = "totalTaxPayment",
    TotalPayment = "totalPayment",
    TotalWorkerPayment = "totalWorkerPayment",
    TotalService = "totalService",
}

/** CalculationRowSource enumeration */
export enum CalculationRowSource {
    Undefined = "undefined",
    Disabled = "disabled",
    ManualRow = "manualRow",
    WorktimeImport = "worktimeImport",
    PriceEmployment = "priceEmployment",
    PriceCompany = "priceCompany",
    CustomRowtype = "customRowtype",
}

/** CalculationRowType enumeration */
export enum CalculationRowType {
    Unknown = "unknown",
    Salary = "salary",
    HourlySalary = "hourlySalary",
    MonthlySalary = "monthlySalary",
    TotalWorkerPayment = "totalWorkerPayment",
    TotalEmployerPayment = "totalEmployerPayment",
    Compensation = "compensation",
    Overtime = "overtime",
    TesWorktimeShortening = "tesWorktimeShortening",
    EveningAddition = "eveningAddition",
    NightimeAddition = "nightimeAddition",
    SaturdayAddition = "saturdayAddition",
    SundayWork = "sundayWork",
    OtherAdditions = "otherAdditions",
    PaidSickLeaveSalary = "paidSickLeaveSalary",
    PaidSickLeaveHourlySalary = "paidSickLeaveHourlySalary",
    PaidSickLeaveMonthlySalary = "paidSickLeaveMonthlySalary",
    TrainingSalary = "trainingSalary",
    TrainingHourlySalary = "trainingHourlySalary",
    TrainingMonthlySalary = "trainingMonthlySalary",
    AccomodationBenefit = "accomodationBenefit",
    MealBenefit = "mealBenefit",
    PhoneBenefit = "phoneBenefit",
    CarBenefit = "carBenefit",
    BicycleBenefit = "bicycleBenefit",
    OtherBenefit = "otherBenefit",
    HolidayCompensation = "holidayCompensation",
    HolidayBonus = "holidayBonus",
    HolidaySalary = "holidaySalary",
    DailyAllowance = "dailyAllowance",
    DailyAllowanceHalf = "dailyAllowanceHalf",
    MealCompensation = "mealCompensation",
    MilageOwnCar = "milageOwnCar",
    ToolCompensation = "toolCompensation",
    Expenses = "expenses",
    MilageDaily = "milageDaily",
    MilageOther = "milageOther",
    UnionPayment = "unionPayment",
    Foreclosure = "foreclosure",
    Advance = "advance",
    ForeclosureByPalkkaus = "foreclosureByPalkkaus",
    PrepaidExpenses = "prepaidExpenses",
    OtherDeductions = "otherDeductions",
    DeductibleOfExerciseAndCultureBenefit = "deductibleOfExerciseAndCultureBenefit",
    ChildCareSubsidy = "childCareSubsidy",
    ChainsawReduction = "chainsawReduction",
    NonProfitOrg = "nonProfitOrg",
    SubsidisedCommute = "subsidisedCommute",
    IrIncomeType = "irIncomeType",
    Board = "board",
    Remuneration = "remuneration",
    OtherCompensation = "otherCompensation",
    WorkingTimeCompensation = "workingTimeCompensation",
    EmploymentTermination = "employmentTermination",
    HourlySalaryWithWorkingTimeCompensation = "hourlySalaryWithWorkingTimeCompensation",
    PaidSickLeave = "paidSickLeave",
    Training = "training",
    TaxAtSource = "taxAtSource",
    TaxWithholding = "taxWithholding",
    AbsencePeriod = "absencePeriod",
    ServiceCharge = "serviceCharge",
    Service = "service",
    Totals = "totals",
}

/** CalculationRowUnit enumeration */
export enum CalculationRowUnit {
    Undefined = "undefined",
    Count = "count",
    Percent = "percent",
    Days = "days",
    Kilometers = "kilometers",
    Hours = "hours",
}

/** CalculationStatus enumeration */
export enum CalculationStatus {
    Draft = "draft",
    PaymentStarted = "paymentStarted",
    PaymentSucceeded = "paymentSucceeded",
    PaymentCanceled = "paymentCanceled",
    PaymentError = "paymentError",
    PaymentWorkerCopy = "paymentWorkerCopy",
    WorkerRequested = "workerRequested",
    WorkerRequestAccepted = "workerRequestAccepted",
    WorkerRequestDeclined = "workerRequestDeclined",
    PaymentRefunded = "paymentRefunded",
    WaitingApproval = "waitingApproval",
    PayrollDraft = "payrollDraft",
    ProDraft = "proDraft",
    SharedWaiting = "sharedWaiting",
    SharedApproved = "sharedApproved",
    SharedRejected = "sharedRejected",
    History = "history",
    Template = "template",
}

/** CalculationStatusCategory enumeration */
export enum CalculationStatusCategory {
    All = "all",
    Readonly = "readonly",
    Editable = "editable",
    Sent = "sent",
    Shared = "shared",
    Received = "received",
    Error = "error",
}

/** CalendarActionType enumeration */
export enum CalendarActionType {
    Undefined = "undefined",
    Display = "display",
    Email = "email",
    Audio = "audio",
    CreateItem = "createItem",
    Script = "script",
    PaymentDate = "paymentDate",
}

/** CalendarEventStatus enumeration */
export enum CalendarEventStatus {
    Undefined = "undefined",
    Cancelled = "cancelled",
    Confirmed = "confirmed",
    Tentative = "tentative",
    NeedsAction = "needsAction",
    Completed = "completed",
    InProcess = "inProcess",
}

/** CarBenefitCode enumeration */
export enum CarBenefitCode {
    LimitedCarBenefit = "limitedCarBenefit",
    FullCarBenefit = "fullCarBenefit",
}

/** CompanyType enumeration */
export enum CompanyType {
    Unknown = "unknown",
    FiOy = "fiOy",
    FiTm = "fiTm",
    FiRy = "fiRy",
    FiYy = "fiYy",
}

/** ContractPartyType enumeration */
export enum ContractPartyType {
    Person = "person",
    CustomContact = "customContact",
}

/** ContactType enumeration */
export enum ContactType {
    Default = "default",
    WorkerAccount = "workerAccount",
    EmployerOverride = "employerOverride",
    Foreign = "foreign",
}

/** CostAccountingDimensionScope enumeration */
export enum CostAccountingDimensionScope {
    None = "none",
    Calculation = "calculation",
    Row = "row",
    Hidden = "hidden",
}

/** Country enumeration */
export enum Country {
    Fi = "fi",
    Ae = "ae",
    At = "at",
    Ba = "ba",
    Bg = "bg",
    By = "by",
    Cn = "cn",
    De = "de",
    Eg = "eg",
    Fr = "fr",
    Gg = "gg",
    Hr = "hr",
    Ie = "ie",
    In = "in",
    Je = "je",
    Kr = "kr",
    Lk = "lk",
    Lv = "lv",
    Me = "me",
    Mx = "mx",
    No = "no",
    Pk = "pk",
    Rs = "rs",
    Sg = "sg",
    Th = "th",
    Tr = "tr",
    Us = "us",
    Vg = "vg",
    Zm = "zm",
    Am = "am",
    Au = "au",
    Bb = "bb",
    Bm = "bm",
    Ca = "ca",
    Cy = "cy",
    Dk = "dk",
    Es = "es",
    Gb = "gb",
    Gr = "gr",
    Hu = "hu",
    Il = "il",
    Is = "is",
    Jp = "jp",
    Ky = "ky",
    Lt = "lt",
    Ma = "ma",
    Mk = "mk",
    My = "my",
    Nz = "nz",
    Pl = "pl",
    Ru = "ru",
    Si = "si",
    Tj = "tj",
    Tz = "tz",
    Uy = "uy",
    Vn = "vn",
    Ar = "ar",
    Az = "az",
    Be = "be",
    Br = "br",
    Ch = "ch",
    Cz = "cz",
    Ee = "ee",
    Ge = "ge",
    Hk = "hk",
    Id = "id",
    Im = "im",
    It = "it",
    Kg = "kg",
    Kz = "kz",
    Lu = "lu",
    Md = "md",
    Mt = "mt",
    Nl = "nl",
    Ph = "ph",
    Ro = "ro",
    Se = "se",
    Sk = "sk",
    Tm = "tm",
    Ua = "ua",
    Uz = "uz",
    Za = "za",
    Other = "other",
}

/** CustomerInvoiceStatus enumeration */
export enum CustomerInvoiceStatus {
    Undefined = "undefined",
    Forecast = "forecast",
    Preview = "preview",
    WaitingPalkkaus = "waitingPalkkaus",
    Unread = "unread",
    Read = "read",
    PaymentStarted = "paymentStarted",
    Warning = "warning",
    Paid = "paid",
    Canceled = "canceled",
    Error = "error",
}

/** CustomerWebApp enumeration */
export enum CustomerWebApp {
    Palkkaus = "palkkaus",
    CustomSso = "customSso",
    CustomPalkkaus = "customPalkkaus",
    NoCustomerUi = "noCustomerUi",
}

/** EarningsPaymentReportStatus enumeration */
export enum EarningsPaymentReportStatus {
    New = "new",
    Scheduled = "scheduled",
    Succeeded = "succeeded",
    Canceled = "canceled",
    Error = "error",
    Invalid = "invalid",
}

/** EmploymentRelationSalaryPaymentMethod enumeration */
export enum EmploymentRelationSalaryPaymentMethod {
    BankAccount = "bankAccount",
    External = "external",
}

/** EmploymentRelationStatus enumeration */
export enum EmploymentRelationStatus {
    Unknown = "unknown",
    Primary = "primary",
    SecondaryCurrent = "secondaryCurrent",
    Archived = "archived",
}

/** EmploymentRelationTaxcard enumeration */
export enum EmploymentRelationTaxcard {
    Undefined = "undefined",
    Auto = "auto",
    Manual = "manual",
    NoTaxCard = "noTaxCard",
    TaxAtSource = "taxAtSource",
}

/** EmploymentRelationType enumeration */
export enum EmploymentRelationType {
    Undefined = "undefined",
    Salary = "salary",
    HourlySalary = "hourlySalary",
    MonthlySalary = "monthlySalary",
    Compensation = "compensation",
    BoardMember = "boardMember",
    Entrepreneur = "entrepreneur",
    Farmer = "farmer",
    EmployedByStateEmploymentFund = "employedByStateEmploymentFund",
    Athlete = "athlete",
    PerformingArtist = "performingArtist",
    ForeignWorker = "foreignWorker",
    WorkingAbroad = "workingAbroad",
}

/** ExportMethod enumeration */
export enum ExportMethod {
    Undefined = "undefined",
    FileExcel = "fileExcel",
    FileCsv = "fileCsv",
    FilePdf = "filePdf",
    FileText = "fileText",
    CopyExcel = "copyExcel",
    CopyCsv = "copyCsv",
    CopyText = "copyText",
    PaymentChannel = "paymentChannel",
    Api = "api",
}

/** DatasetStatus enumeration */
export enum DatasetStatus {
    Draft = "draft",
    Instance = "instance",
    Template = "template",
}

/** DatasetType enumeration */
export enum DatasetType {
    Undefined = "undefined",
    ReportAdHoc = "reportAdHoc",
    Import = "import",
    Export = "export",
    Batch = "batch",
}

/** DateOfBirthAccuracy enumeration */
export enum DateOfBirthAccuracy {
    Assumption = "assumption",
    AgeBased = "ageBased",
    AgeGroupBased = "ageGroupBased",
    MonthCorrect = "monthCorrect",
    Exact = "exact",
    Verified = "verified",
}

/** FrameworkAgreement enumeration */
export enum FrameworkAgreement {
    NotDefined = "notDefined",
    Construction = "construction",
    Mll = "mll",
    ChildCare = "childCare",
    Cleaning = "cleaning",
    SantaClaus = "santaClaus",
    Entrepreneur = "entrepreneur",
    Other = "other",
}

/** Gender enumeration */
export enum Gender {
    Unknown = "unknown",
    Male = "male",
    Female = "female",
}

/** HelttiIndustry enumeration */
export enum HelttiIndustry {
    NotDefined = "notDefined",
    I = "i",
    J = "j",
    K = "k",
    M = "m",
    O = "o",
    N = "n",
    P = "p",
    Q = "q",
    R = "r",
    S = "s",
    Other = "other",
}

/** HelttiProductPackage enumeration */
export enum HelttiProductPackage {
    NotDefined = "notDefined",
    Small = "small",
    Medium = "medium",
    Large = "large",
}

/** IncomeEarnerType enumeration */
export enum IncomeEarnerType {
    EmployedByStateEmploymentFund = "employedByStateEmploymentFund",
    JointOwnerWithPayer = "jointOwnerWithPayer",
    PartialOwner = "partialOwner",
    KeyEmployee = "keyEmployee",
    LeasedEmployeeLivingAbroad = "leasedEmployeeLivingAbroad",
    PersonWorkingInFrontierDistrict = "personWorkingInFrontierDistrict",
    PersonWorkingAbroad = "personWorkingAbroad",
    Athlete = "athlete",
    PerformingArtist = "performingArtist",
    RestrictedPeriodInFinland = "restrictedPeriodInFinland",
    NetOfTaxContract = "netOfTaxContract",
    Organization = "organization",
    PersonWorkingOnAlandFerry = "personWorkingOnAlandFerry",
    EntrepreneurOrFarmerNoPensionRequired = "entrepreneurOrFarmerNoPensionRequired",
    DimplomaticMission = "dimplomaticMission",
    Eppo = "eppo",
    LightEntrepreneur = "lightEntrepreneur",
}

/** IncomeLogDiff enumeration */
export enum IncomeLogDiff {
    Default = "default",
    New = "new",
    Changed = "changed",
    Removed = "removed",
}

/** InternationalIdentifier enumeration */
export enum InternationalIdentifier {
    Undefined = "undefined",
    TaxIdentificationNumber = "taxIdentificationNumber",
    ForeignPersonalIdentificationNumber = "foreignPersonalIdentificationNumber",
    Other = "other",
}

/** InvoiceStatus enumeration */
export enum InvoiceStatus {
    Undefined = "undefined",
    Forecast = "forecast",
    Preview = "preview",
    WaitingPalkkaus = "waitingPalkkaus",
    Unread = "unread",
    Read = "read",
    WaitingConfirmation = "waitingConfirmation",
    PaymentStarted = "paymentStarted",
    Warning = "warning",
    Paid = "paid",
    Canceled = "canceled",
    Error = "error",
}

/** InvoiceType enumeration */
export enum InvoiceType {
    Undefined = "undefined",
    Net = "net",
    Tax = "tax",
    TaxWithholding = "taxWithholding",
    TaxSocialSecurity = "taxSocialSecurity",
    TaxAtSource = "taxAtSource",
    Unemployment = "unemployment",
    Pension = "pension",
    Union = "union",
    Foreclosure = "foreclosure",
    Payroll = "payroll",
    Service = "service",
    Fee = "fee",
    Gross = "gross",
    Verification = "verification",
}

/** Holiday enumeration */
export enum Holiday {
    NewYearsDay = "newYearsDay",
    Epiphany = "epiphany",
    GoodFriday = "goodFriday",
    EasterSunday = "easterSunday",
    EasterSaturday = "easterSaturday",
    EasterMonday = "easterMonday",
    MayDay = "mayDay",
    AscensionDay = "ascensionDay",
    Pentecost = "pentecost",
    MidsummerEve = "midsummerEve",
    MidsummerDay = "midsummerDay",
    AllSaintsDay = "allSaintsDay",
    IndependenceDay = "independenceDay",
    ChristmasEve = "christmasEve",
    ChristmasDay = "christmasDay",
    StStephensDay = "stStephensDay",
}

/** HolidayAccrualSource enumeration */
export enum HolidayAccrualSource {
    Initial = "initial",
    Manual = "manual",
    CalcDraft = "calcDraft",
    CalcPaid = "calcPaid",
}

/** HolidayBonusPaymentMethod enumeration */
export enum HolidayBonusPaymentMethod {
    None = "none",
    PayForHolidaySalary = "payForHolidaySalary",
    PaySummerBonus = "paySummerBonus",
    PaySelectedDays = "paySelectedDays",
    Pay24Days = "pay24Days",
    PayAllBonus = "payAllBonus",
}

/** HolidayCode enumeration */
export enum HolidayCode {
    Undefined = "undefined",
    Permanent14Days = "permanent14Days",
    Permanent35Hours = "permanent35Hours",
    TemporaryTimeOff = "temporaryTimeOff",
    HolidayCompensation = "holidayCompensation",
    HolidayCompensationIncluded = "holidayCompensationIncluded",
    NoHolidays = "noHolidays",
}

/** HolidayGroup enumeration */
export enum HolidayGroup {
    Official = "official",
    NonBanking = "nonBanking",
    Holiday = "holiday",
}

/** HolidayPayCalculation enumeration */
export enum HolidayPayCalculation {
    Undefined = "undefined",
    NormalMonthlyPay = "normalMonthlyPay",
    AverageDailyPay = "averageDailyPay",
    PercentageBasedPay = "percentageBasedPay",
    AverageHourlyPay = "averageHourlyPay",
    HolidayCompensation = "holidayCompensation",
    OtherPay = "otherPay",
}

/** HouseholdYearProcessingStatus enumeration */
export enum HouseholdYearProcessingStatus {
    Open = "open",
    Closed = "closed",
    Printed = "printed",
}

/** HouseholdYearStatus enumeration */
export enum HouseholdYearStatus {
    Undefined = "undefined",
    Ok = "ok",
    OkWithModifications = "okWithModifications",
    WillHandleMyself = "willHandleMyself",
}

/** InsuranceCompany enumeration */
export enum InsuranceCompany {
    None = "none",
    LähiTapiola = "lähiTapiola",
    Pohjola = "pohjola",
    If = "if",
    Fennia = "fennia",
    AVakuutus = "aVakuutus",
    Aktia = "aktia",
    Pohjantähti = "pohjantähti",
    Tryg = "tryg",
    Ålands = "ålands",
    Turva = "turva",
    Redarnas = "redarnas",
    Folksam = "folksam",
    Alandia = "alandia",
    Other = "other",
    Pending = "pending",
}

/** InternationalSocialSecurityException enumeration */
export enum InternationalSocialSecurityException {
    NotSubjectToEarningsRelatedPensionInsurance = "notSubjectToEarningsRelatedPensionInsurance",
    NotSubjectToAccidentAndOccupationalDiseaseInsurance = "notSubjectToAccidentAndOccupationalDiseaseInsurance",
    NotSubjectToUnemploymentInsurance = "notSubjectToUnemploymentInsurance",
    NotSubjectToHealthInsurance = "notSubjectToHealthInsurance",
    VoluntaryEarningsRelatedPensionInsurance = "voluntaryEarningsRelatedPensionInsurance",
    NoObligationToHealthInsuranceDailyAllowanceContribution = "noObligationToHealthInsuranceDailyAllowanceContribution",
}

/** InternationalSocialSecurityType enumeration */
export enum InternationalSocialSecurityType {
    Default = "default",
    Foreign = "foreign",
    Mixed = "mixed",
}

/** InvoiceDateKind enumeration */
export enum InvoiceDateKind {
    InvoiceDate = "invoiceDate",
    DueDate = "dueDate",
    LogicalDate = "logicalDate",
}

/** InvoicePaymentType enumeration */
export enum InvoicePaymentType {
    Default = "default",
    Salary = "salary",
    SalaryInPast = "salaryInPast",
}

/** IrFlags enumeration */
export enum IrFlags {
    NoMoney = "noMoney",
    OneOff = "oneOff",
    UnjustEnrichment = "unjustEnrichment",
}

/** IrInsuranceExceptions enumeration */
export enum IrInsuranceExceptions {
    IncludeAll = "includeAll",
    IncludePension = "includePension",
    IncludeHealthInsurance = "includeHealthInsurance",
    IncludeUnemployment = "includeUnemployment",
    IncludeAccidentInsurance = "includeAccidentInsurance",
    ExcludeAll = "excludeAll",
    ExcludePension = "excludePension",
    ExcludeHealthInsurance = "excludeHealthInsurance",
    ExcludeUnemployment = "excludeUnemployment",
    ExcludeAccidentInsurance = "excludeAccidentInsurance",
}

/** IrRowSourceType enumeration */
export enum IrRowSourceType {
    Manual = "manual",
    Usecase = "usecase",
    UsecaseV02 = "usecaseV02",
}

/** Language enumeration */
export enum Language {
    Default = "default",
    Fi = "fi",
    Sv = "sv",
    En = "en",
}

/** LegalEntityType enumeration */
export enum LegalEntityType {
    Undefined = "undefined",
    Person = "person",
    Company = "company",
    PersonCreatedByEmployer = "personCreatedByEmployer",
    Partner = "partner",
}

/** LocalTapiolaInsuranceOrderAuthorizationType enumeration */
export enum LocalTapiolaInsuranceOrderAuthorizationType {
    Procuration = "procuration",
    PowerOfAttorney = "powerOfAttorney",
    ApparentAuthority = "apparentAuthority",
    Other = "other",
}

/** LocalTapiolaInsuranceOrderStatus enumeration */
export enum LocalTapiolaInsuranceOrderStatus {
    Draft = "draft",
    WaitingApproval = "waitingApproval",
    Checked = "checked",
    Sent = "sent",
    Handled = "handled",
    Canceled = "canceled",
}

/** LocalTapiolaInsuranceOrderType enumeration */
export enum LocalTapiolaInsuranceOrderType {
    NewWorkerInsurance = "newWorkerInsurance",
    MoveWorkerInsurance = "moveWorkerInsurance",
    NewEntrepreneurInsurance = "newEntrepreneurInsurance",
    MoveEntrepreneurInsurance = "moveEntrepreneurInsurance",
    Other = "other",
}

/** MessageFrom enumeration */
export enum MessageFrom {
    Undefined = "undefined",
    Owner = "owner",
    OtherParty = "otherParty",
    System = "system",
}

/** MessageThreadStatus enumeration */
export enum MessageThreadStatus {
    Draft = "draft",
    Active = "active",
    Approved = "approved",
    Rejected = "rejected",
    Archived = "archived",
    Template = "template",
}

/** MessageType enumeration */
export enum MessageType {
    Email = "email",
    Sms = "sms",
}

/** OnboardingStatus enumeration */
export enum OnboardingStatus {
    Created = "created",
    Open = "open",
    Error = "error",
    Cancel = "cancel",
    Done = "done",
    Expired = "expired",
}

/** PayerSummaryReportStatus enumeration */
export enum PayerSummaryReportStatus {
    New = "new",
    Scheduled = "scheduled",
    Succeeded = "succeeded",
    Canceled = "canceled",
    Error = "error",
    Invalid = "invalid",
}

/** PaymentChannel enumeration */
export enum PaymentChannel {
    Undefined = "undefined",
    Test = "test",
    ZeroPayment = "zeroPayment",
    External = "external",
    PalkkausManual = "palkkausManual",
    PalkkausWS = "palkkausWS",
    PalkkausPersonal = "palkkausPersonal",
    PalkkausInvoices = "palkkausInvoices",
    PalkkausCfaPaytrail = "palkkausCfaPaytrail",
    PalkkausCfaReference = "palkkausCfaReference",
    PalkkausCfaFinvoice = "palkkausCfaFinvoice",
    PalkkausEcfaPaytrail = "palkkausEcfaPaytrail",
    PalkkausEcfaReference = "palkkausEcfaReference",
    PalkkausEcfaFinvoice = "palkkausEcfaFinvoice",
    PalkkausCfaTest = "palkkausCfaTest",
    AccountorGo = "accountorGo",
    TalenomOnline = "talenomOnline",
    TalenomCfa = "talenomCfa",
    HolviCfa = "holviCfa",
    FinagoSolo = "finagoSolo",
    Procountor = "procountor",
    Kevytyrittaja = "kevytyrittaja",
    VismaNetvisor = "vismaNetvisor",
    Askelma = "askelma",
    Briox = "briox",
    Lemonaid = "lemonaid",
    Laskupiste = "laskupiste",
    Holvi = "holvi",
    Kompassi = "kompassi",
    Domus = "domus",
    PasseliMerit = "passeliMerit",
    Odoo = "odoo",
    Ecom = "ecom",
    Kitsas = "kitsas",
}

/** PaymentMethod enumeration */
export enum PaymentMethod {
    Undefined = "undefined",
    Sepa = "sepa",
    Siirto = "siirto",
    Test = "test",
}

/** PaymentStatus enumeration */
export enum PaymentStatus {
    New = "new",
    SentToBank = "sentToBank",
    BankTechApproval = "bankTechApproval",
    BankDelivered = "bankDelivered",
    BankPartialError = "bankPartialError",
    BankError = "bankError",
    Paid = "paid",
    Unknown = "unknown",
    Cancelled = "cancelled",
}

/** PayrollStatus enumeration */
export enum PayrollStatus {
    Draft = "draft",
    PaymentStarted = "paymentStarted",
    PaymentSucceeded = "paymentSucceeded",
    PaymentCanceled = "paymentCanceled",
    PaymentError = "paymentError",
    WaitingApproval = "waitingApproval",
    Handled = "handled",
    Template = "template",
}

/** PensionCalculation enumeration */
export enum PensionCalculation {
    Undefined = "undefined",
    Employee = "employee",
    Entrepreneur = "entrepreneur",
    Farmer = "farmer",
    PartialOwner = "partialOwner",
    Athlete = "athlete",
    Compensation = "compensation",
    BoardRemuneration = "boardRemuneration",
    SmallEntrepreneur = "smallEntrepreneur",
    SmallFarmer = "smallFarmer",
    PublicSector = "publicSector",
}

/** PensionCompany enumeration */
export enum PensionCompany {
    None = "none",
    Etera = "etera",
    Ilmarinen = "ilmarinen",
    Elo = "elo",
    PensionsAlandia = "pensionsAlandia",
    Varma = "varma",
    Veritas = "veritas",
    Apteekkien = "apteekkien",
    Verso = "verso",
    KevaMunicipal = "kevaMunicipal",
    KevaAland = "kevaAland",
    KevaChurch = "kevaChurch",
    KevaKela = "kevaKela",
    KevaState = "kevaState",
    Valio = "valio",
    Other = "other",
}

/** PensionRule enumeration */
export enum PensionRule {
    Default = "default",
    MonthlyLowerLimit = "monthlyLowerLimit",
}

/** PeriodDateKind enumeration */
export enum PeriodDateKind {
    PaidAtDate = "paidAtDate",
    SalaryDate = "salaryDate",
    WorkDate = "workDate",
    WorkDateStart = "workDateStart",
    WorkDateEnd = "workDateEnd",
}

/** PeriodType enumeration */
export enum PeriodType {
    Month = "month",
    Quarter = "quarter",
    Year = "year",
    Custom = "custom",
}

/** PricingModel enumeration */
export enum PricingModel {
    PalkkausFee = "palkkausFee",
    NoFee = "noFee",
    FixedFee = "fixedFee",
}

/** ProductPackage enumeration */
export enum ProductPackage {
    Default = "default",
    PartnerBasic = "partnerBasic",
    PartnerPro = "partnerPro",
}

/** ProductListFilter enumeration */
export enum ProductListFilter {
    Available = "available",
    All = "all",
}

/** RecurringEventCreateMode enumeration */
export enum RecurringEventCreateMode {
    Default = "default",
    CreateRecurrence = "createRecurrence",
}

/** ReportCategory enumeration */
export enum ReportCategory {
    All = "all",
    Monthly = "monthly",
    Yearly = "yearly",
}

/** ReportType enumeration */
export enum ReportType {
    Undefined = "undefined",
    Example = "example",
    MonthlyDetails = "monthlyDetails",
    TaxMonthly4001 = "taxMonthly4001",
    PayerSummaryReport = "payerSummaryReport",
    MonthlyPension = "monthlyPension",
    MonthlyLiikekirjuri = "monthlyLiikekirjuri",
    MonthlyLiikekirjuriLegacy = "monthlyLiikekirjuriLegacy",
    MonthlyRapko = "monthlyRapko",
    MonthlyAccounting = "monthlyAccounting",
    MonthlyAccountingExcel = "monthlyAccountingExcel",
    YearlyDetails = "yearlyDetails",
    YearEndReport = "yearEndReport",
    YearlyWorkerSummary = "yearlyWorkerSummary",
    TaxYearly7801 = "taxYearly7801",
    Unemployment = "unemployment",
    Insurance = "insurance",
    HouseholdDeduction = "householdDeduction",
    TaxHouseholdDeduction14B = "taxHouseholdDeduction14B",
    TaxHouseholdDeduction14BSpouseA = "taxHouseholdDeduction14BSpouseA",
    TaxHouseholdDeduction14BSpouseB = "taxHouseholdDeduction14BSpouseB",
    SalarySlip = "salarySlip",
    SalarySlipPaid = "salarySlipPaid",
    SalarySlipCopy = "salarySlipCopy",
    ESalarySpecification = "eSalarySpecification",
    EmployerReport = "employerReport",
    PaymentReport = "paymentReport",
    PaymentSummaryReport = "paymentSummaryReport",
    TotalsReport = "totalsReport",
    EarningsPaymentReport = "earningsPaymentReport",
    AccountingReport = "accountingReport",
    Invoice = "invoice",
    InvoiceList = "invoiceList",
    EmploymentContract = "employmentContract",
    Authorization = "authorization",
}

/** Role enumeration */
export enum Role {
    Undefined = "undefined",
    Accountant = "accountant",
    TrustedPartner = "trustedPartner",
    AccountantCandidate = "accountantCandidate",
    PricingPartner = "pricingPartner",
    SepaPartner = "sepaPartner",
}

/** SalaryDateKind enumeration */
export enum SalaryDateKind {
    Default = "default",
    InPast = "inPast",
}

/** SalaryKind enumeration */
export enum SalaryKind {
    Undefined = "undefined",
    FixedSalary = "fixedSalary",
    HourlySalary = "hourlySalary",
    MonthlySalary = "monthlySalary",
    Compensation = "compensation",
    TotalWorkerPayment = "totalWorkerPayment",
    TotalEmployerPayment = "totalEmployerPayment",
}

/** SalaryType enumeration */
export enum SalaryType {
    Tyel = "tyel",
    Yel = "yel",
    Compensation = "compensation",
}

/** LegacyServiceModel enumeration */
export enum LegacyServiceModel {
    Shared = "shared",
    PartnerOnly = "partnerOnly",
}

/** SettingsStatus enumeration */
export enum SettingsStatus {
    Undefined = "undefined",
    Checked = "checked",
    Pending = "pending",
}

/** SharingUriType enumeration */
export enum SharingUriType {
    Undefined = "undefined",
    Url = "url",
    Employer = "employer",
}

/** TaxcardApiIncomeType enumeration */
export enum TaxcardApiIncomeType {
    Undefined = "undefined",
    Salary = "salary",
    DividendsForWorkAsSalary = "dividendsForWorkAsSalary",
    PersonnelFundIncome = "personnelFundIncome",
    SalaryOneOff = "salaryOneOff",
    CompensationForUseEarnedIncome = "compensationForUseEarnedIncome",
    CompensationForUseCapitalIncome = "compensationForUseCapitalIncome",
    CompensationVatResponsible = "compensationVatResponsible",
    Compensation = "compensation",
    DividendsForWorkAsCompensation = "dividendsForWorkAsCompensation",
    AthletePay = "athletePay",
    OtherTaxableIncome = "otherTaxableIncome",
    OtherTaxableIncomeOneOff = "otherTaxableIncomeOneOff",
    EmployeeStockOption = "employeeStockOption",
}

/** TaxcardApprovalMethod enumeration */
export enum TaxcardApprovalMethod {
    AssureWaiting = "assureWaiting",
    Approve = "approve",
    Reject = "reject",
}

/** TaxcardCalcDiffCheck enumeration */
export enum TaxcardCalcDiffCheck {
    GetDiff = "getDiff",
    NoCheck = "noCheck",
    CommitDiff = "commitDiff",
}

/** TaxCardIncomeType enumeration */
export enum TaxCardIncomeType {
    Unknown = "unknown",
    SalaxyCalculation = "salaxyCalculation",
    PreviousEmployerSalaries = "previousEmployerSalaries",
    ExternalSalaries = "externalSalaries",
    SharedCardExtSum = "sharedCardExtSum",
    Diff = "diff",
}

/** TaxcardState enumeration */
export enum TaxcardState {
    New = "new",
    Approved = "approved",
    EmployerAdded = "employerAdded",
    VerifiedVero = "verifiedVero",
    SharedWaiting = "sharedWaiting",
    SharedApproved = "sharedApproved",
    SharedRejected = "sharedRejected",
    SharedRejectedWithoutOpen = "sharedRejectedWithoutOpen",
    Shared = "shared",
}

/** TaxcardKind enumeration */
export enum TaxcardKind {
    Undefined = "undefined",
    NoTaxCard = "noTaxCard",
    Auto = "auto",
    DefaultYearly = "defaultYearly",
    Replacement = "replacement",
    NoWithholdingHousehold = "noWithholdingHousehold",
    Others = "others",
    Historical = "historical",
}

/** TaxcardValidity enumeration */
export enum TaxcardValidity {
    Undefined = "undefined",
    Valid = "valid",
    ValidJanuary = "validJanuary",
    Future = "future",
    Expired = "expired",
}

/** TaxAtSourceKind enumeration */
export enum TaxAtSourceKind {
    Undefined = "undefined",
    NoDeduction = "noDeduction",
    MonthlyDeduction = "monthlyDeduction",
    DailyDeduction = "dailyDeduction",
    FixedValues = "fixedValues",
}

/** TaxDeductionWorkCategories enumeration */
export enum TaxDeductionWorkCategories {
    None = "none",
    Householdwork = "householdwork",
    Carework = "carework",
    HomeImprovement = "homeImprovement",
    OwnPropety = "ownPropety",
    RelativesProperty = "relativesProperty",
    OilHeatingReplacementWork = "oilHeatingReplacementWork",
}

/** TaxReportHandling enumeration */
export enum TaxReportHandling {
    Default = "default",
    NoZeroSalaryReport = "noZeroSalaryReport",
    NoMonthlyReport = "noMonthlyReport",
    Always = "always",
}

/** TaxWithholdingKind enumeration */
export enum TaxWithholdingKind {
    Undefined = "undefined",
    Percentage = "percentage",
    FixedValue = "fixedValue",
}

/** TesSubtype enumeration */
export enum TesSubtype {
    NotSelected = "notSelected",
    ConstructionCarpenter = "constructionCarpenter",
    ConstructionFloor = "constructionFloor",
    ConstructionOther = "constructionOther",
    ConstructionFreeContract = "constructionFreeContract",
}

/** TestEnum enumeration */
export enum TestEnum {
    ValueZero = "valueZero",
    ValueOne = "valueOne",
    ValueTwo = "valueTwo",
    ValueThree = "valueThree",
    ValueFour = "valueFour",
    ValueFive = "valueFive",
    ValueSix = "valueSix",
    ValueSeven = "valueSeven",
    ValueEight = "valueEight",
    ValueNine = "valueNine",
    ValueTen = "valueTen",
}

/** ThreadedMessageType enumeration */
export enum ThreadedMessageType {
    Text = "text",
    BlobFile = "blobFile",
    Calculation = "calculation",
    Payroll = "payroll",
    WorkerAccount = "workerAccount",
    Email = "email",
    SalaxyEmail = "salaxyEmail",
    Sms = "sms",
    SalaxySms = "salaxySms",
    Timer = "timer",
    TimerEdited = "timerEdited",
    HourlyReport = "hourlyReport",
    TimeReport = "timeReport",
    Absence = "absence",
    AnnualLeave = "annualLeave",
    CalcRow = "calcRow",
    Travel = "travel",
    Expense = "expense",
}

/** UnemploymentPayrollLimitStatus enumeration */
export enum UnemploymentPayrollLimitStatus {
    Default = "default",
    Higher = "higher",
}

/** UnionPaymentType enumeration */
export enum UnionPaymentType {
    NotSelected = "notSelected",
    RaksaNormal = "raksaNormal",
    RaksaUnemploymentOnly = "raksaUnemploymentOnly",
    Other = "other",
}

/** Unit enumeration */
export enum Unit {
    Undefined = "undefined",
    Hours = "hours",
    Days = "days",
    Weeks = "weeks",
    Period = "period",
    One = "one",
    Count = "count",
    Percent = "percent",
    Kilometers = "kilometers",
    Euro = "euro",
}

/** UsecaseActionType enumeration */
export enum UsecaseActionType {
    ClientScript = "clientScript",
    ClientScriptAsync = "clientScriptAsync",
    ServerScript = "serverScript",
    ServerScriptAsync = "serverScriptAsync",
    WebServiceCall = "webServiceCall",
    PowerAutomateFlow = "powerAutomateFlow",
}

/** UsecaseStatus enumeration */
export enum UsecaseStatus {
    Undefined = "undefined",
    Active = "active",
    Default = "default",
    Inactive = "inactive",
}

/** VarmaPensionOrderAction enumeration */
export enum VarmaPensionOrderAction {
    Undefined = "undefined",
    NewYel = "newYel",
    NewTyel = "newTyel",
    Move = "move",
}

/** VarmaPensionOrderYelPayer enumeration */
export enum VarmaPensionOrderYelPayer {
    Undefined = "undefined",
    Entrepreneur = "entrepreneur",
    Company = "company",
}

/** VatRate enumeration */
export enum VatRate {
    Undefined = "undefined",
    None = "none",
    Vat0000 = "vat0000",
    Vat1000 = "vat1000",
    Vat1400 = "vat1400",
    Vat2400 = "vat2400",
    Vat2550 = "vat2550",
    Other = "other",
}

/** WageBasis enumeration */
export enum WageBasis {
    Undefined = "undefined",
    Monthly = "monthly",
    Hourly = "hourly",
    PerformanceBased = "performanceBased",
    Other = "other",
}

/** WebSiteUserRole enumeration */
export enum WebSiteUserRole {
    None = "none",
    Household = "household",
    Worker = "worker",
    Company = "company",
}

/** WorkerSalaryNotification enumeration */
export enum WorkerSalaryNotification {
    Always = "always",
    Silent = "silent",
}

/** WorkerSalarySlipDeliveryMethod enumeration */
export enum WorkerSalarySlipDeliveryMethod {
    Default = "default",
    Payslip = "payslip",
    Omapalkka = "omapalkka",
}

/** WorkflowEventFeatures enumeration */
export enum WorkflowEventFeatures {
    None = "none",
    IsActive = "isActive",
    IsEditable = "isEditable",
    IsRemovable = "isRemovable",
    IsOnHold = "isOnHold",
}

/** YearEndAdminCheck enumeration */
export enum YearEndAdminCheck {
    NotChecked = "notChecked",
    Ok = "ok",
    OkWithWarning = "okWithWarning",
    Errors = "errors",
}

/** YearEndFeedbackCalculationType enumeration */
export enum YearEndFeedbackCalculationType {
    Unknown = "unknown",
    SalaxyPayment = "salaxyPayment",
    External = "external",
    Correction = "correction",
}

/** YearEndUserFeedback enumeration */
export enum YearEndUserFeedback {
    NotChecked = "notChecked",
    Ok = "ok",
    OkWithModifications = "okWithModifications",
    WillHandleMyself = "willHandleMyself",
    NoYearlyReports = "noYearlyReports",
}

/** YtjCompanyType enumeration */
export enum YtjCompanyType {
    NoCompanyType = "noCompanyType",
    HousingCooperative = "housingCooperative",
    Condominium = "condominium",
    AsoAssociation = "asoAssociation",
    OpenCompany = "openCompany",
    Association = "association",
    HypoAssociation = "hypoAssociation",
    MutualRealEstateCompany = "mutualRealEstateCompany",
    Ky = "ky",
    Osuuskunta = "osuuskunta",
    CooperativeBank = "cooperativeBank",
    Oy = "oy",
    PublicLimitedCompany = "publicLimitedCompany",
    Foundation = "foundation",
    Branch = "branch",
    SavingsBank = "savingsBank",
    FinancialAssociation = "financialAssociation",
    StateEstablishment = "stateEstablishment",
    InsuranceAssociation = "insuranceAssociation",
    PrivateEntrepreneur = "privateEntrepreneur",
    OtherAssociation = "otherAssociation",
    SpecialPurposeAssociation = "specialPurposeAssociation",
    ForestCareAssociation = "forestCareAssociation",
    OtherFinancialAssociation = "otherFinancialAssociation",
    ReligiousCommunity = "religiousCommunity",
    JointInterestGroups = "jointInterestGroups",
    TaxableGrouping = "taxableGrouping",
    DeathEstate = "deathEstate",
    MutualInsuranceAssociation = "mutualInsuranceAssociation",
    ForeignOrganisation = "foreignOrganisation",
    MunicipalEstablishment = "municipalEstablishment",
    FederationOfMunicipalitiesEstablishment = "federationOfMunicipalitiesEstablishment",
    AlandFederation = "alandFederation",
    EuropeanCooperative = "europeanCooperative",
    EuropeanCooperativeBank = "europeanCooperativeBank",
    ReindeerHerdingCooperative = "reindeerHerdingCooperative",
    Unknown = "unknown",
}

/** CarBenefitKind enumeration */
export enum CarBenefitKind {
    Undefined = "undefined",
    LimitedCarBenefit = "limitedCarBenefit",
    FullCarBenefit = "fullCarBenefit",
}

/** BicycleBenefitKind enumeration */
export enum BicycleBenefitKind {
    Undefined = "undefined",
    NoDeduction = "noDeduction",
    SingleDeduction = "singleDeduction",
    PeriodicalDeduction = "periodicalDeduction",
}

/** UnionPaymentKind enumeration */
export enum UnionPaymentKind {
    Undefined = "undefined",
    Fixed = "fixed",
    Percentage = "percentage",
    PercentageAndLimits = "percentageAndLimits",
    RaksaNormal = "raksaNormal",
    RaksaUnemploymentOnly = "raksaUnemploymentOnly",
    Other = "other",
}

/** NonProfitOrgKind enumeration */
export enum NonProfitOrgKind {
    Undefined = "undefined",
    KilometreAllowance = "kilometreAllowance",
    DailyAllowance = "dailyAllowance",
    AccomodationAllowance = "accomodationAllowance",
}

/** SubsidisedCommuteKind enumeration */
export enum SubsidisedCommuteKind {
    Undefined = "undefined",
    NoDeduction = "noDeduction",
    SingleDeduction = "singleDeduction",
    PeriodicalDeduction = "periodicalDeduction",
}

/** MealBenefitKind enumeration */
export enum MealBenefitKind {
    Undefined = "undefined",
    CateringContract = "cateringContract",
    MealTicket = "mealTicket",
    TaxableAmount = "taxableAmount",
    MealAllowance = "mealAllowance",
    Institute = "institute",
    Teacher = "teacher",
    RestaurantWorker = "restaurantWorker",
    CollectedReimbursement = "collectedReimbursement",
}

/** DailyAllowanceKind enumeration */
export enum DailyAllowanceKind {
    Undefined = "undefined",
    FullDailyAllowance = "fullDailyAllowance",
    PartialDailyAllowance = "partialDailyAllowance",
    InternationalDailyAllowance = "internationalDailyAllowance",
    MealAllowance = "mealAllowance",
}

/** BoardKind enumeration */
export enum BoardKind {
    Undefined = "undefined",
}

/** RemunerationKind enumeration */
export enum RemunerationKind {
    Undefined = "undefined",
    InitiativeFee = "initiativeFee",
    BonusPay = "bonusPay",
    Commission = "commission",
    PerformanceBonus = "performanceBonus",
    ShareIssueForEmployees = "shareIssueForEmployees",
    ProfitSharingBonus = "profitSharingBonus",
}

/** OtherCompensationKind enumeration */
export enum OtherCompensationKind {
    Undefined = "undefined",
    MeetingFee = "meetingFee",
    LectureFee = "lectureFee",
    PositionOfTrustCompensation = "positionOfTrustCompensation",
    AccruedTimeOffCompensation = "accruedTimeOffCompensation",
    MembershipOfGoverningBodyCompensation = "membershipOfGoverningBodyCompensation",
    MonetaryGiftForEmployees = "monetaryGiftForEmployees",
    UseCompensationAsEarnedIncome = "useCompensationAsEarnedIncome",
    UseCompensationAsCapitalIncome = "useCompensationAsCapitalIncome",
    OtherTaxableIncomeAsEarnedIncome = "otherTaxableIncomeAsEarnedIncome",
    StockOptionsAndGrants = "stockOptionsAndGrants",
    EmployeeInventionCompensation = "employeeInventionCompensation",
    CapitalIncomePayment = "capitalIncomePayment",
    WorkEffortBasedDividendsAsWage = "workEffortBasedDividendsAsWage",
    WorkEffortBasedDividendsAsNonWage = "workEffortBasedDividendsAsNonWage",
    EmployeeStockOption = "employeeStockOption",
    EmployeeStockOptionWithLowerPrice = "employeeStockOptionWithLowerPrice",
    CopyrightRoyaltiesEarnedIncome = "copyrightRoyaltiesEarnedIncome",
    StockGrantPaidInMoney = "stockGrantPaidInMoney",
    EmployeeStockOptionPaidInMoney = "employeeStockOptionPaidInMoney",
}

/** PaidSickLeaveKind enumeration */
export enum PaidSickLeaveKind {
    Undefined = "undefined",
    PaidSickLeaveSalary = "paidSickLeaveSalary",
    PaidSickLeaveHourlySalary = "paidSickLeaveHourlySalary",
    PaidSickLeaveMonthlySalary = "paidSickLeaveMonthlySalary",
}

/** WorkingTimeCompensationKind enumeration */
export enum WorkingTimeCompensationKind {
    Undefined = "undefined",
    EmergencyWorkCompensation = "emergencyWorkCompensation",
    EveningWorkCompensation = "eveningWorkCompensation",
    EveningShiftAllowance = "eveningShiftAllowance",
    SaturdayPay = "saturdayPay",
    ExtraWorkPremium = "extraWorkPremium",
    OtherCompensation = "otherCompensation",
    WaitingTimeCompensation = "waitingTimeCompensation",
    SundayWorkCompensation = "sundayWorkCompensation",
    StandByCompensation = "standByCompensation",
    WeeklyRestCompensation = "weeklyRestCompensation",
    OvertimeCompensation = "overtimeCompensation",
    NightWorkAllowance = "nightWorkAllowance",
    NightShiftCompensation = "nightShiftCompensation",
}

/** WorkingTimeCompensationPricing enumeration */
export enum WorkingTimeCompensationPricing {
    Undefined = "undefined",
    Percent = "percent",
    Fixed = "fixed",
}

/** EmploymentTerminationKind enumeration */
export enum EmploymentTerminationKind {
    Undefined = "undefined",
    NoticePeriodCompensation = "noticePeriodCompensation",
    MonetaryWorkingTimeBankCompensation = "monetaryWorkingTimeBankCompensation",
    TerminationAndLayOffDamages = "terminationAndLayOffDamages",
    VoluntaryTerminationCompensation = "voluntaryTerminationCompensation",
    PensionPaidByEmployer = "pensionPaidByEmployer",
}

/** ForeclosureKind enumeration */
export enum ForeclosureKind {
    Undefined = "undefined",
    Fixed = "fixed",
    Periodic = "periodic",
    NonPeriodic = "nonPeriodic",
}

/** TotalWorkerPaymentKind enumeration */
export enum TotalWorkerPaymentKind {
    Undefined = "undefined",
    TotalWorkerPayment = "totalWorkerPayment",
    TotalWorkerWorkerPaymentExcludingExpenses = "totalWorkerWorkerPaymentExcludingExpenses",
    TotalWorkerPaymentAndTax = "totalWorkerPaymentAndTax",
    TotalWorkerWorkerPaymentAndTaxExcludingExpenses = "totalWorkerWorkerPaymentAndTaxExcludingExpenses",
}

/** TransactionCode enumeration */
export enum TransactionCode {
    Unknown = "unknown",
    Ignored = "ignored",
    TimeRatePay = "timeRatePay",
    InitiativeFee = "initiativeFee",
    BonusPay = "bonusPay",
    ComplementaryWagePaidDuringBenefitPeriod = "complementaryWagePaidDuringBenefitPeriod",
    EmergencyWorkCompensation = "emergencyWorkCompensation",
    EveningWorkCompensation = "eveningWorkCompensation",
    EveningShiftAllowance = "eveningShiftAllowance",
    NoticePeriodCompensation = "noticePeriodCompensation",
    KilometreAllowanceTaxable = "kilometreAllowanceTaxable",
    MeetingFee = "meetingFee",
    SaturdayPay = "saturdayPay",
    ExtraWorkPremium = "extraWorkPremium",
    HolidayBonus = "holidayBonus",
    LectureFee = "lectureFee",
    CompensationForTrustPosition = "compensationForTrustPosition",
    OtherCompensation = "otherCompensation",
    WaitingTimeCompensation = "waitingTimeCompensation",
    WorkingConditionCompensation = "workingConditionCompensation",
    PartialPayDuringSickLeave = "partialPayDuringSickLeave",
    Commission = "commission",
    SundayWorkCompensation = "sundayWorkCompensation",
    BenefitArisingFromSyntheticOption = "benefitArisingFromSyntheticOption",
    PerformanceBonus = "performanceBonus",
    MonetaryCompensationFromWorkingTimeBank = "monetaryCompensationFromWorkingTimeBank",
    CompensationForAccruedTimeOff = "compensationForAccruedTimeOff",
    ShareIssueForEmployees = "shareIssueForEmployees",
    ContractPay = "contractPay",
    DamagesInConjunctionWithTermination = "damagesInConjunctionWithTermination",
    StandByCompensation = "standByCompensation",
    VoluntaryCompensationInConjunctionWithTermination = "voluntaryCompensationInConjunctionWithTermination",
    WeeklyRestCompensation = "weeklyRestCompensation",
    ProfitSharingBonus = "profitSharingBonus",
    AnnualHolidayCompensation = "annualHolidayCompensation",
    OvertimeCompensation = "overtimeCompensation",
    NightWorkAllowance = "nightWorkAllowance",
    NightShiftCompensation = "nightShiftCompensation",
    OtherRegularCompensation = "otherRegularCompensation",
    CompensationForUnusedCompensatoryLeave = "compensationForUnusedCompensatoryLeave",
    AccommodationBenefit = "accommodationBenefit",
    InterestBenefitForHousingLoan = "interestBenefitForHousingLoan",
    MealAllowance = "mealAllowance",
    CarBenefit = "carBenefit",
    CompensationForGoverningBodyMembership = "compensationForGoverningBodyMembership",
    ShareOfReserveDrawnFromPersonnelFund = "shareOfReserveDrawnFromPersonnelFund",
    MonetaryGiftForEmployees = "monetaryGiftForEmployees",
    KilometreAllowanceTaxExempt = "kilometreAllowanceTaxExempt",
    TreatmentFeeForMunicipalVeterinarian = "treatmentFeeForMunicipalVeterinarian",
    CompensationForUseEarnedIncome = "compensationForUseEarnedIncome",
    CompensationForUseCapitalIncome = "compensationForUseCapitalIncome",
    OtherTaxableBenefitForEmployees = "otherTaxableBenefitForEmployees",
    OtherTaxableIncomeDeemedEarnedIncome = "otherTaxableIncomeDeemedEarnedIncome",
    OtherFringeBenefit = "otherFringeBenefit",
    KinshipCarersFee = "kinshipCarersFee",
    StockOptions = "stockOptions",
    WagesPaidBySubstitutePayerIncludingSocialInsurance = "wagesPaidBySubstitutePayerIncludingSocialInsurance",
    WagesPaidBySubstitutePayerIncludingEarningsRelatedPensionInsurance = "wagesPaidBySubstitutePayerIncludingEarningsRelatedPensionInsurance",
    WagesPaidBySubstitutePayerIncludingUnemploymentInsurance = "wagesPaidBySubstitutePayerIncludingUnemploymentInsurance",
    WagesPaidBySubstitutePayerIncludingAccidentAndOccupationalDiseaseInsurance = "wagesPaidBySubstitutePayerIncludingAccidentAndOccupationalDiseaseInsurance",
    WagesPaidBySubstitutePayerIncludingHealthInsurance = "wagesPaidBySubstitutePayerIncludingHealthInsurance",
    CompensationForEmployeeInvention = "compensationForEmployeeInvention",
    ReimbursementOfPrivateCaretakersExpenses = "reimbursementOfPrivateCaretakersExpenses",
    PrivateCaretakersFee = "privateCaretakersFee",
    ReimbursementOfFamilyDayCareProvidersExpenses = "reimbursementOfFamilyDayCareProvidersExpenses",
    TelephoneBenefit = "telephoneBenefit",
    DailyAllowance = "dailyAllowance",
    CapitalIncomePayment = "capitalIncomePayment",
    MealBenefit = "mealBenefit",
    ReimbursementOfCostsPaidToConciliator = "reimbursementOfCostsPaidToConciliator",
    NonWageCompensationForWork = "nonWageCompensationForWork",
    SupplementaryDailyAllowancePaidByEmployerSpecificHealthInsuranceFund = "supplementaryDailyAllowancePaidByEmployerSpecificHealthInsuranceFund",
    PensionPaidByEmployer = "pensionPaidByEmployer",
    DividendsBasedOnWages = "dividendsBasedOnWages",
    DividendsBasedOnNonWage = "dividendsBasedOnNonWage",
    EmployerSubsidisedCommuterTicketTaxExempt = "employerSubsidisedCommuterTicketTaxExempt",
    EmployerSubsidisedCommuterTicketTaxable = "employerSubsidisedCommuterTicketTaxable",
    EmployeeStockOption = "employeeStockOption",
    WagesTransferredToAthletesSpecialFund = "wagesTransferredToAthletesSpecialFund",
    WagesPaidFromAthletesSpecialFund = "wagesPaidFromAthletesSpecialFund",
    WagesForInsurancePurposes = "wagesForInsurancePurposes",
    TaxableReimbursementOfExpenses = "taxableReimbursementOfExpenses",
    PrivateDayCareAllowanceMunicipalSupplement = "privateDayCareAllowanceMunicipalSupplement",
    PrivateDayCareAllowanceWages = "privateDayCareAllowanceWages",
    PrivateDayCareAllowanceNonWage = "privateDayCareAllowanceNonWage",
    KilometreAllowancePaidByNonProfitOrganisation = "kilometreAllowancePaidByNonProfitOrganisation",
    DailyAllowancePaidByNonProfitOrganisation = "dailyAllowancePaidByNonProfitOrganisation",
    UnjustEnrichment = "unjustEnrichment",
    EmployeeStockOptionLowerMarketPrice = "employeeStockOptionLowerMarketPrice",
    RoyaltyPaidToNonResidentTaxpayer = "royaltyPaidToNonResidentTaxpayer",
    BicycleBenefitTaxExempt = "bicycleBenefitTaxExempt",
    BicycleBenefitTaxable = "bicycleBenefitTaxable",
    ConditionalStockOptions = "conditionalStockOptions",
    CopyrightRoyaltiesEarnedIncome = "copyrightRoyaltiesEarnedIncome",
    StockGrantPaidInMoney = "stockGrantPaidInMoney",
    EmployeeStockOptionPaidInMoney = "employeeStockOptionPaidInMoney",
    EarningsFromJuELEmployerToLightEntrepreneur = "earningsFromJuELEmployerToLightEntrepreneur",
    CompensationCollectedForCarBenefit = "compensationCollectedForCarBenefit",
    WithholdingTax = "withholdingTax",
    ElectedOfficialFee = "electedOfficialFee",
    TaxAtSource = "taxAtSource",
    TaxAtSourceDeduction = "taxAtSourceDeduction",
    WagesPaid = "wagesPaid",
    ReimbursementCollectedForOtherFringeBenefits = "reimbursementCollectedForOtherFringeBenefits",
    OtherItemDeductibleFromNetWage = "otherItemDeductibleFromNetWage",
    NetWage = "netWage",
    EmployerPaidPremiumForCollectiveAdditionalPensionInsurance = "employerPaidPremiumForCollectiveAdditionalPensionInsurance",
    EmployerPaidPremiumForCollectiveAdditionalPensionInsuranceEmployeesContribution = "employerPaidPremiumForCollectiveAdditionalPensionInsuranceEmployeesContribution",
    EmployeesHealthInsuranceContribution = "employeesHealthInsuranceContribution",
    EmployeesPensionInsuranceContribution = "employeesPensionInsuranceContribution",
    EmployeesUnemploymentInsuranceContribution = "employeesUnemploymentInsuranceContribution",
    ReimbursementForEmployerSubsidisedCommuterTicket = "reimbursementForEmployerSubsidisedCommuterTicket",
    TaxPaidAbroad = "taxPaidAbroad",
    Distraint = "distraint",
    VoluntaryIndividualPensionInsurancePremium = "voluntaryIndividualPensionInsurancePremium",
    DeductionBeforeWithholding = "deductionBeforeWithholding",
    ReimbursementCollectedForBicycleBenefit = "reimbursementCollectedForBicycleBenefit",
}

/** TrainingKind enumeration */
export enum TrainingKind {
    Undefined = "undefined",
    TrainingSalary = "trainingSalary",
    TrainingHourlySalary = "trainingHourlySalary",
    TrainingMonthlySalary = "trainingMonthlySalary",
}

export interface Holidays {
    newYearsDay?: HolidayDate | null;
    epiphany?: HolidayDate | null;
    goodFriday?: HolidayDate | null;
    easterSunday?: HolidayDate | null;
    easterSaturday?: HolidayDate | null;
    easterMonday?: HolidayDate | null;
    mayDay?: HolidayDate | null;
    ascensionDay?: HolidayDate | null;
    pentecost?: HolidayDate | null;
    midsummerEve?: HolidayDate | null;
    midsummerDay?: HolidayDate | null;
    allSaintsDay?: HolidayDate | null;
    independenceDay?: HolidayDate | null;
    christmasEve?: HolidayDate | null;
    christmasDay?: HolidayDate | null;
    stStephensDay?: HolidayDate | null;
}

export interface holidays {
    newYearsDay?: HolidayDate | null;
    epiphany?: HolidayDate | null;
    goodFriday?: HolidayDate | null;
    easterSunday?: HolidayDate | null;
    easterSaturday?: HolidayDate | null;
    easterMonday?: HolidayDate | null;
    mayDay?: HolidayDate | null;
    ascensionDay?: HolidayDate | null;
    pentecost?: HolidayDate | null;
    midsummerEve?: HolidayDate | null;
    midsummerDay?: HolidayDate | null;
    allSaintsDay?: HolidayDate | null;
    independenceDay?: HolidayDate | null;
    christmasEve?: HolidayDate | null;
    christmasDay?: HolidayDate | null;
    stStephensDay?: HolidayDate | null;
}

export enum UserInfoApplicationRole {
    Unknown = "unknown",
    NoAccess = "noAccess",
    ReadOnly = "readOnly",
    ReadWrite = "readWrite",
    Owner = "owner",
}

export interface FileParameter {
    data: any;
    fileName: string;
}